/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.quack = (function() {

    /**
     * Namespace quack.
     * @exports quack
     * @namespace
     */
    var quack = {};

    quack.Unknown = (function() {

        /**
         * Properties of an Unknown.
         * @memberof quack
         * @interface IUnknown
         * @property {number|null} [firmwareVersion] Unknown firmwareVersion
         */

        /**
         * Constructs a new Unknown.
         * @memberof quack
         * @classdesc Represents an Unknown.
         * @implements IUnknown
         * @constructor
         * @param {quack.IUnknown=} [properties] Properties to set
         */
        function Unknown(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Unknown firmwareVersion.
         * @member {number} firmwareVersion
         * @memberof quack.Unknown
         * @instance
         */
        Unknown.prototype.firmwareVersion = 0;

        /**
         * Creates a new Unknown instance using the specified properties.
         * @function create
         * @memberof quack.Unknown
         * @static
         * @param {quack.IUnknown=} [properties] Properties to set
         * @returns {quack.Unknown} Unknown instance
         */
        Unknown.create = function create(properties) {
            return new Unknown(properties);
        };

        /**
         * Creates an Unknown message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Unknown
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Unknown} Unknown
         */
        Unknown.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Unknown)
                return object;
            var message = new $root.quack.Unknown();
            if (object.firmwareVersion != null)
                message.firmwareVersion = object.firmwareVersion | 0;
            return message;
        };

        /**
         * Creates a plain object from an Unknown message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Unknown
         * @static
         * @param {quack.Unknown} message Unknown
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Unknown.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.firmwareVersion = 0;
            if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                object.firmwareVersion = message.firmwareVersion;
            return object;
        };

        /**
         * Converts this Unknown to JSON.
         * @function toJSON
         * @memberof quack.Unknown
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Unknown.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Unknown;
    })();

    /**
     * ResponseCode enum.
     * @name quack.ResponseCode
     * @enum {string}
     * @property {number} RESPONSE_CODE_INVALID=0 RESPONSE_CODE_INVALID value
     * @property {number} RESPONSE_CODE_ACKNOWLEDGE=1 RESPONSE_CODE_ACKNOWLEDGE value
     * @property {number} RESPONSE_CODE_ERROR=2 RESPONSE_CODE_ERROR value
     */
    quack.ResponseCode = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RESPONSE_CODE_INVALID"] = 0;
        values[valuesById[1] = "RESPONSE_CODE_ACKNOWLEDGE"] = 1;
        values[valuesById[2] = "RESPONSE_CODE_ERROR"] = 2;
        return values;
    })();

    quack.Ack = (function() {

        /**
         * Properties of an Ack.
         * @memberof quack
         * @interface IAck
         * @property {number|null} [unixTime] Ack unixTime
         */

        /**
         * Constructs a new Ack.
         * @memberof quack
         * @classdesc Represents an Ack.
         * @implements IAck
         * @constructor
         * @param {quack.IAck=} [properties] Properties to set
         */
        function Ack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Ack unixTime.
         * @member {number} unixTime
         * @memberof quack.Ack
         * @instance
         */
        Ack.prototype.unixTime = 0;

        /**
         * Creates a new Ack instance using the specified properties.
         * @function create
         * @memberof quack.Ack
         * @static
         * @param {quack.IAck=} [properties] Properties to set
         * @returns {quack.Ack} Ack instance
         */
        Ack.create = function create(properties) {
            return new Ack(properties);
        };

        /**
         * Creates an Ack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Ack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Ack} Ack
         */
        Ack.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Ack)
                return object;
            var message = new $root.quack.Ack();
            if (object.unixTime != null)
                message.unixTime = object.unixTime >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an Ack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Ack
         * @static
         * @param {quack.Ack} message Ack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Ack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.unixTime = 0;
            if (message.unixTime != null && message.hasOwnProperty("unixTime"))
                object.unixTime = message.unixTime;
            return object;
        };

        /**
         * Converts this Ack to JSON.
         * @function toJSON
         * @memberof quack.Ack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Ack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Ack;
    })();

    quack.Nack = (function() {

        /**
         * Properties of a Nack.
         * @memberof quack
         * @interface INack
         * @property {string|null} [errorMessage] Nack errorMessage
         */

        /**
         * Constructs a new Nack.
         * @memberof quack
         * @classdesc Represents a Nack.
         * @implements INack
         * @constructor
         * @param {quack.INack=} [properties] Properties to set
         */
        function Nack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Nack errorMessage.
         * @member {string} errorMessage
         * @memberof quack.Nack
         * @instance
         */
        Nack.prototype.errorMessage = "";

        /**
         * Creates a new Nack instance using the specified properties.
         * @function create
         * @memberof quack.Nack
         * @static
         * @param {quack.INack=} [properties] Properties to set
         * @returns {quack.Nack} Nack instance
         */
        Nack.create = function create(properties) {
            return new Nack(properties);
        };

        /**
         * Creates a Nack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Nack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Nack} Nack
         */
        Nack.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Nack)
                return object;
            var message = new $root.quack.Nack();
            if (object.errorMessage != null)
                message.errorMessage = String(object.errorMessage);
            return message;
        };

        /**
         * Creates a plain object from a Nack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Nack
         * @static
         * @param {quack.Nack} message Nack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Nack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errorMessage = "";
            if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                object.errorMessage = message.errorMessage;
            return object;
        };

        /**
         * Converts this Nack to JSON.
         * @function toJSON
         * @memberof quack.Nack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Nack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Nack;
    })();

    /**
     * SleepType enum.
     * @name quack.SleepType
     * @enum {string}
     * @property {number} SLEEP_TYPE_NONE=0 SLEEP_TYPE_NONE value
     * @property {number} SLEEP_TYPE_NAP=1 SLEEP_TYPE_NAP value
     * @property {number} SLEEP_TYPE_DEEP=2 SLEEP_TYPE_DEEP value
     * @property {number} SLEEP_TYPE_HIBERNATE=3 SLEEP_TYPE_HIBERNATE value
     */
    quack.SleepType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SLEEP_TYPE_NONE"] = 0;
        values[valuesById[1] = "SLEEP_TYPE_NAP"] = 1;
        values[valuesById[2] = "SLEEP_TYPE_DEEP"] = 2;
        values[valuesById[3] = "SLEEP_TYPE_HIBERNATE"] = 3;
        return values;
    })();

    quack.UpdateDevice = (function() {

        /**
         * Properties of an UpdateDevice.
         * @memberof quack
         * @interface IUpdateDevice
         * @property {string|null} [name] UpdateDevice name
         * @property {quack.SleepType|null} [sleepType] UpdateDevice sleepType
         * @property {number|null} [sleepDurationS] UpdateDevice sleepDurationS
         * @property {number|null} [sleepDelayMs] UpdateDevice sleepDelayMs
         * @property {number|null} [pondCheckPeriodS] UpdateDevice pondCheckPeriodS
         * @property {number|null} [wakePin] UpdateDevice wakePin
         */

        /**
         * Constructs a new UpdateDevice.
         * @memberof quack
         * @classdesc Represents an UpdateDevice.
         * @implements IUpdateDevice
         * @constructor
         * @param {quack.IUpdateDevice=} [properties] Properties to set
         */
        function UpdateDevice(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateDevice name.
         * @member {string} name
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.name = "";

        /**
         * UpdateDevice sleepType.
         * @member {quack.SleepType} sleepType
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.sleepType = 0;

        /**
         * UpdateDevice sleepDurationS.
         * @member {number} sleepDurationS
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.sleepDurationS = 0;

        /**
         * UpdateDevice sleepDelayMs.
         * @member {number} sleepDelayMs
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.sleepDelayMs = 0;

        /**
         * UpdateDevice pondCheckPeriodS.
         * @member {number} pondCheckPeriodS
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.pondCheckPeriodS = 0;

        /**
         * UpdateDevice wakePin.
         * @member {number} wakePin
         * @memberof quack.UpdateDevice
         * @instance
         */
        UpdateDevice.prototype.wakePin = 0;

        /**
         * Creates a new UpdateDevice instance using the specified properties.
         * @function create
         * @memberof quack.UpdateDevice
         * @static
         * @param {quack.IUpdateDevice=} [properties] Properties to set
         * @returns {quack.UpdateDevice} UpdateDevice instance
         */
        UpdateDevice.create = function create(properties) {
            return new UpdateDevice(properties);
        };

        /**
         * Creates an UpdateDevice message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateDevice
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateDevice} UpdateDevice
         */
        UpdateDevice.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateDevice)
                return object;
            var message = new $root.quack.UpdateDevice();
            if (object.name != null)
                message.name = String(object.name);
            switch (object.sleepType) {
            case "SLEEP_TYPE_NONE":
            case 0:
                message.sleepType = 0;
                break;
            case "SLEEP_TYPE_NAP":
            case 1:
                message.sleepType = 1;
                break;
            case "SLEEP_TYPE_DEEP":
            case 2:
                message.sleepType = 2;
                break;
            case "SLEEP_TYPE_HIBERNATE":
            case 3:
                message.sleepType = 3;
                break;
            }
            if (object.sleepDurationS != null)
                message.sleepDurationS = object.sleepDurationS >>> 0;
            if (object.sleepDelayMs != null)
                message.sleepDelayMs = object.sleepDelayMs >>> 0;
            if (object.pondCheckPeriodS != null)
                message.pondCheckPeriodS = object.pondCheckPeriodS >>> 0;
            if (object.wakePin != null)
                message.wakePin = object.wakePin >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an UpdateDevice message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateDevice
         * @static
         * @param {quack.UpdateDevice} message UpdateDevice
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateDevice.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.sleepType = options.enums === String ? "SLEEP_TYPE_NONE" : 0;
                object.sleepDurationS = 0;
                object.sleepDelayMs = 0;
                object.pondCheckPeriodS = 0;
                object.wakePin = 0;
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.sleepType != null && message.hasOwnProperty("sleepType"))
                object.sleepType = options.enums === String ? $root.quack.SleepType[message.sleepType] : message.sleepType;
            if (message.sleepDurationS != null && message.hasOwnProperty("sleepDurationS"))
                object.sleepDurationS = message.sleepDurationS;
            if (message.sleepDelayMs != null && message.hasOwnProperty("sleepDelayMs"))
                object.sleepDelayMs = message.sleepDelayMs;
            if (message.pondCheckPeriodS != null && message.hasOwnProperty("pondCheckPeriodS"))
                object.pondCheckPeriodS = message.pondCheckPeriodS;
            if (message.wakePin != null && message.hasOwnProperty("wakePin"))
                object.wakePin = message.wakePin;
            return object;
        };

        /**
         * Converts this UpdateDevice to JSON.
         * @function toJSON
         * @memberof quack.UpdateDevice
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateDevice.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateDevice;
    })();

    quack.Check = (function() {

        /**
         * Properties of a Check.
         * @memberof quack
         * @interface ICheck
         */

        /**
         * Constructs a new Check.
         * @memberof quack
         * @classdesc Represents a Check.
         * @implements ICheck
         * @constructor
         * @param {quack.ICheck=} [properties] Properties to set
         */
        function Check(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Check instance using the specified properties.
         * @function create
         * @memberof quack.Check
         * @static
         * @param {quack.ICheck=} [properties] Properties to set
         * @returns {quack.Check} Check instance
         */
        Check.create = function create(properties) {
            return new Check(properties);
        };

        /**
         * Creates a Check message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Check
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Check} Check
         */
        Check.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Check)
                return object;
            return new $root.quack.Check();
        };

        /**
         * Creates a plain object from a Check message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Check
         * @static
         * @param {quack.Check} message Check
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Check.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Check to JSON.
         * @function toJSON
         * @memberof quack.Check
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Check.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Check;
    })();

    quack.Firmware = (function() {

        /**
         * Properties of a Firmware.
         * @memberof quack
         * @interface IFirmware
         * @property {Uint8Array|null} [chunk] Firmware chunk
         * @property {number|null} [totalSize] Firmware totalSize
         * @property {number|null} [offset] Firmware offset
         */

        /**
         * Constructs a new Firmware.
         * @memberof quack
         * @classdesc Represents a Firmware.
         * @implements IFirmware
         * @constructor
         * @param {quack.IFirmware=} [properties] Properties to set
         */
        function Firmware(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Firmware chunk.
         * @member {Uint8Array} chunk
         * @memberof quack.Firmware
         * @instance
         */
        Firmware.prototype.chunk = $util.newBuffer([]);

        /**
         * Firmware totalSize.
         * @member {number} totalSize
         * @memberof quack.Firmware
         * @instance
         */
        Firmware.prototype.totalSize = 0;

        /**
         * Firmware offset.
         * @member {number} offset
         * @memberof quack.Firmware
         * @instance
         */
        Firmware.prototype.offset = 0;

        /**
         * Creates a new Firmware instance using the specified properties.
         * @function create
         * @memberof quack.Firmware
         * @static
         * @param {quack.IFirmware=} [properties] Properties to set
         * @returns {quack.Firmware} Firmware instance
         */
        Firmware.create = function create(properties) {
            return new Firmware(properties);
        };

        /**
         * Creates a Firmware message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Firmware
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Firmware} Firmware
         */
        Firmware.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Firmware)
                return object;
            var message = new $root.quack.Firmware();
            if (object.chunk != null)
                if (typeof object.chunk === "string")
                    $util.base64.decode(object.chunk, message.chunk = $util.newBuffer($util.base64.length(object.chunk)), 0);
                else if (object.chunk.length)
                    message.chunk = object.chunk;
            if (object.totalSize != null)
                message.totalSize = object.totalSize >>> 0;
            if (object.offset != null)
                message.offset = object.offset >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Firmware message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Firmware
         * @static
         * @param {quack.Firmware} message Firmware
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Firmware.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.chunk = "";
                else {
                    object.chunk = [];
                    if (options.bytes !== Array)
                        object.chunk = $util.newBuffer(object.chunk);
                }
                object.totalSize = 0;
                object.offset = 0;
            }
            if (message.chunk != null && message.hasOwnProperty("chunk"))
                object.chunk = options.bytes === String ? $util.base64.encode(message.chunk, 0, message.chunk.length) : options.bytes === Array ? Array.prototype.slice.call(message.chunk) : message.chunk;
            if (message.totalSize != null && message.hasOwnProperty("totalSize"))
                object.totalSize = message.totalSize;
            if (message.offset != null && message.hasOwnProperty("offset"))
                object.offset = message.offset;
            return object;
        };

        /**
         * Converts this Firmware to JSON.
         * @function toJSON
         * @memberof quack.Firmware
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Firmware.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Firmware;
    })();

    quack.SyncTime = (function() {

        /**
         * Properties of a SyncTime.
         * @memberof quack
         * @interface ISyncTime
         */

        /**
         * Constructs a new SyncTime.
         * @memberof quack
         * @classdesc Represents a SyncTime.
         * @implements ISyncTime
         * @constructor
         * @param {quack.ISyncTime=} [properties] Properties to set
         */
        function SyncTime(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SyncTime instance using the specified properties.
         * @function create
         * @memberof quack.SyncTime
         * @static
         * @param {quack.ISyncTime=} [properties] Properties to set
         * @returns {quack.SyncTime} SyncTime instance
         */
        SyncTime.create = function create(properties) {
            return new SyncTime(properties);
        };

        /**
         * Creates a SyncTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.SyncTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.SyncTime} SyncTime
         */
        SyncTime.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.SyncTime)
                return object;
            return new $root.quack.SyncTime();
        };

        /**
         * Creates a plain object from a SyncTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.SyncTime
         * @static
         * @param {quack.SyncTime} message SyncTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SyncTime.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SyncTime to JSON.
         * @function toJSON
         * @memberof quack.SyncTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SyncTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncTime;
    })();

    quack.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof quack
         * @interface IError
         * @property {string|null} [msg] Error msg
         */

        /**
         * Constructs a new Error.
         * @memberof quack
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {quack.IError=} [properties] Properties to set
         */
        function Error(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Error msg.
         * @member {string} msg
         * @memberof quack.Error
         * @instance
         */
        Error.prototype.msg = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof quack.Error
         * @static
         * @param {quack.IError=} [properties] Properties to set
         * @returns {quack.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Creates an Error message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Error
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Error} Error
         */
        Error.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Error)
                return object;
            var message = new $root.quack.Error();
            if (object.msg != null)
                message.msg = String(object.msg);
            return message;
        };

        /**
         * Creates a plain object from an Error message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Error
         * @static
         * @param {quack.Error} message Error
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Error.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.msg = "";
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            return object;
        };

        /**
         * Converts this Error to JSON.
         * @function toJSON
         * @memberof quack.Error
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Error.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Error;
    })();

    quack.Clear = (function() {

        /**
         * Properties of a Clear.
         * @memberof quack
         * @interface IClear
         */

        /**
         * Constructs a new Clear.
         * @memberof quack
         * @classdesc Represents a Clear.
         * @implements IClear
         * @constructor
         * @param {quack.IClear=} [properties] Properties to set
         */
        function Clear(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Clear instance using the specified properties.
         * @function create
         * @memberof quack.Clear
         * @static
         * @param {quack.IClear=} [properties] Properties to set
         * @returns {quack.Clear} Clear instance
         */
        Clear.create = function create(properties) {
            return new Clear(properties);
        };

        /**
         * Creates a Clear message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Clear
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Clear} Clear
         */
        Clear.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Clear)
                return object;
            return new $root.quack.Clear();
        };

        /**
         * Creates a plain object from a Clear message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Clear
         * @static
         * @param {quack.Clear} message Clear
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Clear.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Clear to JSON.
         * @function toJSON
         * @memberof quack.Clear
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Clear.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Clear;
    })();

    quack.Status = (function() {

        /**
         * Properties of a Status.
         * @memberof quack
         * @interface IStatus
         * @property {string|null} [iccid] Status iccid
         * @property {string|null} [firmwareVersion] Status firmwareVersion
         * @property {number|null} [resetReason] Status resetReason
         */

        /**
         * Constructs a new Status.
         * @memberof quack
         * @classdesc Represents a Status.
         * @implements IStatus
         * @constructor
         * @param {quack.IStatus=} [properties] Properties to set
         */
        function Status(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Status iccid.
         * @member {string} iccid
         * @memberof quack.Status
         * @instance
         */
        Status.prototype.iccid = "";

        /**
         * Status firmwareVersion.
         * @member {string} firmwareVersion
         * @memberof quack.Status
         * @instance
         */
        Status.prototype.firmwareVersion = "";

        /**
         * Status resetReason.
         * @member {number} resetReason
         * @memberof quack.Status
         * @instance
         */
        Status.prototype.resetReason = 0;

        /**
         * Creates a new Status instance using the specified properties.
         * @function create
         * @memberof quack.Status
         * @static
         * @param {quack.IStatus=} [properties] Properties to set
         * @returns {quack.Status} Status instance
         */
        Status.create = function create(properties) {
            return new Status(properties);
        };

        /**
         * Creates a Status message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Status
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Status} Status
         */
        Status.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Status)
                return object;
            var message = new $root.quack.Status();
            if (object.iccid != null)
                message.iccid = String(object.iccid);
            if (object.firmwareVersion != null)
                message.firmwareVersion = String(object.firmwareVersion);
            if (object.resetReason != null)
                message.resetReason = object.resetReason >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Status message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Status
         * @static
         * @param {quack.Status} message Status
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Status.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.iccid = "";
                object.firmwareVersion = "";
                object.resetReason = 0;
            }
            if (message.iccid != null && message.hasOwnProperty("iccid"))
                object.iccid = message.iccid;
            if (message.firmwareVersion != null && message.hasOwnProperty("firmwareVersion"))
                object.firmwareVersion = message.firmwareVersion;
            if (message.resetReason != null && message.hasOwnProperty("resetReason"))
                object.resetReason = message.resetReason;
            return object;
        };

        /**
         * Converts this Status to JSON.
         * @function toJSON
         * @memberof quack.Status
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Status.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Status;
    })();

    quack.Connect = (function() {

        /**
         * Properties of a Connect.
         * @memberof quack
         * @interface IConnect
         * @property {string|null} [gateway] Connect gateway
         * @property {string|null} [password] Connect password
         */

        /**
         * Constructs a new Connect.
         * @memberof quack
         * @classdesc Represents a Connect.
         * @implements IConnect
         * @constructor
         * @param {quack.IConnect=} [properties] Properties to set
         */
        function Connect(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Connect gateway.
         * @member {string} gateway
         * @memberof quack.Connect
         * @instance
         */
        Connect.prototype.gateway = "";

        /**
         * Connect password.
         * @member {string} password
         * @memberof quack.Connect
         * @instance
         */
        Connect.prototype.password = "";

        /**
         * Creates a new Connect instance using the specified properties.
         * @function create
         * @memberof quack.Connect
         * @static
         * @param {quack.IConnect=} [properties] Properties to set
         * @returns {quack.Connect} Connect instance
         */
        Connect.create = function create(properties) {
            return new Connect(properties);
        };

        /**
         * Creates a Connect message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Connect
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Connect} Connect
         */
        Connect.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Connect)
                return object;
            var message = new $root.quack.Connect();
            if (object.gateway != null)
                message.gateway = String(object.gateway);
            if (object.password != null)
                message.password = String(object.password);
            return message;
        };

        /**
         * Creates a plain object from a Connect message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Connect
         * @static
         * @param {quack.Connect} message Connect
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Connect.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.gateway = "";
                object.password = "";
            }
            if (message.gateway != null && message.hasOwnProperty("gateway"))
                object.gateway = message.gateway;
            if (message.password != null && message.hasOwnProperty("password"))
                object.password = message.password;
            return object;
        };

        /**
         * Converts this Connect to JSON.
         * @function toJSON
         * @memberof quack.Connect
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Connect.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Connect;
    })();

    /**
     * ComponentType enum.
     * @name quack.ComponentType
     * @enum {string}
     * @property {number} COMPONENT_TYPE_INVALID=0 COMPONENT_TYPE_INVALID value
     * @property {number} COMPONENT_TYPE_POWER=1 COMPONENT_TYPE_POWER value
     * @property {number} COMPONENT_TYPE_TEMPERATURE=2 COMPONENT_TYPE_TEMPERATURE value
     * @property {number} COMPONENT_TYPE_BOOLEAN_OUTPUT=3 COMPONENT_TYPE_BOOLEAN_OUTPUT value
     * @property {number} COMPONENT_TYPE_EDGE_TRIGGERED=4 COMPONENT_TYPE_EDGE_TRIGGERED value
     * @property {number} COMPONENT_TYPE_GRAIN_CABLE=5 COMPONENT_TYPE_GRAIN_CABLE value
     * @property {number} COMPONENT_TYPE_PRESSURE=6 COMPONENT_TYPE_PRESSURE value
     * @property {number} COMPONENT_TYPE_GPS=7 COMPONENT_TYPE_GPS value
     * @property {number} COMPONENT_TYPE_BOOLEAN_INPUT=8 COMPONENT_TYPE_BOOLEAN_INPUT value
     * @property {number} COMPONENT_TYPE_DHT=9 COMPONENT_TYPE_DHT value
     * @property {number} COMPONENT_TYPE_MODEM=10 COMPONENT_TYPE_MODEM value
     * @property {number} COMPONENT_TYPE_LIGHT=11 COMPONENT_TYPE_LIGHT value
     * @property {number} COMPONENT_TYPE_CO2=12 COMPONENT_TYPE_CO2 value
     * @property {number} COMPONENT_TYPE_STEPPER_MOTOR=13 COMPONENT_TYPE_STEPPER_MOTOR value
     * @property {number} COMPONENT_TYPE_ANALOG_INPUT=14 COMPONENT_TYPE_ANALOG_INPUT value
     * @property {number} COMPONENT_TYPE_O2=15 COMPONENT_TYPE_O2 value
     * @property {number} COMPONENT_TYPE_ETHYLENE=16 COMPONENT_TYPE_ETHYLENE value
     * @property {number} COMPONENT_TYPE_ORP=17 COMPONENT_TYPE_ORP value
     * @property {number} COMPONENT_TYPE_PH=18 COMPONENT_TYPE_PH value
     * @property {number} COMPONENT_TYPE_VOLTAGE=19 COMPONENT_TYPE_VOLTAGE value
     * @property {number} COMPONENT_TYPE_CALCIUM=20 COMPONENT_TYPE_CALCIUM value
     * @property {number} COMPONENT_TYPE_NITRATE=21 COMPONENT_TYPE_NITRATE value
     * @property {number} COMPONENT_TYPE_POTASSIUM=22 COMPONENT_TYPE_POTASSIUM value
     * @property {number} COMPONENT_TYPE_CONDUCTIVITY=23 COMPONENT_TYPE_CONDUCTIVITY value
     * @property {number} COMPONENT_TYPE_CAPACITANCE=24 COMPONENT_TYPE_CAPACITANCE value
     * @property {number} COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT=25 COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT value
     * @property {number} COMPONENT_TYPE_WEIGHT=26 COMPONENT_TYPE_WEIGHT value
     * @property {number} COMPONENT_TYPE_AIR_QUALITY=27 COMPONENT_TYPE_AIR_QUALITY value
     * @property {number} COMPONENT_TYPE_LIDAR=28 COMPONENT_TYPE_LIDAR value
     * @property {number} COMPONENT_TYPE_PRESSURE_CABLE=29 COMPONENT_TYPE_PRESSURE_CABLE value
     * @property {number} COMPONENT_TYPE_INTERNAL_FUNCTION=30 COMPONENT_TYPE_INTERNAL_FUNCTION value
     * @property {number} COMPONENT_TYPE_CAPACITOR_CABLE=31 COMPONENT_TYPE_CAPACITOR_CABLE value
     * @property {number} COMPONENT_TYPE_SEN5X=32 COMPONENT_TYPE_SEN5X value
     * @property {number} COMPONENT_TYPE_VIBRATION_CHAIN=33 COMPONENT_TYPE_VIBRATION_CHAIN value
     * @property {number} COMPONENT_TYPE_DRAGER_GAS_DONGLE=34 COMPONENT_TYPE_DRAGER_GAS_DONGLE value
     * @property {number} COMPONENT_TYPE_AIRFLOW=35 COMPONENT_TYPE_AIRFLOW value
     */
    quack.ComponentType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "COMPONENT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "COMPONENT_TYPE_POWER"] = 1;
        values[valuesById[2] = "COMPONENT_TYPE_TEMPERATURE"] = 2;
        values[valuesById[3] = "COMPONENT_TYPE_BOOLEAN_OUTPUT"] = 3;
        values[valuesById[4] = "COMPONENT_TYPE_EDGE_TRIGGERED"] = 4;
        values[valuesById[5] = "COMPONENT_TYPE_GRAIN_CABLE"] = 5;
        values[valuesById[6] = "COMPONENT_TYPE_PRESSURE"] = 6;
        values[valuesById[7] = "COMPONENT_TYPE_GPS"] = 7;
        values[valuesById[8] = "COMPONENT_TYPE_BOOLEAN_INPUT"] = 8;
        values[valuesById[9] = "COMPONENT_TYPE_DHT"] = 9;
        values[valuesById[10] = "COMPONENT_TYPE_MODEM"] = 10;
        values[valuesById[11] = "COMPONENT_TYPE_LIGHT"] = 11;
        values[valuesById[12] = "COMPONENT_TYPE_CO2"] = 12;
        values[valuesById[13] = "COMPONENT_TYPE_STEPPER_MOTOR"] = 13;
        values[valuesById[14] = "COMPONENT_TYPE_ANALOG_INPUT"] = 14;
        values[valuesById[15] = "COMPONENT_TYPE_O2"] = 15;
        values[valuesById[16] = "COMPONENT_TYPE_ETHYLENE"] = 16;
        values[valuesById[17] = "COMPONENT_TYPE_ORP"] = 17;
        values[valuesById[18] = "COMPONENT_TYPE_PH"] = 18;
        values[valuesById[19] = "COMPONENT_TYPE_VOLTAGE"] = 19;
        values[valuesById[20] = "COMPONENT_TYPE_CALCIUM"] = 20;
        values[valuesById[21] = "COMPONENT_TYPE_NITRATE"] = 21;
        values[valuesById[22] = "COMPONENT_TYPE_POTASSIUM"] = 22;
        values[valuesById[23] = "COMPONENT_TYPE_CONDUCTIVITY"] = 23;
        values[valuesById[24] = "COMPONENT_TYPE_CAPACITANCE"] = 24;
        values[valuesById[25] = "COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT"] = 25;
        values[valuesById[26] = "COMPONENT_TYPE_WEIGHT"] = 26;
        values[valuesById[27] = "COMPONENT_TYPE_AIR_QUALITY"] = 27;
        values[valuesById[28] = "COMPONENT_TYPE_LIDAR"] = 28;
        values[valuesById[29] = "COMPONENT_TYPE_PRESSURE_CABLE"] = 29;
        values[valuesById[30] = "COMPONENT_TYPE_INTERNAL_FUNCTION"] = 30;
        values[valuesById[31] = "COMPONENT_TYPE_CAPACITOR_CABLE"] = 31;
        values[valuesById[32] = "COMPONENT_TYPE_SEN5X"] = 32;
        values[valuesById[33] = "COMPONENT_TYPE_VIBRATION_CHAIN"] = 33;
        values[valuesById[34] = "COMPONENT_TYPE_DRAGER_GAS_DONGLE"] = 34;
        values[valuesById[35] = "COMPONENT_TYPE_AIRFLOW"] = 35;
        return values;
    })();

    /**
     * AddressType enum.
     * @name quack.AddressType
     * @enum {string}
     * @property {number} ADDRESS_TYPE_INVALID=0 ADDRESS_TYPE_INVALID value
     * @property {number} ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY=1 ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY value
     * @property {number} ADDRESS_TYPE_I2C=2 ADDRESS_TYPE_I2C value
     * @property {number} ADDRESS_TYPE_DAC=3 ADDRESS_TYPE_DAC value
     * @property {number} ADDRESS_TYPE_POWER=4 ADDRESS_TYPE_POWER value
     * @property {number} ADDRESS_TYPE_GPS=5 ADDRESS_TYPE_GPS value
     * @property {number} ADDRESS_TYPE_MODEM=6 ADDRESS_TYPE_MODEM value
     * @property {number} ADDRESS_TYPE_I2C_WITH_CHANNELS=7 ADDRESS_TYPE_I2C_WITH_CHANNELS value
     * @property {number} ADDRESS_TYPE_INCREMENTAL=8 ADDRESS_TYPE_INCREMENTAL value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET1=9 ADDRESS_TYPE_PIN_OFFSET1 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET2=10 ADDRESS_TYPE_PIN_OFFSET2 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET3=11 ADDRESS_TYPE_PIN_OFFSET3 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET4=12 ADDRESS_TYPE_PIN_OFFSET4 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET5=13 ADDRESS_TYPE_PIN_OFFSET5 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET6=14 ADDRESS_TYPE_PIN_OFFSET6 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET7=15 ADDRESS_TYPE_PIN_OFFSET7 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET8=16 ADDRESS_TYPE_PIN_OFFSET8 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET9=17 ADDRESS_TYPE_PIN_OFFSET9 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET10=18 ADDRESS_TYPE_PIN_OFFSET10 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET11=19 ADDRESS_TYPE_PIN_OFFSET11 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET12=20 ADDRESS_TYPE_PIN_OFFSET12 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET13=21 ADDRESS_TYPE_PIN_OFFSET13 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET14=22 ADDRESS_TYPE_PIN_OFFSET14 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET15=23 ADDRESS_TYPE_PIN_OFFSET15 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET16=24 ADDRESS_TYPE_PIN_OFFSET16 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET17=25 ADDRESS_TYPE_PIN_OFFSET17 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET18=26 ADDRESS_TYPE_PIN_OFFSET18 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET19=27 ADDRESS_TYPE_PIN_OFFSET19 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET20=28 ADDRESS_TYPE_PIN_OFFSET20 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET21=29 ADDRESS_TYPE_PIN_OFFSET21 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET22=30 ADDRESS_TYPE_PIN_OFFSET22 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET23=31 ADDRESS_TYPE_PIN_OFFSET23 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET24=32 ADDRESS_TYPE_PIN_OFFSET24 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET25=33 ADDRESS_TYPE_PIN_OFFSET25 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET26=34 ADDRESS_TYPE_PIN_OFFSET26 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET27=35 ADDRESS_TYPE_PIN_OFFSET27 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET28=36 ADDRESS_TYPE_PIN_OFFSET28 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET29=37 ADDRESS_TYPE_PIN_OFFSET29 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET30=38 ADDRESS_TYPE_PIN_OFFSET30 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET31=39 ADDRESS_TYPE_PIN_OFFSET31 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET32=40 ADDRESS_TYPE_PIN_OFFSET32 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET33=41 ADDRESS_TYPE_PIN_OFFSET33 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET34=42 ADDRESS_TYPE_PIN_OFFSET34 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET35=43 ADDRESS_TYPE_PIN_OFFSET35 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET36=44 ADDRESS_TYPE_PIN_OFFSET36 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET37=45 ADDRESS_TYPE_PIN_OFFSET37 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET38=46 ADDRESS_TYPE_PIN_OFFSET38 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET39=47 ADDRESS_TYPE_PIN_OFFSET39 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET40=48 ADDRESS_TYPE_PIN_OFFSET40 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET41=49 ADDRESS_TYPE_PIN_OFFSET41 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET42=50 ADDRESS_TYPE_PIN_OFFSET42 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET43=51 ADDRESS_TYPE_PIN_OFFSET43 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET44=52 ADDRESS_TYPE_PIN_OFFSET44 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET45=53 ADDRESS_TYPE_PIN_OFFSET45 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET46=54 ADDRESS_TYPE_PIN_OFFSET46 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET47=55 ADDRESS_TYPE_PIN_OFFSET47 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET48=56 ADDRESS_TYPE_PIN_OFFSET48 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET49=57 ADDRESS_TYPE_PIN_OFFSET49 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET50=58 ADDRESS_TYPE_PIN_OFFSET50 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET51=59 ADDRESS_TYPE_PIN_OFFSET51 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET52=60 ADDRESS_TYPE_PIN_OFFSET52 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET53=61 ADDRESS_TYPE_PIN_OFFSET53 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET54=62 ADDRESS_TYPE_PIN_OFFSET54 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET55=63 ADDRESS_TYPE_PIN_OFFSET55 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET56=64 ADDRESS_TYPE_PIN_OFFSET56 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET57=65 ADDRESS_TYPE_PIN_OFFSET57 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET58=66 ADDRESS_TYPE_PIN_OFFSET58 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET59=67 ADDRESS_TYPE_PIN_OFFSET59 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET60=68 ADDRESS_TYPE_PIN_OFFSET60 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET61=69 ADDRESS_TYPE_PIN_OFFSET61 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET62=70 ADDRESS_TYPE_PIN_OFFSET62 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET63=71 ADDRESS_TYPE_PIN_OFFSET63 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET64=72 ADDRESS_TYPE_PIN_OFFSET64 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET65=73 ADDRESS_TYPE_PIN_OFFSET65 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET66=74 ADDRESS_TYPE_PIN_OFFSET66 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET67=75 ADDRESS_TYPE_PIN_OFFSET67 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET68=76 ADDRESS_TYPE_PIN_OFFSET68 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET69=77 ADDRESS_TYPE_PIN_OFFSET69 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET70=78 ADDRESS_TYPE_PIN_OFFSET70 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET71=79 ADDRESS_TYPE_PIN_OFFSET71 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET72=80 ADDRESS_TYPE_PIN_OFFSET72 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET73=81 ADDRESS_TYPE_PIN_OFFSET73 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET74=82 ADDRESS_TYPE_PIN_OFFSET74 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET75=83 ADDRESS_TYPE_PIN_OFFSET75 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET76=84 ADDRESS_TYPE_PIN_OFFSET76 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET77=85 ADDRESS_TYPE_PIN_OFFSET77 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET78=86 ADDRESS_TYPE_PIN_OFFSET78 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET79=87 ADDRESS_TYPE_PIN_OFFSET79 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET80=88 ADDRESS_TYPE_PIN_OFFSET80 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET81=89 ADDRESS_TYPE_PIN_OFFSET81 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET82=90 ADDRESS_TYPE_PIN_OFFSET82 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET83=91 ADDRESS_TYPE_PIN_OFFSET83 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET84=92 ADDRESS_TYPE_PIN_OFFSET84 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET85=93 ADDRESS_TYPE_PIN_OFFSET85 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET86=94 ADDRESS_TYPE_PIN_OFFSET86 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET87=95 ADDRESS_TYPE_PIN_OFFSET87 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET88=96 ADDRESS_TYPE_PIN_OFFSET88 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET89=97 ADDRESS_TYPE_PIN_OFFSET89 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET90=98 ADDRESS_TYPE_PIN_OFFSET90 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET91=99 ADDRESS_TYPE_PIN_OFFSET91 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET92=100 ADDRESS_TYPE_PIN_OFFSET92 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET93=101 ADDRESS_TYPE_PIN_OFFSET93 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET94=102 ADDRESS_TYPE_PIN_OFFSET94 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET95=103 ADDRESS_TYPE_PIN_OFFSET95 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET96=104 ADDRESS_TYPE_PIN_OFFSET96 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET97=105 ADDRESS_TYPE_PIN_OFFSET97 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET98=106 ADDRESS_TYPE_PIN_OFFSET98 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET99=107 ADDRESS_TYPE_PIN_OFFSET99 value
     * @property {number} ADDRESS_TYPE_PIN_OFFSET100=108 ADDRESS_TYPE_PIN_OFFSET100 value
     * @property {number} ADDRESS_TYPE_INTERNAL_SLEEP=109 ADDRESS_TYPE_INTERNAL_SLEEP value
     * @property {number} ADDRESS_TYPE_SPI=110 ADDRESS_TYPE_SPI value
     */
    quack.AddressType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ADDRESS_TYPE_INVALID"] = 0;
        values[valuesById[1] = "ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY"] = 1;
        values[valuesById[2] = "ADDRESS_TYPE_I2C"] = 2;
        values[valuesById[3] = "ADDRESS_TYPE_DAC"] = 3;
        values[valuesById[4] = "ADDRESS_TYPE_POWER"] = 4;
        values[valuesById[5] = "ADDRESS_TYPE_GPS"] = 5;
        values[valuesById[6] = "ADDRESS_TYPE_MODEM"] = 6;
        values[valuesById[7] = "ADDRESS_TYPE_I2C_WITH_CHANNELS"] = 7;
        values[valuesById[8] = "ADDRESS_TYPE_INCREMENTAL"] = 8;
        values[valuesById[9] = "ADDRESS_TYPE_PIN_OFFSET1"] = 9;
        values[valuesById[10] = "ADDRESS_TYPE_PIN_OFFSET2"] = 10;
        values[valuesById[11] = "ADDRESS_TYPE_PIN_OFFSET3"] = 11;
        values[valuesById[12] = "ADDRESS_TYPE_PIN_OFFSET4"] = 12;
        values[valuesById[13] = "ADDRESS_TYPE_PIN_OFFSET5"] = 13;
        values[valuesById[14] = "ADDRESS_TYPE_PIN_OFFSET6"] = 14;
        values[valuesById[15] = "ADDRESS_TYPE_PIN_OFFSET7"] = 15;
        values[valuesById[16] = "ADDRESS_TYPE_PIN_OFFSET8"] = 16;
        values[valuesById[17] = "ADDRESS_TYPE_PIN_OFFSET9"] = 17;
        values[valuesById[18] = "ADDRESS_TYPE_PIN_OFFSET10"] = 18;
        values[valuesById[19] = "ADDRESS_TYPE_PIN_OFFSET11"] = 19;
        values[valuesById[20] = "ADDRESS_TYPE_PIN_OFFSET12"] = 20;
        values[valuesById[21] = "ADDRESS_TYPE_PIN_OFFSET13"] = 21;
        values[valuesById[22] = "ADDRESS_TYPE_PIN_OFFSET14"] = 22;
        values[valuesById[23] = "ADDRESS_TYPE_PIN_OFFSET15"] = 23;
        values[valuesById[24] = "ADDRESS_TYPE_PIN_OFFSET16"] = 24;
        values[valuesById[25] = "ADDRESS_TYPE_PIN_OFFSET17"] = 25;
        values[valuesById[26] = "ADDRESS_TYPE_PIN_OFFSET18"] = 26;
        values[valuesById[27] = "ADDRESS_TYPE_PIN_OFFSET19"] = 27;
        values[valuesById[28] = "ADDRESS_TYPE_PIN_OFFSET20"] = 28;
        values[valuesById[29] = "ADDRESS_TYPE_PIN_OFFSET21"] = 29;
        values[valuesById[30] = "ADDRESS_TYPE_PIN_OFFSET22"] = 30;
        values[valuesById[31] = "ADDRESS_TYPE_PIN_OFFSET23"] = 31;
        values[valuesById[32] = "ADDRESS_TYPE_PIN_OFFSET24"] = 32;
        values[valuesById[33] = "ADDRESS_TYPE_PIN_OFFSET25"] = 33;
        values[valuesById[34] = "ADDRESS_TYPE_PIN_OFFSET26"] = 34;
        values[valuesById[35] = "ADDRESS_TYPE_PIN_OFFSET27"] = 35;
        values[valuesById[36] = "ADDRESS_TYPE_PIN_OFFSET28"] = 36;
        values[valuesById[37] = "ADDRESS_TYPE_PIN_OFFSET29"] = 37;
        values[valuesById[38] = "ADDRESS_TYPE_PIN_OFFSET30"] = 38;
        values[valuesById[39] = "ADDRESS_TYPE_PIN_OFFSET31"] = 39;
        values[valuesById[40] = "ADDRESS_TYPE_PIN_OFFSET32"] = 40;
        values[valuesById[41] = "ADDRESS_TYPE_PIN_OFFSET33"] = 41;
        values[valuesById[42] = "ADDRESS_TYPE_PIN_OFFSET34"] = 42;
        values[valuesById[43] = "ADDRESS_TYPE_PIN_OFFSET35"] = 43;
        values[valuesById[44] = "ADDRESS_TYPE_PIN_OFFSET36"] = 44;
        values[valuesById[45] = "ADDRESS_TYPE_PIN_OFFSET37"] = 45;
        values[valuesById[46] = "ADDRESS_TYPE_PIN_OFFSET38"] = 46;
        values[valuesById[47] = "ADDRESS_TYPE_PIN_OFFSET39"] = 47;
        values[valuesById[48] = "ADDRESS_TYPE_PIN_OFFSET40"] = 48;
        values[valuesById[49] = "ADDRESS_TYPE_PIN_OFFSET41"] = 49;
        values[valuesById[50] = "ADDRESS_TYPE_PIN_OFFSET42"] = 50;
        values[valuesById[51] = "ADDRESS_TYPE_PIN_OFFSET43"] = 51;
        values[valuesById[52] = "ADDRESS_TYPE_PIN_OFFSET44"] = 52;
        values[valuesById[53] = "ADDRESS_TYPE_PIN_OFFSET45"] = 53;
        values[valuesById[54] = "ADDRESS_TYPE_PIN_OFFSET46"] = 54;
        values[valuesById[55] = "ADDRESS_TYPE_PIN_OFFSET47"] = 55;
        values[valuesById[56] = "ADDRESS_TYPE_PIN_OFFSET48"] = 56;
        values[valuesById[57] = "ADDRESS_TYPE_PIN_OFFSET49"] = 57;
        values[valuesById[58] = "ADDRESS_TYPE_PIN_OFFSET50"] = 58;
        values[valuesById[59] = "ADDRESS_TYPE_PIN_OFFSET51"] = 59;
        values[valuesById[60] = "ADDRESS_TYPE_PIN_OFFSET52"] = 60;
        values[valuesById[61] = "ADDRESS_TYPE_PIN_OFFSET53"] = 61;
        values[valuesById[62] = "ADDRESS_TYPE_PIN_OFFSET54"] = 62;
        values[valuesById[63] = "ADDRESS_TYPE_PIN_OFFSET55"] = 63;
        values[valuesById[64] = "ADDRESS_TYPE_PIN_OFFSET56"] = 64;
        values[valuesById[65] = "ADDRESS_TYPE_PIN_OFFSET57"] = 65;
        values[valuesById[66] = "ADDRESS_TYPE_PIN_OFFSET58"] = 66;
        values[valuesById[67] = "ADDRESS_TYPE_PIN_OFFSET59"] = 67;
        values[valuesById[68] = "ADDRESS_TYPE_PIN_OFFSET60"] = 68;
        values[valuesById[69] = "ADDRESS_TYPE_PIN_OFFSET61"] = 69;
        values[valuesById[70] = "ADDRESS_TYPE_PIN_OFFSET62"] = 70;
        values[valuesById[71] = "ADDRESS_TYPE_PIN_OFFSET63"] = 71;
        values[valuesById[72] = "ADDRESS_TYPE_PIN_OFFSET64"] = 72;
        values[valuesById[73] = "ADDRESS_TYPE_PIN_OFFSET65"] = 73;
        values[valuesById[74] = "ADDRESS_TYPE_PIN_OFFSET66"] = 74;
        values[valuesById[75] = "ADDRESS_TYPE_PIN_OFFSET67"] = 75;
        values[valuesById[76] = "ADDRESS_TYPE_PIN_OFFSET68"] = 76;
        values[valuesById[77] = "ADDRESS_TYPE_PIN_OFFSET69"] = 77;
        values[valuesById[78] = "ADDRESS_TYPE_PIN_OFFSET70"] = 78;
        values[valuesById[79] = "ADDRESS_TYPE_PIN_OFFSET71"] = 79;
        values[valuesById[80] = "ADDRESS_TYPE_PIN_OFFSET72"] = 80;
        values[valuesById[81] = "ADDRESS_TYPE_PIN_OFFSET73"] = 81;
        values[valuesById[82] = "ADDRESS_TYPE_PIN_OFFSET74"] = 82;
        values[valuesById[83] = "ADDRESS_TYPE_PIN_OFFSET75"] = 83;
        values[valuesById[84] = "ADDRESS_TYPE_PIN_OFFSET76"] = 84;
        values[valuesById[85] = "ADDRESS_TYPE_PIN_OFFSET77"] = 85;
        values[valuesById[86] = "ADDRESS_TYPE_PIN_OFFSET78"] = 86;
        values[valuesById[87] = "ADDRESS_TYPE_PIN_OFFSET79"] = 87;
        values[valuesById[88] = "ADDRESS_TYPE_PIN_OFFSET80"] = 88;
        values[valuesById[89] = "ADDRESS_TYPE_PIN_OFFSET81"] = 89;
        values[valuesById[90] = "ADDRESS_TYPE_PIN_OFFSET82"] = 90;
        values[valuesById[91] = "ADDRESS_TYPE_PIN_OFFSET83"] = 91;
        values[valuesById[92] = "ADDRESS_TYPE_PIN_OFFSET84"] = 92;
        values[valuesById[93] = "ADDRESS_TYPE_PIN_OFFSET85"] = 93;
        values[valuesById[94] = "ADDRESS_TYPE_PIN_OFFSET86"] = 94;
        values[valuesById[95] = "ADDRESS_TYPE_PIN_OFFSET87"] = 95;
        values[valuesById[96] = "ADDRESS_TYPE_PIN_OFFSET88"] = 96;
        values[valuesById[97] = "ADDRESS_TYPE_PIN_OFFSET89"] = 97;
        values[valuesById[98] = "ADDRESS_TYPE_PIN_OFFSET90"] = 98;
        values[valuesById[99] = "ADDRESS_TYPE_PIN_OFFSET91"] = 99;
        values[valuesById[100] = "ADDRESS_TYPE_PIN_OFFSET92"] = 100;
        values[valuesById[101] = "ADDRESS_TYPE_PIN_OFFSET93"] = 101;
        values[valuesById[102] = "ADDRESS_TYPE_PIN_OFFSET94"] = 102;
        values[valuesById[103] = "ADDRESS_TYPE_PIN_OFFSET95"] = 103;
        values[valuesById[104] = "ADDRESS_TYPE_PIN_OFFSET96"] = 104;
        values[valuesById[105] = "ADDRESS_TYPE_PIN_OFFSET97"] = 105;
        values[valuesById[106] = "ADDRESS_TYPE_PIN_OFFSET98"] = 106;
        values[valuesById[107] = "ADDRESS_TYPE_PIN_OFFSET99"] = 107;
        values[valuesById[108] = "ADDRESS_TYPE_PIN_OFFSET100"] = 108;
        values[valuesById[109] = "ADDRESS_TYPE_INTERNAL_SLEEP"] = 109;
        values[valuesById[110] = "ADDRESS_TYPE_SPI"] = 110;
        return values;
    })();

    /**
     * PowerSubtype enum.
     * @name quack.PowerSubtype
     * @enum {string}
     * @property {number} POWER_SUBTYPE_NONE=0 POWER_SUBTYPE_NONE value
     * @property {number} POWER_SUBTYPE_NO_BATTERY=1 POWER_SUBTYPE_NO_BATTERY value
     */
    quack.PowerSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "POWER_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "POWER_SUBTYPE_NO_BATTERY"] = 1;
        return values;
    })();

    /**
     * TemperatureSubtype enum.
     * @name quack.TemperatureSubtype
     * @enum {string}
     * @property {number} TEMPERATURE_SUBTYPE_NONE=0 TEMPERATURE_SUBTYPE_NONE value
     * @property {number} TEMPERATURE_SUBTYPE_ONEWIRE_DS18=1 TEMPERATURE_SUBTYPE_ONEWIRE_DS18 value
     * @property {number} TEMPERATURE_SUBTYPE_ANALOG=2 TEMPERATURE_SUBTYPE_ANALOG value
     */
    quack.TemperatureSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "TEMPERATURE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "TEMPERATURE_SUBTYPE_ONEWIRE_DS18"] = 1;
        values[valuesById[2] = "TEMPERATURE_SUBTYPE_ANALOG"] = 2;
        return values;
    })();

    /**
     * BooleanOutputSubtype enum.
     * @name quack.BooleanOutputSubtype
     * @enum {string}
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_NONE=0 BOOLEAN_OUTPUT_SUBTYPE_NONE value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_LED=1 BOOLEAN_OUTPUT_SUBTYPE_LED value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_HEATER=2 BOOLEAN_OUTPUT_SUBTYPE_HEATER value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_AERATION_FAN=3 BOOLEAN_OUTPUT_SUBTYPE_AERATION_FAN value
     * @property {number} BOOLEAN_OUTPUT_SUBTYPE_EXHAUST_FAN=4 BOOLEAN_OUTPUT_SUBTYPE_EXHAUST_FAN value
     */
    quack.BooleanOutputSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "BOOLEAN_OUTPUT_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "BOOLEAN_OUTPUT_SUBTYPE_LED"] = 1;
        values[valuesById[2] = "BOOLEAN_OUTPUT_SUBTYPE_HEATER"] = 2;
        values[valuesById[3] = "BOOLEAN_OUTPUT_SUBTYPE_AERATION_FAN"] = 3;
        values[valuesById[4] = "BOOLEAN_OUTPUT_SUBTYPE_EXHAUST_FAN"] = 4;
        return values;
    })();

    /**
     * EdgeTriggeredSubtype enum.
     * @name quack.EdgeTriggeredSubtype
     * @enum {string}
     * @property {number} EDGE_TRIGGERED_SUBTYPE_NONE=0 EDGE_TRIGGERED_SUBTYPE_NONE value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_DOOR=1 EDGE_TRIGGERED_SUBTYPE_DOOR value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_WATER=2 EDGE_TRIGGERED_SUBTYPE_WATER value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_RAIN=3 EDGE_TRIGGERED_SUBTYPE_RAIN value
     * @property {number} EDGE_TRIGGERED_SUBTYPE_WIND_SPEED=4 EDGE_TRIGGERED_SUBTYPE_WIND_SPEED value
     */
    quack.EdgeTriggeredSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "EDGE_TRIGGERED_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "EDGE_TRIGGERED_SUBTYPE_DOOR"] = 1;
        values[valuesById[2] = "EDGE_TRIGGERED_SUBTYPE_WATER"] = 2;
        values[valuesById[3] = "EDGE_TRIGGERED_SUBTYPE_RAIN"] = 3;
        values[valuesById[4] = "EDGE_TRIGGERED_SUBTYPE_WIND_SPEED"] = 4;
        return values;
    })();

    /**
     * PressureSubtype enum.
     * @name quack.PressureSubtype
     * @enum {string}
     * @property {number} PRESSURE_SUBTYPE_NONE=0 PRESSURE_SUBTYPE_NONE value
     * @property {number} PRESSURE_SUBTYPE_GAUGE=1 PRESSURE_SUBTYPE_GAUGE value
     * @property {number} PRESSURE_SUBTYPE_FROG=2 PRESSURE_SUBTYPE_FROG value
     */
    quack.PressureSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PRESSURE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "PRESSURE_SUBTYPE_GAUGE"] = 1;
        values[valuesById[2] = "PRESSURE_SUBTYPE_FROG"] = 2;
        return values;
    })();

    /**
     * DHTSubtype enum.
     * @name quack.DHTSubtype
     * @enum {string}
     * @property {number} DHT_SUBTYPE_NONE=0 DHT_SUBTYPE_NONE value
     * @property {number} DHT_SUBTYPE_22=1 DHT_SUBTYPE_22 value
     * @property {number} DHT_SUBTYPE_SHT20=2 DHT_SUBTYPE_SHT20 value
     * @property {number} DHT_SUBTYPE_FROG=3 DHT_SUBTYPE_FROG value
     * @property {number} DHT_SUBTYPE_SCD30=4 DHT_SUBTYPE_SCD30 value
     */
    quack.DHTSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DHT_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "DHT_SUBTYPE_22"] = 1;
        values[valuesById[2] = "DHT_SUBTYPE_SHT20"] = 2;
        values[valuesById[3] = "DHT_SUBTYPE_FROG"] = 3;
        values[valuesById[4] = "DHT_SUBTYPE_SCD30"] = 4;
        return values;
    })();

    /**
     * GrainCableSubtype enum.
     * @name quack.GrainCableSubtype
     * @enum {string}
     * @property {number} GRAIN_CABLE_SUBTYPE_NONE=0 GRAIN_CABLE_SUBTYPE_NONE value
     * @property {number} GRAIN_CABLE_SUBTYPE_FROG=1 GRAIN_CABLE_SUBTYPE_FROG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_TEMP=2 GRAIN_CABLE_SUBTYPE_OPI_TEMP value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_SHT35=3 GRAIN_CABLE_SUBTYPE_OPI_SHT35 value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_DIAG=4 GRAIN_CABLE_SUBTYPE_OPI_DIAG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_REPROG=5 GRAIN_CABLE_SUBTYPE_OPI_REPROG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_CABLE_DIAG=6 GRAIN_CABLE_SUBTYPE_OPI_CABLE_DIAG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_CABLE_REPROG=7 GRAIN_CABLE_SUBTYPE_OPI_CABLE_REPROG value
     * @property {number} GRAIN_CABLE_SUBTYPE_OPI_AUTOMATIC=8 GRAIN_CABLE_SUBTYPE_OPI_AUTOMATIC value
     * @property {number} GRAIN_CABLE_SUBTYPE_ANALOG=9 GRAIN_CABLE_SUBTYPE_ANALOG value
     */
    quack.GrainCableSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "GRAIN_CABLE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "GRAIN_CABLE_SUBTYPE_FROG"] = 1;
        values[valuesById[2] = "GRAIN_CABLE_SUBTYPE_OPI_TEMP"] = 2;
        values[valuesById[3] = "GRAIN_CABLE_SUBTYPE_OPI_SHT35"] = 3;
        values[valuesById[4] = "GRAIN_CABLE_SUBTYPE_OPI_DIAG"] = 4;
        values[valuesById[5] = "GRAIN_CABLE_SUBTYPE_OPI_REPROG"] = 5;
        values[valuesById[6] = "GRAIN_CABLE_SUBTYPE_OPI_CABLE_DIAG"] = 6;
        values[valuesById[7] = "GRAIN_CABLE_SUBTYPE_OPI_CABLE_REPROG"] = 7;
        values[valuesById[8] = "GRAIN_CABLE_SUBTYPE_OPI_AUTOMATIC"] = 8;
        values[valuesById[9] = "GRAIN_CABLE_SUBTYPE_ANALOG"] = 9;
        return values;
    })();

    /**
     * LidarSubtype enum.
     * @name quack.LidarSubtype
     * @enum {string}
     * @property {number} LIDAR_SUBTYPE_NONE=0 LIDAR_SUBTYPE_NONE value
     * @property {number} LIDAR_SUBTYPE_LONG_DISTANCE=1 LIDAR_SUBTYPE_LONG_DISTANCE value
     * @property {number} LIDAR_SUBTYPE_BENEWAKE_TF02W_MID_RANGE=2 LIDAR_SUBTYPE_BENEWAKE_TF02W_MID_RANGE value
     */
    quack.LidarSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "LIDAR_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "LIDAR_SUBTYPE_LONG_DISTANCE"] = 1;
        values[valuesById[2] = "LIDAR_SUBTYPE_BENEWAKE_TF02W_MID_RANGE"] = 2;
        return values;
    })();

    /**
     * CapacitorCableSubtype enum.
     * @name quack.CapacitorCableSubtype
     * @enum {string}
     * @property {number} CAPACITOR_CABLE_SUBTYPE_NONE=0 CAPACITOR_CABLE_SUBTYPE_NONE value
     * @property {number} CAPACITOR_CABLE_SUBTYPE_FROG=1 CAPACITOR_CABLE_SUBTYPE_FROG value
     */
    quack.CapacitorCableSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CAPACITOR_CABLE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "CAPACITOR_CABLE_SUBTYPE_FROG"] = 1;
        return values;
    })();

    /**
     * AnalogInputSubtype enum.
     * @name quack.AnalogInputSubtype
     * @enum {string}
     * @property {number} ANALOG_INPUT_SUBTYPE_NONE=0 ANALOG_INPUT_SUBTYPE_NONE value
     * @property {number} ANALOG_INPUT_SUBTYPE_FUEL=1 ANALOG_INPUT_SUBTYPE_FUEL value
     * @property {number} ANALOG_INPUT_SUBTYPE_WIND_SPEED=2 ANALOG_INPUT_SUBTYPE_WIND_SPEED value
     * @property {number} ANALOG_INPUT_SUBTYPE_WIND_DIRECTION=3 ANALOG_INPUT_SUBTYPE_WIND_DIRECTION value
     * @property {number} ANALOG_INPUT_SUBTYPE_CURRENT_TRANSFORMER=4 ANALOG_INPUT_SUBTYPE_CURRENT_TRANSFORMER value
     */
    quack.AnalogInputSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ANALOG_INPUT_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "ANALOG_INPUT_SUBTYPE_FUEL"] = 1;
        values[valuesById[2] = "ANALOG_INPUT_SUBTYPE_WIND_SPEED"] = 2;
        values[valuesById[3] = "ANALOG_INPUT_SUBTYPE_WIND_DIRECTION"] = 3;
        values[valuesById[4] = "ANALOG_INPUT_SUBTYPE_CURRENT_TRANSFORMER"] = 4;
        return values;
    })();

    /**
     * AirQualitySubtype enum.
     * @name quack.AirQualitySubtype
     * @enum {string}
     * @property {number} AIR_QUALITY_SUBTYPE_SGP30=0 AIR_QUALITY_SUBTYPE_SGP30 value
     */
    quack.AirQualitySubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AIR_QUALITY_SUBTYPE_SGP30"] = 0;
        return values;
    })();

    /**
     * CapacitanceSubtype enum.
     * @name quack.CapacitanceSubtype
     * @enum {string}
     * @property {number} CAPACITANCE_SUBTYPE_NONE=0 CAPACITANCE_SUBTYPE_NONE value
     * @property {number} CAPACITANCE_SUBTYPE_FDC=1 CAPACITANCE_SUBTYPE_FDC value
     */
    quack.CapacitanceSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CAPACITANCE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "CAPACITANCE_SUBTYPE_FDC"] = 1;
        return values;
    })();

    /**
     * DragerGasDongleSubtype enum.
     * @name quack.DragerGasDongleSubtype
     * @enum {string}
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_NONE=0 DRAGER_GAS_DONGLE_SUBTYPE_NONE value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_DEBUG_VOLTAGE=1 DRAGER_GAS_DONGLE_SUBTYPE_DEBUG_VOLTAGE value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_CO_CO2_NO2_O2=2 DRAGER_GAS_DONGLE_SUBTYPE_CO_CO2_NO2_O2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_CO=3 DRAGER_GAS_DONGLE_SUBTYPE_CO value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_CO2=4 DRAGER_GAS_DONGLE_SUBTYPE_CO2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_NO2=5 DRAGER_GAS_DONGLE_SUBTYPE_NO2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_O2=6 DRAGER_GAS_DONGLE_SUBTYPE_O2 value
     * @property {number} DRAGER_GAS_DONGLE_SUBTYPE_H2S=7 DRAGER_GAS_DONGLE_SUBTYPE_H2S value
     */
    quack.DragerGasDongleSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "DRAGER_GAS_DONGLE_SUBTYPE_NONE"] = 0;
        values[valuesById[1] = "DRAGER_GAS_DONGLE_SUBTYPE_DEBUG_VOLTAGE"] = 1;
        values[valuesById[2] = "DRAGER_GAS_DONGLE_SUBTYPE_CO_CO2_NO2_O2"] = 2;
        values[valuesById[3] = "DRAGER_GAS_DONGLE_SUBTYPE_CO"] = 3;
        values[valuesById[4] = "DRAGER_GAS_DONGLE_SUBTYPE_CO2"] = 4;
        values[valuesById[5] = "DRAGER_GAS_DONGLE_SUBTYPE_NO2"] = 5;
        values[valuesById[6] = "DRAGER_GAS_DONGLE_SUBTYPE_O2"] = 6;
        values[valuesById[7] = "DRAGER_GAS_DONGLE_SUBTYPE_H2S"] = 7;
        return values;
    })();

    /**
     * AirFlowSubtype enum.
     * @name quack.AirFlowSubtype
     * @enum {string}
     * @property {number} AIR_FLOW_SUBTYPE_PROSENSE=0 AIR_FLOW_SUBTYPE_PROSENSE value
     * @property {number} AIR_FLOW_SUBTYPE_ULTRASONIC=1 AIR_FLOW_SUBTYPE_ULTRASONIC value
     */
    quack.AirFlowSubtype = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "AIR_FLOW_SUBTYPE_PROSENSE"] = 0;
        values[valuesById[1] = "AIR_FLOW_SUBTYPE_ULTRASONIC"] = 1;
        return values;
    })();

    /**
     * OutputMode enum.
     * @name quack.OutputMode
     * @enum {string}
     * @property {number} OUTPUT_MODE_AUTO=0 OUTPUT_MODE_AUTO value
     * @property {number} OUTPUT_MODE_ON=1 OUTPUT_MODE_ON value
     * @property {number} OUTPUT_MODE_OFF=2 OUTPUT_MODE_OFF value
     */
    quack.OutputMode = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OUTPUT_MODE_AUTO"] = 0;
        values[valuesById[1] = "OUTPUT_MODE_ON"] = 1;
        values[valuesById[2] = "OUTPUT_MODE_OFF"] = 2;
        return values;
    })();

    quack.Calibration = (function() {

        /**
         * Properties of a Calibration.
         * @memberof quack
         * @interface ICalibration
         * @property {number|null} [calibrationCoefficient] Calibration calibrationCoefficient
         * @property {number|null} [calibrationOffset] Calibration calibrationOffset
         * @property {quack.MeasurementType|null} [measurementType] Calibration measurementType
         */

        /**
         * Constructs a new Calibration.
         * @memberof quack
         * @classdesc Represents a Calibration.
         * @implements ICalibration
         * @constructor
         * @param {quack.ICalibration=} [properties] Properties to set
         */
        function Calibration(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Calibration calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof quack.Calibration
         * @instance
         */
        Calibration.prototype.calibrationCoefficient = 0;

        /**
         * Calibration calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof quack.Calibration
         * @instance
         */
        Calibration.prototype.calibrationOffset = 0;

        /**
         * Calibration measurementType.
         * @member {quack.MeasurementType} measurementType
         * @memberof quack.Calibration
         * @instance
         */
        Calibration.prototype.measurementType = 0;

        /**
         * Creates a new Calibration instance using the specified properties.
         * @function create
         * @memberof quack.Calibration
         * @static
         * @param {quack.ICalibration=} [properties] Properties to set
         * @returns {quack.Calibration} Calibration instance
         */
        Calibration.create = function create(properties) {
            return new Calibration(properties);
        };

        /**
         * Creates a Calibration message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Calibration
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Calibration} Calibration
         */
        Calibration.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Calibration)
                return object;
            var message = new $root.quack.Calibration();
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            switch (object.measurementType) {
            case "MEASUREMENT_TYPE_INVALID":
            case 0:
                message.measurementType = 0;
                break;
            case "MEASUREMENT_TYPE_TEMPERATURE":
            case 1:
                message.measurementType = 1;
                break;
            case "MEASUREMENT_TYPE_BOOLEAN":
            case 2:
                message.measurementType = 2;
                break;
            case "MEASUREMENT_TYPE_VOLTAGE":
            case 3:
                message.measurementType = 3;
                break;
            case "MEASUREMENT_TYPE_PERCENT":
            case 4:
                message.measurementType = 4;
                break;
            case "MEASUREMENT_TYPE_PRESSURE":
            case 5:
                message.measurementType = 5;
                break;
            case "MEASUREMENT_TYPE_RSSI":
            case 6:
                message.measurementType = 6;
                break;
            case "MEASUREMENT_TYPE_LIGHT":
            case 7:
                message.measurementType = 7;
                break;
            case "MEASUREMENT_TYPE_PPM":
            case 8:
                message.measurementType = 8;
                break;
            case "MEASUREMENT_TYPE_ANALOG":
            case 9:
                message.measurementType = 9;
                break;
            case "MEASUREMENT_TYPE_ORP":
            case 10:
                message.measurementType = 10;
                break;
            case "MEASUREMENT_TYPE_PH":
            case 11:
                message.measurementType = 11;
                break;
            case "MEASUREMENT_TYPE_PPB":
            case 12:
                message.measurementType = 12;
                break;
            case "MEASUREMENT_TYPE_CONDUCTIVITY":
            case 13:
                message.measurementType = 13;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE":
            case 14:
                message.measurementType = 14;
                break;
            case "MEASUREMENT_TYPE_WEIGHT":
            case 15:
                message.measurementType = 15;
                break;
            case "MEASUREMENT_TYPE_DISTANCE_CM":
            case 16:
                message.measurementType = 16;
                break;
            case "MEASUREMENT_TYPE_SPEED":
            case 17:
                message.measurementType = 17;
                break;
            case "MEASUREMENT_TYPE_RAIN":
            case 18:
                message.measurementType = 18;
                break;
            case "MEASUREMENT_TYPE_GRAIN_EMC":
            case 19:
                message.measurementType = 19;
                break;
            case "MEASUREMENT_TYPE_EDGE_RISES":
            case 20:
                message.measurementType = 20;
                break;
            case "MEASUREMENT_TYPE_EDGE_FALLS":
            case 21:
                message.measurementType = 21;
                break;
            case "MEASUREMENT_TYPE_STATE_CHANGES":
            case 22:
                message.measurementType = 22;
                break;
            case "MEASUREMENT_TYPE_FULL_SPECTRUM":
            case 23:
                message.measurementType = 23;
                break;
            case "MEASUREMENT_TYPE_INFRARED":
            case 24:
                message.measurementType = 24;
                break;
            case "MEASUREMENT_TYPE_LUX":
            case 25:
                message.measurementType = 25;
                break;
            case "MEASUREMENT_TYPE_VISIBLE_LIGHT":
            case 26:
                message.measurementType = 26;
                break;
            case "MEASUREMENT_TYPE_CFM":
            case 29:
                message.measurementType = 29;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_GND_FF":
            case 27:
                message.measurementType = 27;
                break;
            case "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF":
            case 28:
                message.measurementType = 28;
                break;
            case "MEASUREMENT_TYPE_DUST_1UG":
            case 30:
                message.measurementType = 30;
                break;
            case "MEASUREMENT_TYPE_DUST_2UG":
            case 31:
                message.measurementType = 31;
                break;
            case "MEASUREMENT_TYPE_DUST_4UG":
            case 32:
                message.measurementType = 32;
                break;
            case "MEASUREMENT_TYPE_DUST_10UG":
            case 33:
                message.measurementType = 33;
                break;
            case "MEASUREMENT_TYPE_VOC_INDEX":
            case 34:
                message.measurementType = 34;
                break;
            case "MEASUREMENT_TYPE_NOX_INDEX":
            case 35:
                message.measurementType = 35;
                break;
            case "MEASUREMENT_TYPE_FREQUENCY":
            case 36:
                message.measurementType = 36;
                break;
            case "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS":
            case 37:
                message.measurementType = 37;
                break;
            case "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS":
            case 38:
                message.measurementType = 38;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_CABLE":
            case 39:
                message.measurementType = 39;
                break;
            case "MEASUREMENT_TYPE_BUSHEL_LIDAR":
            case 40:
                message.measurementType = 40;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a Calibration message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Calibration
         * @static
         * @param {quack.Calibration} message Calibration
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Calibration.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
                object.measurementType = options.enums === String ? "MEASUREMENT_TYPE_INVALID" : 0;
            }
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = options.enums === String ? $root.quack.MeasurementType[message.measurementType] : message.measurementType;
            return object;
        };

        /**
         * Converts this Calibration to JSON.
         * @function toJSON
         * @memberof quack.Calibration
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Calibration.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Calibration;
    })();

    quack.Component = (function() {

        /**
         * Properties of a Component.
         * @memberof quack
         * @interface IComponent
         * @property {number|null} [type] Component type
         * @property {number|null} [subtype] Component subtype
         * @property {string|null} [name] Component name
         * @property {number|null} [reportPeriodMs] Component reportPeriodMs
         * @property {number|null} [measurementPeriodMs] Component measurementPeriodMs
         * @property {number|null} [defaultOutputState] Component defaultOutputState
         * @property {number|null} [minCycleTimeMs] Component minCycleTimeMs
         * @property {number|null} [addressType] Component addressType
         * @property {number|null} [address] Component address
         * @property {boolean|null} [calibrate] Component calibrate
         * @property {number|null} [calibrationCoefficient] Component calibrationCoefficient
         * @property {number|null} [calibrationOffset] Component calibrationOffset
         * @property {Array.<quack.Calibration>|null} [calibrations] Component calibrations
         */

        /**
         * Constructs a new Component.
         * @memberof quack
         * @classdesc Represents a Component.
         * @implements IComponent
         * @constructor
         * @param {quack.IComponent=} [properties] Properties to set
         */
        function Component(properties) {
            this.calibrations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Component type.
         * @member {number} type
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.type = 0;

        /**
         * Component subtype.
         * @member {number} subtype
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.subtype = 0;

        /**
         * Component name.
         * @member {string} name
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.name = "";

        /**
         * Component reportPeriodMs.
         * @member {number} reportPeriodMs
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.reportPeriodMs = 0;

        /**
         * Component measurementPeriodMs.
         * @member {number} measurementPeriodMs
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.measurementPeriodMs = 0;

        /**
         * Component defaultOutputState.
         * @member {number} defaultOutputState
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.defaultOutputState = 0;

        /**
         * Component minCycleTimeMs.
         * @member {number} minCycleTimeMs
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.minCycleTimeMs = 0;

        /**
         * Component addressType.
         * @member {number} addressType
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.addressType = 0;

        /**
         * Component address.
         * @member {number} address
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.address = 0;

        /**
         * Component calibrate.
         * @member {boolean} calibrate
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrate = false;

        /**
         * Component calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrationCoefficient = 0;

        /**
         * Component calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrationOffset = 0;

        /**
         * Component calibrations.
         * @member {Array.<quack.Calibration>} calibrations
         * @memberof quack.Component
         * @instance
         */
        Component.prototype.calibrations = $util.emptyArray;

        /**
         * Creates a new Component instance using the specified properties.
         * @function create
         * @memberof quack.Component
         * @static
         * @param {quack.IComponent=} [properties] Properties to set
         * @returns {quack.Component} Component instance
         */
        Component.create = function create(properties) {
            return new Component(properties);
        };

        /**
         * Creates a Component message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Component
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Component} Component
         */
        Component.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Component)
                return object;
            var message = new $root.quack.Component();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.name != null)
                message.name = String(object.name);
            if (object.reportPeriodMs != null)
                message.reportPeriodMs = object.reportPeriodMs >>> 0;
            if (object.measurementPeriodMs != null)
                message.measurementPeriodMs = object.measurementPeriodMs >>> 0;
            if (object.defaultOutputState != null)
                message.defaultOutputState = object.defaultOutputState >>> 0;
            if (object.minCycleTimeMs != null)
                message.minCycleTimeMs = object.minCycleTimeMs >>> 0;
            if (object.addressType != null)
                message.addressType = object.addressType >>> 0;
            if (object.address != null)
                message.address = object.address >>> 0;
            if (object.calibrate != null)
                message.calibrate = Boolean(object.calibrate);
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            if (object.calibrations) {
                if (!Array.isArray(object.calibrations))
                    throw TypeError(".quack.Component.calibrations: array expected");
                message.calibrations = [];
                for (var i = 0; i < object.calibrations.length; ++i) {
                    if (typeof object.calibrations[i] !== "object")
                        throw TypeError(".quack.Component.calibrations: object expected");
                    message.calibrations[i] = $root.quack.Calibration.fromObject(object.calibrations[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Component message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Component
         * @static
         * @param {quack.Component} message Component
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Component.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.calibrations = [];
            if (options.defaults) {
                object.type = 0;
                object.subtype = 0;
                object.name = "";
                object.reportPeriodMs = 0;
                object.measurementPeriodMs = 0;
                object.defaultOutputState = 0;
                object.minCycleTimeMs = 0;
                object.addressType = 0;
                object.address = 0;
                object.calibrate = false;
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.reportPeriodMs != null && message.hasOwnProperty("reportPeriodMs"))
                object.reportPeriodMs = message.reportPeriodMs;
            if (message.measurementPeriodMs != null && message.hasOwnProperty("measurementPeriodMs"))
                object.measurementPeriodMs = message.measurementPeriodMs;
            if (message.defaultOutputState != null && message.hasOwnProperty("defaultOutputState"))
                object.defaultOutputState = message.defaultOutputState;
            if (message.minCycleTimeMs != null && message.hasOwnProperty("minCycleTimeMs"))
                object.minCycleTimeMs = message.minCycleTimeMs;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.calibrate != null && message.hasOwnProperty("calibrate"))
                object.calibrate = message.calibrate;
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            if (message.calibrations && message.calibrations.length) {
                object.calibrations = [];
                for (var j = 0; j < message.calibrations.length; ++j)
                    object.calibrations[j] = $root.quack.Calibration.toObject(message.calibrations[j], options);
            }
            return object;
        };

        /**
         * Converts this Component to JSON.
         * @function toJSON
         * @memberof quack.Component
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Component.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Component;
    })();

    quack.VirtualComponent = (function() {

        /**
         * Properties of a VirtualComponent.
         * @memberof quack
         * @interface IVirtualComponent
         * @property {number|null} [type] VirtualComponent type
         * @property {number|null} [subtype] VirtualComponent subtype
         * @property {number|null} [addressType] VirtualComponent addressType
         * @property {number|null} [address] VirtualComponent address
         * @property {boolean|null} [calibrate] VirtualComponent calibrate
         * @property {number|null} [calibrationCoefficient] VirtualComponent calibrationCoefficient
         * @property {number|null} [calibrationOffset] VirtualComponent calibrationOffset
         */

        /**
         * Constructs a new VirtualComponent.
         * @memberof quack
         * @classdesc Represents a VirtualComponent.
         * @implements IVirtualComponent
         * @constructor
         * @param {quack.IVirtualComponent=} [properties] Properties to set
         */
        function VirtualComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VirtualComponent type.
         * @member {number} type
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.type = 0;

        /**
         * VirtualComponent subtype.
         * @member {number} subtype
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.subtype = 0;

        /**
         * VirtualComponent addressType.
         * @member {number} addressType
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.addressType = 0;

        /**
         * VirtualComponent address.
         * @member {number} address
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.address = 0;

        /**
         * VirtualComponent calibrate.
         * @member {boolean} calibrate
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.calibrate = false;

        /**
         * VirtualComponent calibrationCoefficient.
         * @member {number} calibrationCoefficient
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.calibrationCoefficient = 0;

        /**
         * VirtualComponent calibrationOffset.
         * @member {number} calibrationOffset
         * @memberof quack.VirtualComponent
         * @instance
         */
        VirtualComponent.prototype.calibrationOffset = 0;

        /**
         * Creates a new VirtualComponent instance using the specified properties.
         * @function create
         * @memberof quack.VirtualComponent
         * @static
         * @param {quack.IVirtualComponent=} [properties] Properties to set
         * @returns {quack.VirtualComponent} VirtualComponent instance
         */
        VirtualComponent.create = function create(properties) {
            return new VirtualComponent(properties);
        };

        /**
         * Creates a VirtualComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VirtualComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VirtualComponent} VirtualComponent
         */
        VirtualComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VirtualComponent)
                return object;
            var message = new $root.quack.VirtualComponent();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.addressType != null)
                message.addressType = object.addressType >>> 0;
            if (object.address != null)
                message.address = object.address >>> 0;
            if (object.calibrate != null)
                message.calibrate = Boolean(object.calibrate);
            if (object.calibrationCoefficient != null)
                message.calibrationCoefficient = Number(object.calibrationCoefficient);
            if (object.calibrationOffset != null)
                message.calibrationOffset = Number(object.calibrationOffset);
            return message;
        };

        /**
         * Creates a plain object from a VirtualComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VirtualComponent
         * @static
         * @param {quack.VirtualComponent} message VirtualComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VirtualComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = 0;
                object.subtype = 0;
                object.addressType = 0;
                object.address = 0;
                object.calibrate = false;
                object.calibrationCoefficient = 0;
                object.calibrationOffset = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            if (message.calibrate != null && message.hasOwnProperty("calibrate"))
                object.calibrate = message.calibrate;
            if (message.calibrationCoefficient != null && message.hasOwnProperty("calibrationCoefficient"))
                object.calibrationCoefficient = options.json && !isFinite(message.calibrationCoefficient) ? String(message.calibrationCoefficient) : message.calibrationCoefficient;
            if (message.calibrationOffset != null && message.hasOwnProperty("calibrationOffset"))
                object.calibrationOffset = options.json && !isFinite(message.calibrationOffset) ? String(message.calibrationOffset) : message.calibrationOffset;
            return object;
        };

        /**
         * Converts this VirtualComponent to JSON.
         * @function toJSON
         * @memberof quack.VirtualComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VirtualComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VirtualComponent;
    })();

    quack.ComponentID = (function() {

        /**
         * Properties of a ComponentID.
         * @memberof quack
         * @interface IComponentID
         * @property {quack.ComponentType|null} [type] ComponentID type
         * @property {quack.AddressType|null} [addressType] ComponentID addressType
         * @property {number|null} [address] ComponentID address
         */

        /**
         * Constructs a new ComponentID.
         * @memberof quack
         * @classdesc Represents a ComponentID.
         * @implements IComponentID
         * @constructor
         * @param {quack.IComponentID=} [properties] Properties to set
         */
        function ComponentID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComponentID type.
         * @member {quack.ComponentType} type
         * @memberof quack.ComponentID
         * @instance
         */
        ComponentID.prototype.type = 0;

        /**
         * ComponentID addressType.
         * @member {quack.AddressType} addressType
         * @memberof quack.ComponentID
         * @instance
         */
        ComponentID.prototype.addressType = 0;

        /**
         * ComponentID address.
         * @member {number} address
         * @memberof quack.ComponentID
         * @instance
         */
        ComponentID.prototype.address = 0;

        /**
         * Creates a new ComponentID instance using the specified properties.
         * @function create
         * @memberof quack.ComponentID
         * @static
         * @param {quack.IComponentID=} [properties] Properties to set
         * @returns {quack.ComponentID} ComponentID instance
         */
        ComponentID.create = function create(properties) {
            return new ComponentID(properties);
        };

        /**
         * Creates a ComponentID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.ComponentID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.ComponentID} ComponentID
         */
        ComponentID.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.ComponentID)
                return object;
            var message = new $root.quack.ComponentID();
            switch (object.type) {
            case "COMPONENT_TYPE_INVALID":
            case 0:
                message.type = 0;
                break;
            case "COMPONENT_TYPE_POWER":
            case 1:
                message.type = 1;
                break;
            case "COMPONENT_TYPE_TEMPERATURE":
            case 2:
                message.type = 2;
                break;
            case "COMPONENT_TYPE_BOOLEAN_OUTPUT":
            case 3:
                message.type = 3;
                break;
            case "COMPONENT_TYPE_EDGE_TRIGGERED":
            case 4:
                message.type = 4;
                break;
            case "COMPONENT_TYPE_GRAIN_CABLE":
            case 5:
                message.type = 5;
                break;
            case "COMPONENT_TYPE_PRESSURE":
            case 6:
                message.type = 6;
                break;
            case "COMPONENT_TYPE_GPS":
            case 7:
                message.type = 7;
                break;
            case "COMPONENT_TYPE_BOOLEAN_INPUT":
            case 8:
                message.type = 8;
                break;
            case "COMPONENT_TYPE_DHT":
            case 9:
                message.type = 9;
                break;
            case "COMPONENT_TYPE_MODEM":
            case 10:
                message.type = 10;
                break;
            case "COMPONENT_TYPE_LIGHT":
            case 11:
                message.type = 11;
                break;
            case "COMPONENT_TYPE_CO2":
            case 12:
                message.type = 12;
                break;
            case "COMPONENT_TYPE_STEPPER_MOTOR":
            case 13:
                message.type = 13;
                break;
            case "COMPONENT_TYPE_ANALOG_INPUT":
            case 14:
                message.type = 14;
                break;
            case "COMPONENT_TYPE_O2":
            case 15:
                message.type = 15;
                break;
            case "COMPONENT_TYPE_ETHYLENE":
            case 16:
                message.type = 16;
                break;
            case "COMPONENT_TYPE_ORP":
            case 17:
                message.type = 17;
                break;
            case "COMPONENT_TYPE_PH":
            case 18:
                message.type = 18;
                break;
            case "COMPONENT_TYPE_VOLTAGE":
            case 19:
                message.type = 19;
                break;
            case "COMPONENT_TYPE_CALCIUM":
            case 20:
                message.type = 20;
                break;
            case "COMPONENT_TYPE_NITRATE":
            case 21:
                message.type = 21;
                break;
            case "COMPONENT_TYPE_POTASSIUM":
            case 22:
                message.type = 22;
                break;
            case "COMPONENT_TYPE_CONDUCTIVITY":
            case 23:
                message.type = 23;
                break;
            case "COMPONENT_TYPE_CAPACITANCE":
            case 24:
                message.type = 24;
                break;
            case "COMPONENT_TYPE_VAPOUR_PRESSURE_DEFICIT":
            case 25:
                message.type = 25;
                break;
            case "COMPONENT_TYPE_WEIGHT":
            case 26:
                message.type = 26;
                break;
            case "COMPONENT_TYPE_AIR_QUALITY":
            case 27:
                message.type = 27;
                break;
            case "COMPONENT_TYPE_LIDAR":
            case 28:
                message.type = 28;
                break;
            case "COMPONENT_TYPE_PRESSURE_CABLE":
            case 29:
                message.type = 29;
                break;
            case "COMPONENT_TYPE_INTERNAL_FUNCTION":
            case 30:
                message.type = 30;
                break;
            case "COMPONENT_TYPE_CAPACITOR_CABLE":
            case 31:
                message.type = 31;
                break;
            case "COMPONENT_TYPE_SEN5X":
            case 32:
                message.type = 32;
                break;
            case "COMPONENT_TYPE_VIBRATION_CHAIN":
            case 33:
                message.type = 33;
                break;
            case "COMPONENT_TYPE_DRAGER_GAS_DONGLE":
            case 34:
                message.type = 34;
                break;
            case "COMPONENT_TYPE_AIRFLOW":
            case 35:
                message.type = 35;
                break;
            }
            switch (object.addressType) {
            case "ADDRESS_TYPE_INVALID":
            case 0:
                message.addressType = 0;
                break;
            case "ADDRESS_TYPE_CONFIGURABLE_PIN_ARRAY":
            case 1:
                message.addressType = 1;
                break;
            case "ADDRESS_TYPE_I2C":
            case 2:
                message.addressType = 2;
                break;
            case "ADDRESS_TYPE_DAC":
            case 3:
                message.addressType = 3;
                break;
            case "ADDRESS_TYPE_POWER":
            case 4:
                message.addressType = 4;
                break;
            case "ADDRESS_TYPE_GPS":
            case 5:
                message.addressType = 5;
                break;
            case "ADDRESS_TYPE_MODEM":
            case 6:
                message.addressType = 6;
                break;
            case "ADDRESS_TYPE_I2C_WITH_CHANNELS":
            case 7:
                message.addressType = 7;
                break;
            case "ADDRESS_TYPE_INCREMENTAL":
            case 8:
                message.addressType = 8;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET1":
            case 9:
                message.addressType = 9;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET2":
            case 10:
                message.addressType = 10;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET3":
            case 11:
                message.addressType = 11;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET4":
            case 12:
                message.addressType = 12;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET5":
            case 13:
                message.addressType = 13;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET6":
            case 14:
                message.addressType = 14;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET7":
            case 15:
                message.addressType = 15;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET8":
            case 16:
                message.addressType = 16;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET9":
            case 17:
                message.addressType = 17;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET10":
            case 18:
                message.addressType = 18;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET11":
            case 19:
                message.addressType = 19;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET12":
            case 20:
                message.addressType = 20;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET13":
            case 21:
                message.addressType = 21;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET14":
            case 22:
                message.addressType = 22;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET15":
            case 23:
                message.addressType = 23;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET16":
            case 24:
                message.addressType = 24;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET17":
            case 25:
                message.addressType = 25;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET18":
            case 26:
                message.addressType = 26;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET19":
            case 27:
                message.addressType = 27;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET20":
            case 28:
                message.addressType = 28;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET21":
            case 29:
                message.addressType = 29;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET22":
            case 30:
                message.addressType = 30;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET23":
            case 31:
                message.addressType = 31;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET24":
            case 32:
                message.addressType = 32;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET25":
            case 33:
                message.addressType = 33;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET26":
            case 34:
                message.addressType = 34;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET27":
            case 35:
                message.addressType = 35;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET28":
            case 36:
                message.addressType = 36;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET29":
            case 37:
                message.addressType = 37;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET30":
            case 38:
                message.addressType = 38;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET31":
            case 39:
                message.addressType = 39;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET32":
            case 40:
                message.addressType = 40;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET33":
            case 41:
                message.addressType = 41;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET34":
            case 42:
                message.addressType = 42;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET35":
            case 43:
                message.addressType = 43;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET36":
            case 44:
                message.addressType = 44;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET37":
            case 45:
                message.addressType = 45;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET38":
            case 46:
                message.addressType = 46;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET39":
            case 47:
                message.addressType = 47;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET40":
            case 48:
                message.addressType = 48;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET41":
            case 49:
                message.addressType = 49;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET42":
            case 50:
                message.addressType = 50;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET43":
            case 51:
                message.addressType = 51;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET44":
            case 52:
                message.addressType = 52;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET45":
            case 53:
                message.addressType = 53;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET46":
            case 54:
                message.addressType = 54;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET47":
            case 55:
                message.addressType = 55;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET48":
            case 56:
                message.addressType = 56;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET49":
            case 57:
                message.addressType = 57;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET50":
            case 58:
                message.addressType = 58;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET51":
            case 59:
                message.addressType = 59;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET52":
            case 60:
                message.addressType = 60;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET53":
            case 61:
                message.addressType = 61;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET54":
            case 62:
                message.addressType = 62;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET55":
            case 63:
                message.addressType = 63;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET56":
            case 64:
                message.addressType = 64;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET57":
            case 65:
                message.addressType = 65;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET58":
            case 66:
                message.addressType = 66;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET59":
            case 67:
                message.addressType = 67;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET60":
            case 68:
                message.addressType = 68;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET61":
            case 69:
                message.addressType = 69;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET62":
            case 70:
                message.addressType = 70;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET63":
            case 71:
                message.addressType = 71;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET64":
            case 72:
                message.addressType = 72;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET65":
            case 73:
                message.addressType = 73;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET66":
            case 74:
                message.addressType = 74;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET67":
            case 75:
                message.addressType = 75;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET68":
            case 76:
                message.addressType = 76;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET69":
            case 77:
                message.addressType = 77;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET70":
            case 78:
                message.addressType = 78;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET71":
            case 79:
                message.addressType = 79;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET72":
            case 80:
                message.addressType = 80;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET73":
            case 81:
                message.addressType = 81;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET74":
            case 82:
                message.addressType = 82;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET75":
            case 83:
                message.addressType = 83;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET76":
            case 84:
                message.addressType = 84;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET77":
            case 85:
                message.addressType = 85;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET78":
            case 86:
                message.addressType = 86;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET79":
            case 87:
                message.addressType = 87;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET80":
            case 88:
                message.addressType = 88;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET81":
            case 89:
                message.addressType = 89;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET82":
            case 90:
                message.addressType = 90;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET83":
            case 91:
                message.addressType = 91;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET84":
            case 92:
                message.addressType = 92;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET85":
            case 93:
                message.addressType = 93;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET86":
            case 94:
                message.addressType = 94;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET87":
            case 95:
                message.addressType = 95;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET88":
            case 96:
                message.addressType = 96;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET89":
            case 97:
                message.addressType = 97;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET90":
            case 98:
                message.addressType = 98;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET91":
            case 99:
                message.addressType = 99;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET92":
            case 100:
                message.addressType = 100;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET93":
            case 101:
                message.addressType = 101;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET94":
            case 102:
                message.addressType = 102;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET95":
            case 103:
                message.addressType = 103;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET96":
            case 104:
                message.addressType = 104;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET97":
            case 105:
                message.addressType = 105;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET98":
            case 106:
                message.addressType = 106;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET99":
            case 107:
                message.addressType = 107;
                break;
            case "ADDRESS_TYPE_PIN_OFFSET100":
            case 108:
                message.addressType = 108;
                break;
            case "ADDRESS_TYPE_INTERNAL_SLEEP":
            case 109:
                message.addressType = 109;
                break;
            case "ADDRESS_TYPE_SPI":
            case 110:
                message.addressType = 110;
                break;
            }
            if (object.address != null)
                message.address = object.address >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a ComponentID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.ComponentID
         * @static
         * @param {quack.ComponentID} message ComponentID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComponentID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = options.enums === String ? "COMPONENT_TYPE_INVALID" : 0;
                object.addressType = options.enums === String ? "ADDRESS_TYPE_INVALID" : 0;
                object.address = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.quack.ComponentType[message.type] : message.type;
            if (message.addressType != null && message.hasOwnProperty("addressType"))
                object.addressType = options.enums === String ? $root.quack.AddressType[message.addressType] : message.addressType;
            if (message.address != null && message.hasOwnProperty("address"))
                object.address = message.address;
            return object;
        };

        /**
         * Converts this ComponentID to JSON.
         * @function toJSON
         * @memberof quack.ComponentID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComponentID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComponentID;
    })();

    quack.AddComponent = (function() {

        /**
         * Properties of an AddComponent.
         * @memberof quack
         * @interface IAddComponent
         * @property {quack.Component|null} [component] AddComponent component
         */

        /**
         * Constructs a new AddComponent.
         * @memberof quack
         * @classdesc Represents an AddComponent.
         * @implements IAddComponent
         * @constructor
         * @param {quack.IAddComponent=} [properties] Properties to set
         */
        function AddComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddComponent component.
         * @member {quack.Component|null|undefined} component
         * @memberof quack.AddComponent
         * @instance
         */
        AddComponent.prototype.component = null;

        /**
         * Creates a new AddComponent instance using the specified properties.
         * @function create
         * @memberof quack.AddComponent
         * @static
         * @param {quack.IAddComponent=} [properties] Properties to set
         * @returns {quack.AddComponent} AddComponent instance
         */
        AddComponent.create = function create(properties) {
            return new AddComponent(properties);
        };

        /**
         * Creates an AddComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddComponent} AddComponent
         */
        AddComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddComponent)
                return object;
            var message = new $root.quack.AddComponent();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.AddComponent.component: object expected");
                message.component = $root.quack.Component.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddComponent
         * @static
         * @param {quack.AddComponent} message AddComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.Component.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this AddComponent to JSON.
         * @function toJSON
         * @memberof quack.AddComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddComponent;
    })();

    quack.AddVirtualComponent = (function() {

        /**
         * Properties of an AddVirtualComponent.
         * @memberof quack
         * @interface IAddVirtualComponent
         * @property {quack.VirtualComponent|null} [component] AddVirtualComponent component
         */

        /**
         * Constructs a new AddVirtualComponent.
         * @memberof quack
         * @classdesc Represents an AddVirtualComponent.
         * @implements IAddVirtualComponent
         * @constructor
         * @param {quack.IAddVirtualComponent=} [properties] Properties to set
         */
        function AddVirtualComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddVirtualComponent component.
         * @member {quack.VirtualComponent|null|undefined} component
         * @memberof quack.AddVirtualComponent
         * @instance
         */
        AddVirtualComponent.prototype.component = null;

        /**
         * Creates a new AddVirtualComponent instance using the specified properties.
         * @function create
         * @memberof quack.AddVirtualComponent
         * @static
         * @param {quack.IAddVirtualComponent=} [properties] Properties to set
         * @returns {quack.AddVirtualComponent} AddVirtualComponent instance
         */
        AddVirtualComponent.create = function create(properties) {
            return new AddVirtualComponent(properties);
        };

        /**
         * Creates an AddVirtualComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddVirtualComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddVirtualComponent} AddVirtualComponent
         */
        AddVirtualComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddVirtualComponent)
                return object;
            var message = new $root.quack.AddVirtualComponent();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.AddVirtualComponent.component: object expected");
                message.component = $root.quack.VirtualComponent.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddVirtualComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddVirtualComponent
         * @static
         * @param {quack.AddVirtualComponent} message AddVirtualComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddVirtualComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.VirtualComponent.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this AddVirtualComponent to JSON.
         * @function toJSON
         * @memberof quack.AddVirtualComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddVirtualComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddVirtualComponent;
    })();

    quack.RemoveComponent = (function() {

        /**
         * Properties of a RemoveComponent.
         * @memberof quack
         * @interface IRemoveComponent
         * @property {quack.ComponentID|null} [id] RemoveComponent id
         */

        /**
         * Constructs a new RemoveComponent.
         * @memberof quack
         * @classdesc Represents a RemoveComponent.
         * @implements IRemoveComponent
         * @constructor
         * @param {quack.IRemoveComponent=} [properties] Properties to set
         */
        function RemoveComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveComponent id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.RemoveComponent
         * @instance
         */
        RemoveComponent.prototype.id = null;

        /**
         * Creates a new RemoveComponent instance using the specified properties.
         * @function create
         * @memberof quack.RemoveComponent
         * @static
         * @param {quack.IRemoveComponent=} [properties] Properties to set
         * @returns {quack.RemoveComponent} RemoveComponent instance
         */
        RemoveComponent.create = function create(properties) {
            return new RemoveComponent(properties);
        };

        /**
         * Creates a RemoveComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.RemoveComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.RemoveComponent} RemoveComponent
         */
        RemoveComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.RemoveComponent)
                return object;
            var message = new $root.quack.RemoveComponent();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.RemoveComponent.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            return message;
        };

        /**
         * Creates a plain object from a RemoveComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.RemoveComponent
         * @static
         * @param {quack.RemoveComponent} message RemoveComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            return object;
        };

        /**
         * Converts this RemoveComponent to JSON.
         * @function toJSON
         * @memberof quack.RemoveComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveComponent;
    })();

    quack.UpdateVirtualComponent = (function() {

        /**
         * Properties of an UpdateVirtualComponent.
         * @memberof quack
         * @interface IUpdateVirtualComponent
         * @property {quack.VirtualComponent|null} [component] UpdateVirtualComponent component
         */

        /**
         * Constructs a new UpdateVirtualComponent.
         * @memberof quack
         * @classdesc Represents an UpdateVirtualComponent.
         * @implements IUpdateVirtualComponent
         * @constructor
         * @param {quack.IUpdateVirtualComponent=} [properties] Properties to set
         */
        function UpdateVirtualComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateVirtualComponent component.
         * @member {quack.VirtualComponent|null|undefined} component
         * @memberof quack.UpdateVirtualComponent
         * @instance
         */
        UpdateVirtualComponent.prototype.component = null;

        /**
         * Creates a new UpdateVirtualComponent instance using the specified properties.
         * @function create
         * @memberof quack.UpdateVirtualComponent
         * @static
         * @param {quack.IUpdateVirtualComponent=} [properties] Properties to set
         * @returns {quack.UpdateVirtualComponent} UpdateVirtualComponent instance
         */
        UpdateVirtualComponent.create = function create(properties) {
            return new UpdateVirtualComponent(properties);
        };

        /**
         * Creates an UpdateVirtualComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateVirtualComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateVirtualComponent} UpdateVirtualComponent
         */
        UpdateVirtualComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateVirtualComponent)
                return object;
            var message = new $root.quack.UpdateVirtualComponent();
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.UpdateVirtualComponent.component: object expected");
                message.component = $root.quack.VirtualComponent.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateVirtualComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateVirtualComponent
         * @static
         * @param {quack.UpdateVirtualComponent} message UpdateVirtualComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateVirtualComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.component = null;
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.VirtualComponent.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this UpdateVirtualComponent to JSON.
         * @function toJSON
         * @memberof quack.UpdateVirtualComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateVirtualComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateVirtualComponent;
    })();

    quack.UpdateComponent = (function() {

        /**
         * Properties of an UpdateComponent.
         * @memberof quack
         * @interface IUpdateComponent
         * @property {quack.ComponentID|null} [id] UpdateComponent id
         * @property {quack.Component|null} [component] UpdateComponent component
         */

        /**
         * Constructs a new UpdateComponent.
         * @memberof quack
         * @classdesc Represents an UpdateComponent.
         * @implements IUpdateComponent
         * @constructor
         * @param {quack.IUpdateComponent=} [properties] Properties to set
         */
        function UpdateComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateComponent id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.UpdateComponent
         * @instance
         */
        UpdateComponent.prototype.id = null;

        /**
         * UpdateComponent component.
         * @member {quack.Component|null|undefined} component
         * @memberof quack.UpdateComponent
         * @instance
         */
        UpdateComponent.prototype.component = null;

        /**
         * Creates a new UpdateComponent instance using the specified properties.
         * @function create
         * @memberof quack.UpdateComponent
         * @static
         * @param {quack.IUpdateComponent=} [properties] Properties to set
         * @returns {quack.UpdateComponent} UpdateComponent instance
         */
        UpdateComponent.create = function create(properties) {
            return new UpdateComponent(properties);
        };

        /**
         * Creates an UpdateComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateComponent} UpdateComponent
         */
        UpdateComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateComponent)
                return object;
            var message = new $root.quack.UpdateComponent();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.UpdateComponent.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            if (object.component != null) {
                if (typeof object.component !== "object")
                    throw TypeError(".quack.UpdateComponent.component: object expected");
                message.component = $root.quack.Component.fromObject(object.component);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateComponent
         * @static
         * @param {quack.UpdateComponent} message UpdateComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = null;
                object.component = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            if (message.component != null && message.hasOwnProperty("component"))
                object.component = $root.quack.Component.toObject(message.component, options);
            return object;
        };

        /**
         * Converts this UpdateComponent to JSON.
         * @function toJSON
         * @memberof quack.UpdateComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateComponent;
    })();

    quack.GetComponent = (function() {

        /**
         * Properties of a GetComponent.
         * @memberof quack
         * @interface IGetComponent
         * @property {quack.ComponentID|null} [id] GetComponent id
         */

        /**
         * Constructs a new GetComponent.
         * @memberof quack
         * @classdesc Represents a GetComponent.
         * @implements IGetComponent
         * @constructor
         * @param {quack.IGetComponent=} [properties] Properties to set
         */
        function GetComponent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetComponent id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.GetComponent
         * @instance
         */
        GetComponent.prototype.id = null;

        /**
         * Creates a new GetComponent instance using the specified properties.
         * @function create
         * @memberof quack.GetComponent
         * @static
         * @param {quack.IGetComponent=} [properties] Properties to set
         * @returns {quack.GetComponent} GetComponent instance
         */
        GetComponent.create = function create(properties) {
            return new GetComponent(properties);
        };

        /**
         * Creates a GetComponent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GetComponent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GetComponent} GetComponent
         */
        GetComponent.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GetComponent)
                return object;
            var message = new $root.quack.GetComponent();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.GetComponent.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetComponent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GetComponent
         * @static
         * @param {quack.GetComponent} message GetComponent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetComponent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            return object;
        };

        /**
         * Converts this GetComponent to JSON.
         * @function toJSON
         * @memberof quack.GetComponent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetComponent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetComponent;
    })();

    quack.GetMeasurement = (function() {

        /**
         * Properties of a GetMeasurement.
         * @memberof quack
         * @interface IGetMeasurement
         * @property {quack.ComponentID|null} [id] GetMeasurement id
         */

        /**
         * Constructs a new GetMeasurement.
         * @memberof quack
         * @classdesc Represents a GetMeasurement.
         * @implements IGetMeasurement
         * @constructor
         * @param {quack.IGetMeasurement=} [properties] Properties to set
         */
        function GetMeasurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetMeasurement id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.GetMeasurement
         * @instance
         */
        GetMeasurement.prototype.id = null;

        /**
         * Creates a new GetMeasurement instance using the specified properties.
         * @function create
         * @memberof quack.GetMeasurement
         * @static
         * @param {quack.IGetMeasurement=} [properties] Properties to set
         * @returns {quack.GetMeasurement} GetMeasurement instance
         */
        GetMeasurement.create = function create(properties) {
            return new GetMeasurement(properties);
        };

        /**
         * Creates a GetMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GetMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GetMeasurement} GetMeasurement
         */
        GetMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GetMeasurement)
                return object;
            var message = new $root.quack.GetMeasurement();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.GetMeasurement.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            return message;
        };

        /**
         * Creates a plain object from a GetMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GetMeasurement
         * @static
         * @param {quack.GetMeasurement} message GetMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = null;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            return object;
        };

        /**
         * Converts this GetMeasurement to JSON.
         * @function toJSON
         * @memberof quack.GetMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetMeasurement;
    })();

    quack.Temperature = (function() {

        /**
         * Properties of a Temperature.
         * @memberof quack
         * @interface ITemperature
         * @property {number|null} [celciusTimes_10] Temperature celciusTimes_10
         */

        /**
         * Constructs a new Temperature.
         * @memberof quack
         * @classdesc Represents a Temperature.
         * @implements ITemperature
         * @constructor
         * @param {quack.ITemperature=} [properties] Properties to set
         */
        function Temperature(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Temperature celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.Temperature
         * @instance
         */
        Temperature.prototype.celciusTimes_10 = 0;

        /**
         * Creates a new Temperature instance using the specified properties.
         * @function create
         * @memberof quack.Temperature
         * @static
         * @param {quack.ITemperature=} [properties] Properties to set
         * @returns {quack.Temperature} Temperature instance
         */
        Temperature.create = function create(properties) {
            return new Temperature(properties);
        };

        /**
         * Creates a Temperature message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Temperature
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Temperature} Temperature
         */
        Temperature.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Temperature)
                return object;
            var message = new $root.quack.Temperature();
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            return message;
        };

        /**
         * Creates a plain object from a Temperature message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Temperature
         * @static
         * @param {quack.Temperature} message Temperature
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Temperature.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.celciusTimes_10 = 0;
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            return object;
        };

        /**
         * Converts this Temperature to JSON.
         * @function toJSON
         * @memberof quack.Temperature
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Temperature.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Temperature;
    })();

    quack.EdgeTriggered = (function() {

        /**
         * Properties of an EdgeTriggered.
         * @memberof quack
         * @interface IEdgeTriggered
         * @property {boolean|null} [state] EdgeTriggered state
         * @property {number|null} [rises] EdgeTriggered rises
         * @property {number|null} [falls] EdgeTriggered falls
         * @property {number|null} [lastRise] EdgeTriggered lastRise
         * @property {number|null} [lastFall] EdgeTriggered lastFall
         */

        /**
         * Constructs a new EdgeTriggered.
         * @memberof quack
         * @classdesc Represents an EdgeTriggered.
         * @implements IEdgeTriggered
         * @constructor
         * @param {quack.IEdgeTriggered=} [properties] Properties to set
         */
        function EdgeTriggered(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EdgeTriggered state.
         * @member {boolean} state
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.state = false;

        /**
         * EdgeTriggered rises.
         * @member {number} rises
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.rises = 0;

        /**
         * EdgeTriggered falls.
         * @member {number} falls
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.falls = 0;

        /**
         * EdgeTriggered lastRise.
         * @member {number} lastRise
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.lastRise = 0;

        /**
         * EdgeTriggered lastFall.
         * @member {number} lastFall
         * @memberof quack.EdgeTriggered
         * @instance
         */
        EdgeTriggered.prototype.lastFall = 0;

        /**
         * Creates a new EdgeTriggered instance using the specified properties.
         * @function create
         * @memberof quack.EdgeTriggered
         * @static
         * @param {quack.IEdgeTriggered=} [properties] Properties to set
         * @returns {quack.EdgeTriggered} EdgeTriggered instance
         */
        EdgeTriggered.create = function create(properties) {
            return new EdgeTriggered(properties);
        };

        /**
         * Creates an EdgeTriggered message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.EdgeTriggered
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.EdgeTriggered} EdgeTriggered
         */
        EdgeTriggered.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.EdgeTriggered)
                return object;
            var message = new $root.quack.EdgeTriggered();
            if (object.state != null)
                message.state = Boolean(object.state);
            if (object.rises != null)
                message.rises = object.rises >>> 0;
            if (object.falls != null)
                message.falls = object.falls >>> 0;
            if (object.lastRise != null)
                message.lastRise = object.lastRise >>> 0;
            if (object.lastFall != null)
                message.lastFall = object.lastFall >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an EdgeTriggered message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.EdgeTriggered
         * @static
         * @param {quack.EdgeTriggered} message EdgeTriggered
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EdgeTriggered.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.state = false;
                object.rises = 0;
                object.falls = 0;
                object.lastRise = 0;
                object.lastFall = 0;
            }
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.rises != null && message.hasOwnProperty("rises"))
                object.rises = message.rises;
            if (message.falls != null && message.hasOwnProperty("falls"))
                object.falls = message.falls;
            if (message.lastRise != null && message.hasOwnProperty("lastRise"))
                object.lastRise = message.lastRise;
            if (message.lastFall != null && message.hasOwnProperty("lastFall"))
                object.lastFall = message.lastFall;
            return object;
        };

        /**
         * Converts this EdgeTriggered to JSON.
         * @function toJSON
         * @memberof quack.EdgeTriggered
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EdgeTriggered.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EdgeTriggered;
    })();

    quack.Power = (function() {

        /**
         * Properties of a Power.
         * @memberof quack
         * @interface IPower
         * @property {number|null} [inputVoltageTimes_10] Power inputVoltageTimes_10
         * @property {number|null} [percentChargedTimes_100] Power percentChargedTimes_100
         */

        /**
         * Constructs a new Power.
         * @memberof quack
         * @classdesc Represents a Power.
         * @implements IPower
         * @constructor
         * @param {quack.IPower=} [properties] Properties to set
         */
        function Power(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Power inputVoltageTimes_10.
         * @member {number} inputVoltageTimes_10
         * @memberof quack.Power
         * @instance
         */
        Power.prototype.inputVoltageTimes_10 = 0;

        /**
         * Power percentChargedTimes_100.
         * @member {number} percentChargedTimes_100
         * @memberof quack.Power
         * @instance
         */
        Power.prototype.percentChargedTimes_100 = 0;

        /**
         * Creates a new Power instance using the specified properties.
         * @function create
         * @memberof quack.Power
         * @static
         * @param {quack.IPower=} [properties] Properties to set
         * @returns {quack.Power} Power instance
         */
        Power.create = function create(properties) {
            return new Power(properties);
        };

        /**
         * Creates a Power message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Power
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Power} Power
         */
        Power.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Power)
                return object;
            var message = new $root.quack.Power();
            if (object.inputVoltageTimes_10 != null)
                message.inputVoltageTimes_10 = object.inputVoltageTimes_10 | 0;
            if (object.percentChargedTimes_100 != null)
                message.percentChargedTimes_100 = object.percentChargedTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Power message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Power
         * @static
         * @param {quack.Power} message Power
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Power.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.inputVoltageTimes_10 = 0;
                object.percentChargedTimes_100 = 0;
            }
            if (message.inputVoltageTimes_10 != null && message.hasOwnProperty("inputVoltageTimes_10"))
                object.inputVoltageTimes_10 = message.inputVoltageTimes_10;
            if (message.percentChargedTimes_100 != null && message.hasOwnProperty("percentChargedTimes_100"))
                object.percentChargedTimes_100 = message.percentChargedTimes_100;
            return object;
        };

        /**
         * Converts this Power to JSON.
         * @function toJSON
         * @memberof quack.Power
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Power.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Power;
    })();

    quack.GrainCable = (function() {

        /**
         * Properties of a GrainCable.
         * @memberof quack
         * @interface IGrainCable
         * @property {Array.<number>|null} [celciusTimes_10] GrainCable celciusTimes_10
         * @property {Array.<number>|null} [relativeHumidityTimes_100] GrainCable relativeHumidityTimes_100
         */

        /**
         * Constructs a new GrainCable.
         * @memberof quack
         * @classdesc Represents a GrainCable.
         * @implements IGrainCable
         * @constructor
         * @param {quack.IGrainCable=} [properties] Properties to set
         */
        function GrainCable(properties) {
            this.celciusTimes_10 = [];
            this.relativeHumidityTimes_100 = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrainCable celciusTimes_10.
         * @member {Array.<number>} celciusTimes_10
         * @memberof quack.GrainCable
         * @instance
         */
        GrainCable.prototype.celciusTimes_10 = $util.emptyArray;

        /**
         * GrainCable relativeHumidityTimes_100.
         * @member {Array.<number>} relativeHumidityTimes_100
         * @memberof quack.GrainCable
         * @instance
         */
        GrainCable.prototype.relativeHumidityTimes_100 = $util.emptyArray;

        /**
         * Creates a new GrainCable instance using the specified properties.
         * @function create
         * @memberof quack.GrainCable
         * @static
         * @param {quack.IGrainCable=} [properties] Properties to set
         * @returns {quack.GrainCable} GrainCable instance
         */
        GrainCable.create = function create(properties) {
            return new GrainCable(properties);
        };

        /**
         * Creates a GrainCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GrainCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GrainCable} GrainCable
         */
        GrainCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GrainCable)
                return object;
            var message = new $root.quack.GrainCable();
            if (object.celciusTimes_10) {
                if (!Array.isArray(object.celciusTimes_10))
                    throw TypeError(".quack.GrainCable.celciusTimes_10: array expected");
                message.celciusTimes_10 = [];
                for (var i = 0; i < object.celciusTimes_10.length; ++i)
                    message.celciusTimes_10[i] = object.celciusTimes_10[i] | 0;
            }
            if (object.relativeHumidityTimes_100) {
                if (!Array.isArray(object.relativeHumidityTimes_100))
                    throw TypeError(".quack.GrainCable.relativeHumidityTimes_100: array expected");
                message.relativeHumidityTimes_100 = [];
                for (var i = 0; i < object.relativeHumidityTimes_100.length; ++i)
                    message.relativeHumidityTimes_100[i] = object.relativeHumidityTimes_100[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a GrainCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GrainCable
         * @static
         * @param {quack.GrainCable} message GrainCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrainCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.celciusTimes_10 = [];
                object.relativeHumidityTimes_100 = [];
            }
            if (message.celciusTimes_10 && message.celciusTimes_10.length) {
                object.celciusTimes_10 = [];
                for (var j = 0; j < message.celciusTimes_10.length; ++j)
                    object.celciusTimes_10[j] = message.celciusTimes_10[j];
            }
            if (message.relativeHumidityTimes_100 && message.relativeHumidityTimes_100.length) {
                object.relativeHumidityTimes_100 = [];
                for (var j = 0; j < message.relativeHumidityTimes_100.length; ++j)
                    object.relativeHumidityTimes_100[j] = message.relativeHumidityTimes_100[j];
            }
            return object;
        };

        /**
         * Converts this GrainCable to JSON.
         * @function toJSON
         * @memberof quack.GrainCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrainCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrainCable;
    })();

    quack.CapacitorCable = (function() {

        /**
         * Properties of a CapacitorCable.
         * @memberof quack
         * @interface ICapacitorCable
         * @property {Array.<number>|null} [groundRefFf] CapacitorCable groundRefFf
         * @property {Array.<number>|null} [selfRefFf] CapacitorCable selfRefFf
         */

        /**
         * Constructs a new CapacitorCable.
         * @memberof quack
         * @classdesc Represents a CapacitorCable.
         * @implements ICapacitorCable
         * @constructor
         * @param {quack.ICapacitorCable=} [properties] Properties to set
         */
        function CapacitorCable(properties) {
            this.groundRefFf = [];
            this.selfRefFf = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CapacitorCable groundRefFf.
         * @member {Array.<number>} groundRefFf
         * @memberof quack.CapacitorCable
         * @instance
         */
        CapacitorCable.prototype.groundRefFf = $util.emptyArray;

        /**
         * CapacitorCable selfRefFf.
         * @member {Array.<number>} selfRefFf
         * @memberof quack.CapacitorCable
         * @instance
         */
        CapacitorCable.prototype.selfRefFf = $util.emptyArray;

        /**
         * Creates a new CapacitorCable instance using the specified properties.
         * @function create
         * @memberof quack.CapacitorCable
         * @static
         * @param {quack.ICapacitorCable=} [properties] Properties to set
         * @returns {quack.CapacitorCable} CapacitorCable instance
         */
        CapacitorCable.create = function create(properties) {
            return new CapacitorCable(properties);
        };

        /**
         * Creates a CapacitorCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.CapacitorCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.CapacitorCable} CapacitorCable
         */
        CapacitorCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.CapacitorCable)
                return object;
            var message = new $root.quack.CapacitorCable();
            if (object.groundRefFf) {
                if (!Array.isArray(object.groundRefFf))
                    throw TypeError(".quack.CapacitorCable.groundRefFf: array expected");
                message.groundRefFf = [];
                for (var i = 0; i < object.groundRefFf.length; ++i)
                    message.groundRefFf[i] = object.groundRefFf[i] | 0;
            }
            if (object.selfRefFf) {
                if (!Array.isArray(object.selfRefFf))
                    throw TypeError(".quack.CapacitorCable.selfRefFf: array expected");
                message.selfRefFf = [];
                for (var i = 0; i < object.selfRefFf.length; ++i)
                    message.selfRefFf[i] = object.selfRefFf[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a CapacitorCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.CapacitorCable
         * @static
         * @param {quack.CapacitorCable} message CapacitorCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CapacitorCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.groundRefFf = [];
                object.selfRefFf = [];
            }
            if (message.groundRefFf && message.groundRefFf.length) {
                object.groundRefFf = [];
                for (var j = 0; j < message.groundRefFf.length; ++j)
                    object.groundRefFf[j] = message.groundRefFf[j];
            }
            if (message.selfRefFf && message.selfRefFf.length) {
                object.selfRefFf = [];
                for (var j = 0; j < message.selfRefFf.length; ++j)
                    object.selfRefFf[j] = message.selfRefFf[j];
            }
            return object;
        };

        /**
         * Converts this CapacitorCable to JSON.
         * @function toJSON
         * @memberof quack.CapacitorCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CapacitorCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CapacitorCable;
    })();

    quack.BooleanOutput = (function() {

        /**
         * Properties of a BooleanOutput.
         * @memberof quack
         * @interface IBooleanOutput
         * @property {boolean|null} [value] BooleanOutput value
         */

        /**
         * Constructs a new BooleanOutput.
         * @memberof quack
         * @classdesc Represents a BooleanOutput.
         * @implements IBooleanOutput
         * @constructor
         * @param {quack.IBooleanOutput=} [properties] Properties to set
         */
        function BooleanOutput(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BooleanOutput value.
         * @member {boolean} value
         * @memberof quack.BooleanOutput
         * @instance
         */
        BooleanOutput.prototype.value = false;

        /**
         * Creates a new BooleanOutput instance using the specified properties.
         * @function create
         * @memberof quack.BooleanOutput
         * @static
         * @param {quack.IBooleanOutput=} [properties] Properties to set
         * @returns {quack.BooleanOutput} BooleanOutput instance
         */
        BooleanOutput.create = function create(properties) {
            return new BooleanOutput(properties);
        };

        /**
         * Creates a BooleanOutput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.BooleanOutput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.BooleanOutput} BooleanOutput
         */
        BooleanOutput.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.BooleanOutput)
                return object;
            var message = new $root.quack.BooleanOutput();
            if (object.value != null)
                message.value = Boolean(object.value);
            return message;
        };

        /**
         * Creates a plain object from a BooleanOutput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.BooleanOutput
         * @static
         * @param {quack.BooleanOutput} message BooleanOutput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BooleanOutput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = false;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this BooleanOutput to JSON.
         * @function toJSON
         * @memberof quack.BooleanOutput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BooleanOutput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BooleanOutput;
    })();

    quack.Pressure = (function() {

        /**
         * Properties of a Pressure.
         * @memberof quack
         * @interface IPressure
         * @property {number|null} [pascals] Pressure pascals
         */

        /**
         * Constructs a new Pressure.
         * @memberof quack
         * @classdesc Represents a Pressure.
         * @implements IPressure
         * @constructor
         * @param {quack.IPressure=} [properties] Properties to set
         */
        function Pressure(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Pressure pascals.
         * @member {number} pascals
         * @memberof quack.Pressure
         * @instance
         */
        Pressure.prototype.pascals = 0;

        /**
         * Creates a new Pressure instance using the specified properties.
         * @function create
         * @memberof quack.Pressure
         * @static
         * @param {quack.IPressure=} [properties] Properties to set
         * @returns {quack.Pressure} Pressure instance
         */
        Pressure.create = function create(properties) {
            return new Pressure(properties);
        };

        /**
         * Creates a Pressure message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Pressure
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Pressure} Pressure
         */
        Pressure.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Pressure)
                return object;
            var message = new $root.quack.Pressure();
            if (object.pascals != null)
                message.pascals = object.pascals | 0;
            return message;
        };

        /**
         * Creates a plain object from a Pressure message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Pressure
         * @static
         * @param {quack.Pressure} message Pressure
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Pressure.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.pascals = 0;
            if (message.pascals != null && message.hasOwnProperty("pascals"))
                object.pascals = message.pascals;
            return object;
        };

        /**
         * Converts this Pressure to JSON.
         * @function toJSON
         * @memberof quack.Pressure
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Pressure.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Pressure;
    })();

    quack.WifiAccessPoint = (function() {

        /**
         * Properties of a WifiAccessPoint.
         * @memberof quack
         * @interface IWifiAccessPoint
         * @property {Uint8Array|null} [mac] WifiAccessPoint mac
         * @property {number|null} [signalStrength] WifiAccessPoint signalStrength
         * @property {number|null} [channel] WifiAccessPoint channel
         */

        /**
         * Constructs a new WifiAccessPoint.
         * @memberof quack
         * @classdesc Represents a WifiAccessPoint.
         * @implements IWifiAccessPoint
         * @constructor
         * @param {quack.IWifiAccessPoint=} [properties] Properties to set
         */
        function WifiAccessPoint(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WifiAccessPoint mac.
         * @member {Uint8Array} mac
         * @memberof quack.WifiAccessPoint
         * @instance
         */
        WifiAccessPoint.prototype.mac = $util.newBuffer([]);

        /**
         * WifiAccessPoint signalStrength.
         * @member {number} signalStrength
         * @memberof quack.WifiAccessPoint
         * @instance
         */
        WifiAccessPoint.prototype.signalStrength = 0;

        /**
         * WifiAccessPoint channel.
         * @member {number} channel
         * @memberof quack.WifiAccessPoint
         * @instance
         */
        WifiAccessPoint.prototype.channel = 0;

        /**
         * Creates a new WifiAccessPoint instance using the specified properties.
         * @function create
         * @memberof quack.WifiAccessPoint
         * @static
         * @param {quack.IWifiAccessPoint=} [properties] Properties to set
         * @returns {quack.WifiAccessPoint} WifiAccessPoint instance
         */
        WifiAccessPoint.create = function create(properties) {
            return new WifiAccessPoint(properties);
        };

        /**
         * Creates a WifiAccessPoint message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.WifiAccessPoint
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.WifiAccessPoint} WifiAccessPoint
         */
        WifiAccessPoint.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.WifiAccessPoint)
                return object;
            var message = new $root.quack.WifiAccessPoint();
            if (object.mac != null)
                if (typeof object.mac === "string")
                    $util.base64.decode(object.mac, message.mac = $util.newBuffer($util.base64.length(object.mac)), 0);
                else if (object.mac.length)
                    message.mac = object.mac;
            if (object.signalStrength != null)
                message.signalStrength = object.signalStrength | 0;
            if (object.channel != null)
                message.channel = object.channel >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a WifiAccessPoint message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.WifiAccessPoint
         * @static
         * @param {quack.WifiAccessPoint} message WifiAccessPoint
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WifiAccessPoint.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.mac = "";
                else {
                    object.mac = [];
                    if (options.bytes !== Array)
                        object.mac = $util.newBuffer(object.mac);
                }
                object.signalStrength = 0;
                object.channel = 0;
            }
            if (message.mac != null && message.hasOwnProperty("mac"))
                object.mac = options.bytes === String ? $util.base64.encode(message.mac, 0, message.mac.length) : options.bytes === Array ? Array.prototype.slice.call(message.mac) : message.mac;
            if (message.signalStrength != null && message.hasOwnProperty("signalStrength"))
                object.signalStrength = message.signalStrength;
            if (message.channel != null && message.hasOwnProperty("channel"))
                object.channel = message.channel;
            return object;
        };

        /**
         * Converts this WifiAccessPoint to JSON.
         * @function toJSON
         * @memberof quack.WifiAccessPoint
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WifiAccessPoint.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WifiAccessPoint;
    })();

    quack.CellTower = (function() {

        /**
         * Properties of a CellTower.
         * @memberof quack
         * @interface ICellTower
         * @property {number|null} [cellId] CellTower cellId
         * @property {number|null} [locationAreaCode] CellTower locationAreaCode
         * @property {number|null} [mobileCountryCode] CellTower mobileCountryCode
         * @property {number|null} [mobileNetworkCode] CellTower mobileNetworkCode
         * @property {number|null} [signalStrength] CellTower signalStrength
         */

        /**
         * Constructs a new CellTower.
         * @memberof quack
         * @classdesc Represents a CellTower.
         * @implements ICellTower
         * @constructor
         * @param {quack.ICellTower=} [properties] Properties to set
         */
        function CellTower(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CellTower cellId.
         * @member {number} cellId
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.cellId = 0;

        /**
         * CellTower locationAreaCode.
         * @member {number} locationAreaCode
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.locationAreaCode = 0;

        /**
         * CellTower mobileCountryCode.
         * @member {number} mobileCountryCode
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.mobileCountryCode = 0;

        /**
         * CellTower mobileNetworkCode.
         * @member {number} mobileNetworkCode
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.mobileNetworkCode = 0;

        /**
         * CellTower signalStrength.
         * @member {number} signalStrength
         * @memberof quack.CellTower
         * @instance
         */
        CellTower.prototype.signalStrength = 0;

        /**
         * Creates a new CellTower instance using the specified properties.
         * @function create
         * @memberof quack.CellTower
         * @static
         * @param {quack.ICellTower=} [properties] Properties to set
         * @returns {quack.CellTower} CellTower instance
         */
        CellTower.create = function create(properties) {
            return new CellTower(properties);
        };

        /**
         * Creates a CellTower message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.CellTower
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.CellTower} CellTower
         */
        CellTower.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.CellTower)
                return object;
            var message = new $root.quack.CellTower();
            if (object.cellId != null)
                message.cellId = object.cellId >>> 0;
            if (object.locationAreaCode != null)
                message.locationAreaCode = object.locationAreaCode >>> 0;
            if (object.mobileCountryCode != null)
                message.mobileCountryCode = object.mobileCountryCode >>> 0;
            if (object.mobileNetworkCode != null)
                message.mobileNetworkCode = object.mobileNetworkCode >>> 0;
            if (object.signalStrength != null)
                message.signalStrength = object.signalStrength | 0;
            return message;
        };

        /**
         * Creates a plain object from a CellTower message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.CellTower
         * @static
         * @param {quack.CellTower} message CellTower
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CellTower.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cellId = 0;
                object.locationAreaCode = 0;
                object.mobileCountryCode = 0;
                object.mobileNetworkCode = 0;
                object.signalStrength = 0;
            }
            if (message.cellId != null && message.hasOwnProperty("cellId"))
                object.cellId = message.cellId;
            if (message.locationAreaCode != null && message.hasOwnProperty("locationAreaCode"))
                object.locationAreaCode = message.locationAreaCode;
            if (message.mobileCountryCode != null && message.hasOwnProperty("mobileCountryCode"))
                object.mobileCountryCode = message.mobileCountryCode;
            if (message.mobileNetworkCode != null && message.hasOwnProperty("mobileNetworkCode"))
                object.mobileNetworkCode = message.mobileNetworkCode;
            if (message.signalStrength != null && message.hasOwnProperty("signalStrength"))
                object.signalStrength = message.signalStrength;
            return object;
        };

        /**
         * Converts this CellTower to JSON.
         * @function toJSON
         * @memberof quack.CellTower
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CellTower.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CellTower;
    })();

    quack.Location = (function() {

        /**
         * Properties of a Location.
         * @memberof quack
         * @interface ILocation
         * @property {number|null} [latitude] Location latitude
         * @property {number|null} [longitude] Location longitude
         * @property {number|null} [altitude] Location altitude
         * @property {number|null} [uncertainty] Location uncertainty
         */

        /**
         * Constructs a new Location.
         * @memberof quack
         * @classdesc Represents a Location.
         * @implements ILocation
         * @constructor
         * @param {quack.ILocation=} [properties] Properties to set
         */
        function Location(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Location latitude.
         * @member {number} latitude
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.latitude = 0;

        /**
         * Location longitude.
         * @member {number} longitude
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.longitude = 0;

        /**
         * Location altitude.
         * @member {number} altitude
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.altitude = 0;

        /**
         * Location uncertainty.
         * @member {number} uncertainty
         * @memberof quack.Location
         * @instance
         */
        Location.prototype.uncertainty = 0;

        /**
         * Creates a new Location instance using the specified properties.
         * @function create
         * @memberof quack.Location
         * @static
         * @param {quack.ILocation=} [properties] Properties to set
         * @returns {quack.Location} Location instance
         */
        Location.create = function create(properties) {
            return new Location(properties);
        };

        /**
         * Creates a Location message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Location
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Location} Location
         */
        Location.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Location)
                return object;
            var message = new $root.quack.Location();
            if (object.latitude != null)
                message.latitude = Number(object.latitude);
            if (object.longitude != null)
                message.longitude = Number(object.longitude);
            if (object.altitude != null)
                message.altitude = object.altitude | 0;
            if (object.uncertainty != null)
                message.uncertainty = object.uncertainty >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Location message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Location
         * @static
         * @param {quack.Location} message Location
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Location.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.latitude = 0;
                object.longitude = 0;
                object.altitude = 0;
                object.uncertainty = 0;
            }
            if (message.latitude != null && message.hasOwnProperty("latitude"))
                object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
            if (message.longitude != null && message.hasOwnProperty("longitude"))
                object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
            if (message.altitude != null && message.hasOwnProperty("altitude"))
                object.altitude = message.altitude;
            if (message.uncertainty != null && message.hasOwnProperty("uncertainty"))
                object.uncertainty = message.uncertainty;
            return object;
        };

        /**
         * Converts this Location to JSON.
         * @function toJSON
         * @memberof quack.Location
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Location.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Location;
    })();

    quack.GPS = (function() {

        /**
         * Properties of a GPS.
         * @memberof quack
         * @interface IGPS
         * @property {Array.<quack.WifiAccessPoint>|null} [wifiAccessPoints] GPS wifiAccessPoints
         * @property {quack.CellTower|null} [cellTower] GPS cellTower
         * @property {quack.Location|null} [location] GPS location
         */

        /**
         * Constructs a new GPS.
         * @memberof quack
         * @classdesc Represents a GPS.
         * @implements IGPS
         * @constructor
         * @param {quack.IGPS=} [properties] Properties to set
         */
        function GPS(properties) {
            this.wifiAccessPoints = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GPS wifiAccessPoints.
         * @member {Array.<quack.WifiAccessPoint>} wifiAccessPoints
         * @memberof quack.GPS
         * @instance
         */
        GPS.prototype.wifiAccessPoints = $util.emptyArray;

        /**
         * GPS cellTower.
         * @member {quack.CellTower|null|undefined} cellTower
         * @memberof quack.GPS
         * @instance
         */
        GPS.prototype.cellTower = null;

        /**
         * GPS location.
         * @member {quack.Location|null|undefined} location
         * @memberof quack.GPS
         * @instance
         */
        GPS.prototype.location = null;

        /**
         * Creates a new GPS instance using the specified properties.
         * @function create
         * @memberof quack.GPS
         * @static
         * @param {quack.IGPS=} [properties] Properties to set
         * @returns {quack.GPS} GPS instance
         */
        GPS.create = function create(properties) {
            return new GPS(properties);
        };

        /**
         * Creates a GPS message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GPS
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GPS} GPS
         */
        GPS.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GPS)
                return object;
            var message = new $root.quack.GPS();
            if (object.wifiAccessPoints) {
                if (!Array.isArray(object.wifiAccessPoints))
                    throw TypeError(".quack.GPS.wifiAccessPoints: array expected");
                message.wifiAccessPoints = [];
                for (var i = 0; i < object.wifiAccessPoints.length; ++i) {
                    if (typeof object.wifiAccessPoints[i] !== "object")
                        throw TypeError(".quack.GPS.wifiAccessPoints: object expected");
                    message.wifiAccessPoints[i] = $root.quack.WifiAccessPoint.fromObject(object.wifiAccessPoints[i]);
                }
            }
            if (object.cellTower != null) {
                if (typeof object.cellTower !== "object")
                    throw TypeError(".quack.GPS.cellTower: object expected");
                message.cellTower = $root.quack.CellTower.fromObject(object.cellTower);
            }
            if (object.location != null) {
                if (typeof object.location !== "object")
                    throw TypeError(".quack.GPS.location: object expected");
                message.location = $root.quack.Location.fromObject(object.location);
            }
            return message;
        };

        /**
         * Creates a plain object from a GPS message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GPS
         * @static
         * @param {quack.GPS} message GPS
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GPS.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.wifiAccessPoints = [];
            if (options.defaults) {
                object.cellTower = null;
                object.location = null;
            }
            if (message.wifiAccessPoints && message.wifiAccessPoints.length) {
                object.wifiAccessPoints = [];
                for (var j = 0; j < message.wifiAccessPoints.length; ++j)
                    object.wifiAccessPoints[j] = $root.quack.WifiAccessPoint.toObject(message.wifiAccessPoints[j], options);
            }
            if (message.cellTower != null && message.hasOwnProperty("cellTower"))
                object.cellTower = $root.quack.CellTower.toObject(message.cellTower, options);
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = $root.quack.Location.toObject(message.location, options);
            return object;
        };

        /**
         * Converts this GPS to JSON.
         * @function toJSON
         * @memberof quack.GPS
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GPS.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GPS;
    })();

    quack.BooleanInput = (function() {

        /**
         * Properties of a BooleanInput.
         * @memberof quack
         * @interface IBooleanInput
         * @property {boolean|null} [value] BooleanInput value
         */

        /**
         * Constructs a new BooleanInput.
         * @memberof quack
         * @classdesc Represents a BooleanInput.
         * @implements IBooleanInput
         * @constructor
         * @param {quack.IBooleanInput=} [properties] Properties to set
         */
        function BooleanInput(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BooleanInput value.
         * @member {boolean} value
         * @memberof quack.BooleanInput
         * @instance
         */
        BooleanInput.prototype.value = false;

        /**
         * Creates a new BooleanInput instance using the specified properties.
         * @function create
         * @memberof quack.BooleanInput
         * @static
         * @param {quack.IBooleanInput=} [properties] Properties to set
         * @returns {quack.BooleanInput} BooleanInput instance
         */
        BooleanInput.create = function create(properties) {
            return new BooleanInput(properties);
        };

        /**
         * Creates a BooleanInput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.BooleanInput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.BooleanInput} BooleanInput
         */
        BooleanInput.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.BooleanInput)
                return object;
            var message = new $root.quack.BooleanInput();
            if (object.value != null)
                message.value = Boolean(object.value);
            return message;
        };

        /**
         * Creates a plain object from a BooleanInput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.BooleanInput
         * @static
         * @param {quack.BooleanInput} message BooleanInput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BooleanInput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = false;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this BooleanInput to JSON.
         * @function toJSON
         * @memberof quack.BooleanInput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BooleanInput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BooleanInput;
    })();

    quack.HumidityAndTemperature = (function() {

        /**
         * Properties of a HumidityAndTemperature.
         * @memberof quack
         * @interface IHumidityAndTemperature
         * @property {number|null} [celciusTimes_10] HumidityAndTemperature celciusTimes_10
         * @property {number|null} [relativeHumidityTimes_100] HumidityAndTemperature relativeHumidityTimes_100
         */

        /**
         * Constructs a new HumidityAndTemperature.
         * @memberof quack
         * @classdesc Represents a HumidityAndTemperature.
         * @implements IHumidityAndTemperature
         * @constructor
         * @param {quack.IHumidityAndTemperature=} [properties] Properties to set
         */
        function HumidityAndTemperature(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * HumidityAndTemperature celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.HumidityAndTemperature
         * @instance
         */
        HumidityAndTemperature.prototype.celciusTimes_10 = 0;

        /**
         * HumidityAndTemperature relativeHumidityTimes_100.
         * @member {number} relativeHumidityTimes_100
         * @memberof quack.HumidityAndTemperature
         * @instance
         */
        HumidityAndTemperature.prototype.relativeHumidityTimes_100 = 0;

        /**
         * Creates a new HumidityAndTemperature instance using the specified properties.
         * @function create
         * @memberof quack.HumidityAndTemperature
         * @static
         * @param {quack.IHumidityAndTemperature=} [properties] Properties to set
         * @returns {quack.HumidityAndTemperature} HumidityAndTemperature instance
         */
        HumidityAndTemperature.create = function create(properties) {
            return new HumidityAndTemperature(properties);
        };

        /**
         * Creates a HumidityAndTemperature message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.HumidityAndTemperature
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.HumidityAndTemperature} HumidityAndTemperature
         */
        HumidityAndTemperature.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.HumidityAndTemperature)
                return object;
            var message = new $root.quack.HumidityAndTemperature();
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            if (object.relativeHumidityTimes_100 != null)
                message.relativeHumidityTimes_100 = object.relativeHumidityTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a HumidityAndTemperature message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.HumidityAndTemperature
         * @static
         * @param {quack.HumidityAndTemperature} message HumidityAndTemperature
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        HumidityAndTemperature.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.celciusTimes_10 = 0;
                object.relativeHumidityTimes_100 = 0;
            }
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            if (message.relativeHumidityTimes_100 != null && message.hasOwnProperty("relativeHumidityTimes_100"))
                object.relativeHumidityTimes_100 = message.relativeHumidityTimes_100;
            return object;
        };

        /**
         * Converts this HumidityAndTemperature to JSON.
         * @function toJSON
         * @memberof quack.HumidityAndTemperature
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        HumidityAndTemperature.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HumidityAndTemperature;
    })();

    quack.ModemSignal = (function() {

        /**
         * Properties of a ModemSignal.
         * @memberof quack
         * @interface IModemSignal
         * @property {number|null} [rssi] ModemSignal rssi
         * @property {number|null} [quality] ModemSignal quality
         */

        /**
         * Constructs a new ModemSignal.
         * @memberof quack
         * @classdesc Represents a ModemSignal.
         * @implements IModemSignal
         * @constructor
         * @param {quack.IModemSignal=} [properties] Properties to set
         */
        function ModemSignal(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ModemSignal rssi.
         * @member {number} rssi
         * @memberof quack.ModemSignal
         * @instance
         */
        ModemSignal.prototype.rssi = 0;

        /**
         * ModemSignal quality.
         * @member {number} quality
         * @memberof quack.ModemSignal
         * @instance
         */
        ModemSignal.prototype.quality = 0;

        /**
         * Creates a new ModemSignal instance using the specified properties.
         * @function create
         * @memberof quack.ModemSignal
         * @static
         * @param {quack.IModemSignal=} [properties] Properties to set
         * @returns {quack.ModemSignal} ModemSignal instance
         */
        ModemSignal.create = function create(properties) {
            return new ModemSignal(properties);
        };

        /**
         * Creates a ModemSignal message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.ModemSignal
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.ModemSignal} ModemSignal
         */
        ModemSignal.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.ModemSignal)
                return object;
            var message = new $root.quack.ModemSignal();
            if (object.rssi != null)
                message.rssi = object.rssi | 0;
            if (object.quality != null)
                message.quality = object.quality | 0;
            return message;
        };

        /**
         * Creates a plain object from a ModemSignal message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.ModemSignal
         * @static
         * @param {quack.ModemSignal} message ModemSignal
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ModemSignal.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.rssi = 0;
                object.quality = 0;
            }
            if (message.rssi != null && message.hasOwnProperty("rssi"))
                object.rssi = message.rssi;
            if (message.quality != null && message.hasOwnProperty("quality"))
                object.quality = message.quality;
            return object;
        };

        /**
         * Converts this ModemSignal to JSON.
         * @function toJSON
         * @memberof quack.ModemSignal
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ModemSignal.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ModemSignal;
    })();

    quack.Light = (function() {

        /**
         * Properties of a Light.
         * @memberof quack
         * @interface ILight
         * @property {number|null} [fullSpectrum] Light fullSpectrum
         * @property {number|null} [infrared] Light infrared
         * @property {number|null} [visible] Light visible
         * @property {number|null} [luxTimes_100] Light luxTimes_100
         */

        /**
         * Constructs a new Light.
         * @memberof quack
         * @classdesc Represents a Light.
         * @implements ILight
         * @constructor
         * @param {quack.ILight=} [properties] Properties to set
         */
        function Light(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Light fullSpectrum.
         * @member {number} fullSpectrum
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.fullSpectrum = 0;

        /**
         * Light infrared.
         * @member {number} infrared
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.infrared = 0;

        /**
         * Light visible.
         * @member {number} visible
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.visible = 0;

        /**
         * Light luxTimes_100.
         * @member {number} luxTimes_100
         * @memberof quack.Light
         * @instance
         */
        Light.prototype.luxTimes_100 = 0;

        /**
         * Creates a new Light instance using the specified properties.
         * @function create
         * @memberof quack.Light
         * @static
         * @param {quack.ILight=} [properties] Properties to set
         * @returns {quack.Light} Light instance
         */
        Light.create = function create(properties) {
            return new Light(properties);
        };

        /**
         * Creates a Light message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Light
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Light} Light
         */
        Light.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Light)
                return object;
            var message = new $root.quack.Light();
            if (object.fullSpectrum != null)
                message.fullSpectrum = object.fullSpectrum >>> 0;
            if (object.infrared != null)
                message.infrared = object.infrared >>> 0;
            if (object.visible != null)
                message.visible = object.visible >>> 0;
            if (object.luxTimes_100 != null)
                message.luxTimes_100 = object.luxTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Light message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Light
         * @static
         * @param {quack.Light} message Light
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Light.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.fullSpectrum = 0;
                object.infrared = 0;
                object.visible = 0;
                object.luxTimes_100 = 0;
            }
            if (message.fullSpectrum != null && message.hasOwnProperty("fullSpectrum"))
                object.fullSpectrum = message.fullSpectrum;
            if (message.infrared != null && message.hasOwnProperty("infrared"))
                object.infrared = message.infrared;
            if (message.visible != null && message.hasOwnProperty("visible"))
                object.visible = message.visible;
            if (message.luxTimes_100 != null && message.hasOwnProperty("luxTimes_100"))
                object.luxTimes_100 = message.luxTimes_100;
            return object;
        };

        /**
         * Converts this Light to JSON.
         * @function toJSON
         * @memberof quack.Light
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Light.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Light;
    })();

    quack.Gas = (function() {

        /**
         * Properties of a Gas.
         * @memberof quack
         * @interface IGas
         * @property {number|null} [ppm] Gas ppm
         * @property {number|null} [ppb] Gas ppb
         */

        /**
         * Constructs a new Gas.
         * @memberof quack
         * @classdesc Represents a Gas.
         * @implements IGas
         * @constructor
         * @param {quack.IGas=} [properties] Properties to set
         */
        function Gas(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Gas ppm.
         * @member {number} ppm
         * @memberof quack.Gas
         * @instance
         */
        Gas.prototype.ppm = 0;

        /**
         * Gas ppb.
         * @member {number} ppb
         * @memberof quack.Gas
         * @instance
         */
        Gas.prototype.ppb = 0;

        /**
         * Creates a new Gas instance using the specified properties.
         * @function create
         * @memberof quack.Gas
         * @static
         * @param {quack.IGas=} [properties] Properties to set
         * @returns {quack.Gas} Gas instance
         */
        Gas.create = function create(properties) {
            return new Gas(properties);
        };

        /**
         * Creates a Gas message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Gas
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Gas} Gas
         */
        Gas.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Gas)
                return object;
            var message = new $root.quack.Gas();
            if (object.ppm != null)
                message.ppm = object.ppm >>> 0;
            if (object.ppb != null)
                message.ppb = object.ppb >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Gas message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Gas
         * @static
         * @param {quack.Gas} message Gas
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Gas.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ppm = 0;
                object.ppb = 0;
            }
            if (message.ppm != null && message.hasOwnProperty("ppm"))
                object.ppm = message.ppm;
            if (message.ppb != null && message.hasOwnProperty("ppb"))
                object.ppb = message.ppb;
            return object;
        };

        /**
         * Converts this Gas to JSON.
         * @function toJSON
         * @memberof quack.Gas
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Gas.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Gas;
    })();

    quack.StepperMotor = (function() {

        /**
         * Properties of a StepperMotor.
         * @memberof quack
         * @interface IStepperMotor
         * @property {boolean|null} [running] StepperMotor running
         */

        /**
         * Constructs a new StepperMotor.
         * @memberof quack
         * @classdesc Represents a StepperMotor.
         * @implements IStepperMotor
         * @constructor
         * @param {quack.IStepperMotor=} [properties] Properties to set
         */
        function StepperMotor(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StepperMotor running.
         * @member {boolean} running
         * @memberof quack.StepperMotor
         * @instance
         */
        StepperMotor.prototype.running = false;

        /**
         * Creates a new StepperMotor instance using the specified properties.
         * @function create
         * @memberof quack.StepperMotor
         * @static
         * @param {quack.IStepperMotor=} [properties] Properties to set
         * @returns {quack.StepperMotor} StepperMotor instance
         */
        StepperMotor.create = function create(properties) {
            return new StepperMotor(properties);
        };

        /**
         * Creates a StepperMotor message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.StepperMotor
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.StepperMotor} StepperMotor
         */
        StepperMotor.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.StepperMotor)
                return object;
            var message = new $root.quack.StepperMotor();
            if (object.running != null)
                message.running = Boolean(object.running);
            return message;
        };

        /**
         * Creates a plain object from a StepperMotor message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.StepperMotor
         * @static
         * @param {quack.StepperMotor} message StepperMotor
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StepperMotor.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.running = false;
            if (message.running != null && message.hasOwnProperty("running"))
                object.running = message.running;
            return object;
        };

        /**
         * Converts this StepperMotor to JSON.
         * @function toJSON
         * @memberof quack.StepperMotor
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StepperMotor.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StepperMotor;
    })();

    quack.AnalogInput = (function() {

        /**
         * Properties of an AnalogInput.
         * @memberof quack
         * @interface IAnalogInput
         * @property {number|null} [value] AnalogInput value
         */

        /**
         * Constructs a new AnalogInput.
         * @memberof quack
         * @classdesc Represents an AnalogInput.
         * @implements IAnalogInput
         * @constructor
         * @param {quack.IAnalogInput=} [properties] Properties to set
         */
        function AnalogInput(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AnalogInput value.
         * @member {number} value
         * @memberof quack.AnalogInput
         * @instance
         */
        AnalogInput.prototype.value = 0;

        /**
         * Creates a new AnalogInput instance using the specified properties.
         * @function create
         * @memberof quack.AnalogInput
         * @static
         * @param {quack.IAnalogInput=} [properties] Properties to set
         * @returns {quack.AnalogInput} AnalogInput instance
         */
        AnalogInput.create = function create(properties) {
            return new AnalogInput(properties);
        };

        /**
         * Creates an AnalogInput message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AnalogInput
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AnalogInput} AnalogInput
         */
        AnalogInput.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AnalogInput)
                return object;
            var message = new $root.quack.AnalogInput();
            if (object.value != null)
                message.value = object.value >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an AnalogInput message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AnalogInput
         * @static
         * @param {quack.AnalogInput} message AnalogInput
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AnalogInput.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.value = 0;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this AnalogInput to JSON.
         * @function toJSON
         * @memberof quack.AnalogInput
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AnalogInput.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AnalogInput;
    })();

    quack.ORP = (function() {

        /**
         * Properties of a ORP.
         * @memberof quack
         * @interface IORP
         * @property {number|null} [microvolts] ORP microvolts
         */

        /**
         * Constructs a new ORP.
         * @memberof quack
         * @classdesc Represents a ORP.
         * @implements IORP
         * @constructor
         * @param {quack.IORP=} [properties] Properties to set
         */
        function ORP(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ORP microvolts.
         * @member {number} microvolts
         * @memberof quack.ORP
         * @instance
         */
        ORP.prototype.microvolts = 0;

        /**
         * Creates a new ORP instance using the specified properties.
         * @function create
         * @memberof quack.ORP
         * @static
         * @param {quack.IORP=} [properties] Properties to set
         * @returns {quack.ORP} ORP instance
         */
        ORP.create = function create(properties) {
            return new ORP(properties);
        };

        /**
         * Creates a ORP message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.ORP
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.ORP} ORP
         */
        ORP.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.ORP)
                return object;
            var message = new $root.quack.ORP();
            if (object.microvolts != null)
                message.microvolts = object.microvolts | 0;
            return message;
        };

        /**
         * Creates a plain object from a ORP message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.ORP
         * @static
         * @param {quack.ORP} message ORP
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ORP.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.microvolts = 0;
            if (message.microvolts != null && message.hasOwnProperty("microvolts"))
                object.microvolts = message.microvolts;
            return object;
        };

        /**
         * Converts this ORP to JSON.
         * @function toJSON
         * @memberof quack.ORP
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ORP.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ORP;
    })();

    quack.PH = (function() {

        /**
         * Properties of a PH.
         * @memberof quack
         * @interface IPH
         * @property {number|null} [phTimes_100000] PH phTimes_100000
         */

        /**
         * Constructs a new PH.
         * @memberof quack
         * @classdesc Represents a PH.
         * @implements IPH
         * @constructor
         * @param {quack.IPH=} [properties] Properties to set
         */
        function PH(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PH phTimes_100000.
         * @member {number} phTimes_100000
         * @memberof quack.PH
         * @instance
         */
        PH.prototype.phTimes_100000 = 0;

        /**
         * Creates a new PH instance using the specified properties.
         * @function create
         * @memberof quack.PH
         * @static
         * @param {quack.IPH=} [properties] Properties to set
         * @returns {quack.PH} PH instance
         */
        PH.create = function create(properties) {
            return new PH(properties);
        };

        /**
         * Creates a PH message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.PH
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.PH} PH
         */
        PH.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.PH)
                return object;
            var message = new $root.quack.PH();
            if (object.phTimes_100000 != null)
                message.phTimes_100000 = object.phTimes_100000 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a PH message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.PH
         * @static
         * @param {quack.PH} message PH
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PH.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.phTimes_100000 = 0;
            if (message.phTimes_100000 != null && message.hasOwnProperty("phTimes_100000"))
                object.phTimes_100000 = message.phTimes_100000;
            return object;
        };

        /**
         * Converts this PH to JSON.
         * @function toJSON
         * @memberof quack.PH
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PH.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PH;
    })();

    quack.Voltage = (function() {

        /**
         * Properties of a Voltage.
         * @memberof quack
         * @interface IVoltage
         * @property {number|null} [microvolts] Voltage microvolts
         */

        /**
         * Constructs a new Voltage.
         * @memberof quack
         * @classdesc Represents a Voltage.
         * @implements IVoltage
         * @constructor
         * @param {quack.IVoltage=} [properties] Properties to set
         */
        function Voltage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Voltage microvolts.
         * @member {number} microvolts
         * @memberof quack.Voltage
         * @instance
         */
        Voltage.prototype.microvolts = 0;

        /**
         * Creates a new Voltage instance using the specified properties.
         * @function create
         * @memberof quack.Voltage
         * @static
         * @param {quack.IVoltage=} [properties] Properties to set
         * @returns {quack.Voltage} Voltage instance
         */
        Voltage.create = function create(properties) {
            return new Voltage(properties);
        };

        /**
         * Creates a Voltage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Voltage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Voltage} Voltage
         */
        Voltage.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Voltage)
                return object;
            var message = new $root.quack.Voltage();
            if (object.microvolts != null)
                message.microvolts = object.microvolts | 0;
            return message;
        };

        /**
         * Creates a plain object from a Voltage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Voltage
         * @static
         * @param {quack.Voltage} message Voltage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Voltage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.microvolts = 0;
            if (message.microvolts != null && message.hasOwnProperty("microvolts"))
                object.microvolts = message.microvolts;
            return object;
        };

        /**
         * Converts this Voltage to JSON.
         * @function toJSON
         * @memberof quack.Voltage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Voltage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Voltage;
    })();

    quack.Concentration = (function() {

        /**
         * Properties of a Concentration.
         * @memberof quack
         * @interface IConcentration
         * @property {number|null} [ppb] Concentration ppb
         */

        /**
         * Constructs a new Concentration.
         * @memberof quack
         * @classdesc Represents a Concentration.
         * @implements IConcentration
         * @constructor
         * @param {quack.IConcentration=} [properties] Properties to set
         */
        function Concentration(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Concentration ppb.
         * @member {number} ppb
         * @memberof quack.Concentration
         * @instance
         */
        Concentration.prototype.ppb = 0;

        /**
         * Creates a new Concentration instance using the specified properties.
         * @function create
         * @memberof quack.Concentration
         * @static
         * @param {quack.IConcentration=} [properties] Properties to set
         * @returns {quack.Concentration} Concentration instance
         */
        Concentration.create = function create(properties) {
            return new Concentration(properties);
        };

        /**
         * Creates a Concentration message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Concentration
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Concentration} Concentration
         */
        Concentration.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Concentration)
                return object;
            var message = new $root.quack.Concentration();
            if (object.ppb != null)
                message.ppb = object.ppb >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Concentration message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Concentration
         * @static
         * @param {quack.Concentration} message Concentration
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Concentration.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ppb = 0;
            if (message.ppb != null && message.hasOwnProperty("ppb"))
                object.ppb = message.ppb;
            return object;
        };

        /**
         * Converts this Concentration to JSON.
         * @function toJSON
         * @memberof quack.Concentration
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Concentration.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Concentration;
    })();

    quack.Conductivity = (function() {

        /**
         * Properties of a Conductivity.
         * @memberof quack
         * @interface IConductivity
         * @property {number|null} [microsiemensPerCm] Conductivity microsiemensPerCm
         */

        /**
         * Constructs a new Conductivity.
         * @memberof quack
         * @classdesc Represents a Conductivity.
         * @implements IConductivity
         * @constructor
         * @param {quack.IConductivity=} [properties] Properties to set
         */
        function Conductivity(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Conductivity microsiemensPerCm.
         * @member {number} microsiemensPerCm
         * @memberof quack.Conductivity
         * @instance
         */
        Conductivity.prototype.microsiemensPerCm = 0;

        /**
         * Creates a new Conductivity instance using the specified properties.
         * @function create
         * @memberof quack.Conductivity
         * @static
         * @param {quack.IConductivity=} [properties] Properties to set
         * @returns {quack.Conductivity} Conductivity instance
         */
        Conductivity.create = function create(properties) {
            return new Conductivity(properties);
        };

        /**
         * Creates a Conductivity message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Conductivity
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Conductivity} Conductivity
         */
        Conductivity.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Conductivity)
                return object;
            var message = new $root.quack.Conductivity();
            if (object.microsiemensPerCm != null)
                message.microsiemensPerCm = object.microsiemensPerCm >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Conductivity message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Conductivity
         * @static
         * @param {quack.Conductivity} message Conductivity
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Conductivity.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.microsiemensPerCm = 0;
            if (message.microsiemensPerCm != null && message.hasOwnProperty("microsiemensPerCm"))
                object.microsiemensPerCm = message.microsiemensPerCm;
            return object;
        };

        /**
         * Converts this Conductivity to JSON.
         * @function toJSON
         * @memberof quack.Conductivity
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Conductivity.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Conductivity;
    })();

    quack.Capacitance = (function() {

        /**
         * Properties of a Capacitance.
         * @memberof quack
         * @interface ICapacitance
         * @property {number|null} [picofarads] Capacitance picofarads
         */

        /**
         * Constructs a new Capacitance.
         * @memberof quack
         * @classdesc Represents a Capacitance.
         * @implements ICapacitance
         * @constructor
         * @param {quack.ICapacitance=} [properties] Properties to set
         */
        function Capacitance(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Capacitance picofarads.
         * @member {number} picofarads
         * @memberof quack.Capacitance
         * @instance
         */
        Capacitance.prototype.picofarads = 0;

        /**
         * Creates a new Capacitance instance using the specified properties.
         * @function create
         * @memberof quack.Capacitance
         * @static
         * @param {quack.ICapacitance=} [properties] Properties to set
         * @returns {quack.Capacitance} Capacitance instance
         */
        Capacitance.create = function create(properties) {
            return new Capacitance(properties);
        };

        /**
         * Creates a Capacitance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Capacitance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Capacitance} Capacitance
         */
        Capacitance.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Capacitance)
                return object;
            var message = new $root.quack.Capacitance();
            if (object.picofarads != null)
                message.picofarads = object.picofarads | 0;
            return message;
        };

        /**
         * Creates a plain object from a Capacitance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Capacitance
         * @static
         * @param {quack.Capacitance} message Capacitance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Capacitance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.picofarads = 0;
            if (message.picofarads != null && message.hasOwnProperty("picofarads"))
                object.picofarads = message.picofarads;
            return object;
        };

        /**
         * Converts this Capacitance to JSON.
         * @function toJSON
         * @memberof quack.Capacitance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Capacitance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Capacitance;
    })();

    quack.VapourPressureDeficit = (function() {

        /**
         * Properties of a VapourPressureDeficit.
         * @memberof quack
         * @interface IVapourPressureDeficit
         * @property {number|null} [pascals] VapourPressureDeficit pascals
         * @property {number|null} [celciusTimes_10] VapourPressureDeficit celciusTimes_10
         * @property {number|null} [relativeHumidityTimes_100] VapourPressureDeficit relativeHumidityTimes_100
         */

        /**
         * Constructs a new VapourPressureDeficit.
         * @memberof quack
         * @classdesc Represents a VapourPressureDeficit.
         * @implements IVapourPressureDeficit
         * @constructor
         * @param {quack.IVapourPressureDeficit=} [properties] Properties to set
         */
        function VapourPressureDeficit(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VapourPressureDeficit pascals.
         * @member {number} pascals
         * @memberof quack.VapourPressureDeficit
         * @instance
         */
        VapourPressureDeficit.prototype.pascals = 0;

        /**
         * VapourPressureDeficit celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.VapourPressureDeficit
         * @instance
         */
        VapourPressureDeficit.prototype.celciusTimes_10 = 0;

        /**
         * VapourPressureDeficit relativeHumidityTimes_100.
         * @member {number} relativeHumidityTimes_100
         * @memberof quack.VapourPressureDeficit
         * @instance
         */
        VapourPressureDeficit.prototype.relativeHumidityTimes_100 = 0;

        /**
         * Creates a new VapourPressureDeficit instance using the specified properties.
         * @function create
         * @memberof quack.VapourPressureDeficit
         * @static
         * @param {quack.IVapourPressureDeficit=} [properties] Properties to set
         * @returns {quack.VapourPressureDeficit} VapourPressureDeficit instance
         */
        VapourPressureDeficit.create = function create(properties) {
            return new VapourPressureDeficit(properties);
        };

        /**
         * Creates a VapourPressureDeficit message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VapourPressureDeficit
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VapourPressureDeficit} VapourPressureDeficit
         */
        VapourPressureDeficit.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VapourPressureDeficit)
                return object;
            var message = new $root.quack.VapourPressureDeficit();
            if (object.pascals != null)
                message.pascals = object.pascals | 0;
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            if (object.relativeHumidityTimes_100 != null)
                message.relativeHumidityTimes_100 = object.relativeHumidityTimes_100 >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a VapourPressureDeficit message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VapourPressureDeficit
         * @static
         * @param {quack.VapourPressureDeficit} message VapourPressureDeficit
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VapourPressureDeficit.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.pascals = 0;
                object.celciusTimes_10 = 0;
                object.relativeHumidityTimes_100 = 0;
            }
            if (message.pascals != null && message.hasOwnProperty("pascals"))
                object.pascals = message.pascals;
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            if (message.relativeHumidityTimes_100 != null && message.hasOwnProperty("relativeHumidityTimes_100"))
                object.relativeHumidityTimes_100 = message.relativeHumidityTimes_100;
            return object;
        };

        /**
         * Converts this VapourPressureDeficit to JSON.
         * @function toJSON
         * @memberof quack.VapourPressureDeficit
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VapourPressureDeficit.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VapourPressureDeficit;
    })();

    quack.Weight = (function() {

        /**
         * Properties of a Weight.
         * @memberof quack
         * @interface IWeight
         * @property {number|null} [grams] Weight grams
         */

        /**
         * Constructs a new Weight.
         * @memberof quack
         * @classdesc Represents a Weight.
         * @implements IWeight
         * @constructor
         * @param {quack.IWeight=} [properties] Properties to set
         */
        function Weight(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Weight grams.
         * @member {number} grams
         * @memberof quack.Weight
         * @instance
         */
        Weight.prototype.grams = 0;

        /**
         * Creates a new Weight instance using the specified properties.
         * @function create
         * @memberof quack.Weight
         * @static
         * @param {quack.IWeight=} [properties] Properties to set
         * @returns {quack.Weight} Weight instance
         */
        Weight.create = function create(properties) {
            return new Weight(properties);
        };

        /**
         * Creates a Weight message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Weight
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Weight} Weight
         */
        Weight.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Weight)
                return object;
            var message = new $root.quack.Weight();
            if (object.grams != null)
                message.grams = object.grams >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Weight message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Weight
         * @static
         * @param {quack.Weight} message Weight
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Weight.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.grams = 0;
            if (message.grams != null && message.hasOwnProperty("grams"))
                object.grams = message.grams;
            return object;
        };

        /**
         * Converts this Weight to JSON.
         * @function toJSON
         * @memberof quack.Weight
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Weight.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Weight;
    })();

    quack.Distance = (function() {

        /**
         * Properties of a Distance.
         * @memberof quack
         * @interface IDistance
         * @property {number|null} [cm] Distance cm
         * @property {number|null} [errorCm] Distance errorCm
         */

        /**
         * Constructs a new Distance.
         * @memberof quack
         * @classdesc Represents a Distance.
         * @implements IDistance
         * @constructor
         * @param {quack.IDistance=} [properties] Properties to set
         */
        function Distance(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Distance cm.
         * @member {number} cm
         * @memberof quack.Distance
         * @instance
         */
        Distance.prototype.cm = 0;

        /**
         * Distance errorCm.
         * @member {number} errorCm
         * @memberof quack.Distance
         * @instance
         */
        Distance.prototype.errorCm = 0;

        /**
         * Creates a new Distance instance using the specified properties.
         * @function create
         * @memberof quack.Distance
         * @static
         * @param {quack.IDistance=} [properties] Properties to set
         * @returns {quack.Distance} Distance instance
         */
        Distance.create = function create(properties) {
            return new Distance(properties);
        };

        /**
         * Creates a Distance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Distance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Distance} Distance
         */
        Distance.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Distance)
                return object;
            var message = new $root.quack.Distance();
            if (object.cm != null)
                message.cm = object.cm >>> 0;
            if (object.errorCm != null)
                message.errorCm = object.errorCm >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a Distance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Distance
         * @static
         * @param {quack.Distance} message Distance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Distance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.cm = 0;
                object.errorCm = 0;
            }
            if (message.cm != null && message.hasOwnProperty("cm"))
                object.cm = message.cm;
            if (message.errorCm != null && message.hasOwnProperty("errorCm"))
                object.errorCm = message.errorCm;
            return object;
        };

        /**
         * Converts this Distance to JSON.
         * @function toJSON
         * @memberof quack.Distance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Distance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Distance;
    })();

    quack.Sen5x = (function() {

        /**
         * Properties of a Sen5x.
         * @memberof quack
         * @interface ISen5x
         * @property {number|null} [dust_1ug] Sen5x dust_1ug
         * @property {number|null} [dust_2ug] Sen5x dust_2ug
         * @property {number|null} [dust_4ug] Sen5x dust_4ug
         * @property {number|null} [dust_10ug] Sen5x dust_10ug
         * @property {number|null} [celciusTimes_10] Sen5x celciusTimes_10
         * @property {number|null} [relativeHumidityTimes_100] Sen5x relativeHumidityTimes_100
         * @property {number|null} [vocIndex] Sen5x vocIndex
         * @property {number|null} [noxIndex] Sen5x noxIndex
         */

        /**
         * Constructs a new Sen5x.
         * @memberof quack
         * @classdesc Represents a Sen5x.
         * @implements ISen5x
         * @constructor
         * @param {quack.ISen5x=} [properties] Properties to set
         */
        function Sen5x(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Sen5x dust_1ug.
         * @member {number} dust_1ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_1ug = 0;

        /**
         * Sen5x dust_2ug.
         * @member {number} dust_2ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_2ug = 0;

        /**
         * Sen5x dust_4ug.
         * @member {number} dust_4ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_4ug = 0;

        /**
         * Sen5x dust_10ug.
         * @member {number} dust_10ug
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.dust_10ug = 0;

        /**
         * Sen5x celciusTimes_10.
         * @member {number} celciusTimes_10
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.celciusTimes_10 = 0;

        /**
         * Sen5x relativeHumidityTimes_100.
         * @member {number} relativeHumidityTimes_100
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.relativeHumidityTimes_100 = 0;

        /**
         * Sen5x vocIndex.
         * @member {number} vocIndex
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.vocIndex = 0;

        /**
         * Sen5x noxIndex.
         * @member {number} noxIndex
         * @memberof quack.Sen5x
         * @instance
         */
        Sen5x.prototype.noxIndex = 0;

        /**
         * Creates a new Sen5x instance using the specified properties.
         * @function create
         * @memberof quack.Sen5x
         * @static
         * @param {quack.ISen5x=} [properties] Properties to set
         * @returns {quack.Sen5x} Sen5x instance
         */
        Sen5x.create = function create(properties) {
            return new Sen5x(properties);
        };

        /**
         * Creates a Sen5x message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Sen5x
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Sen5x} Sen5x
         */
        Sen5x.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Sen5x)
                return object;
            var message = new $root.quack.Sen5x();
            if (object.dust_1ug != null)
                message.dust_1ug = object.dust_1ug >>> 0;
            if (object.dust_2ug != null)
                message.dust_2ug = object.dust_2ug >>> 0;
            if (object.dust_4ug != null)
                message.dust_4ug = object.dust_4ug >>> 0;
            if (object.dust_10ug != null)
                message.dust_10ug = object.dust_10ug >>> 0;
            if (object.celciusTimes_10 != null)
                message.celciusTimes_10 = object.celciusTimes_10 | 0;
            if (object.relativeHumidityTimes_100 != null)
                message.relativeHumidityTimes_100 = object.relativeHumidityTimes_100 >>> 0;
            if (object.vocIndex != null)
                message.vocIndex = object.vocIndex | 0;
            if (object.noxIndex != null)
                message.noxIndex = object.noxIndex | 0;
            return message;
        };

        /**
         * Creates a plain object from a Sen5x message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Sen5x
         * @static
         * @param {quack.Sen5x} message Sen5x
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Sen5x.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.dust_1ug = 0;
                object.dust_2ug = 0;
                object.dust_4ug = 0;
                object.dust_10ug = 0;
                object.celciusTimes_10 = 0;
                object.relativeHumidityTimes_100 = 0;
                object.vocIndex = 0;
                object.noxIndex = 0;
            }
            if (message.dust_1ug != null && message.hasOwnProperty("dust_1ug"))
                object.dust_1ug = message.dust_1ug;
            if (message.dust_2ug != null && message.hasOwnProperty("dust_2ug"))
                object.dust_2ug = message.dust_2ug;
            if (message.dust_4ug != null && message.hasOwnProperty("dust_4ug"))
                object.dust_4ug = message.dust_4ug;
            if (message.dust_10ug != null && message.hasOwnProperty("dust_10ug"))
                object.dust_10ug = message.dust_10ug;
            if (message.celciusTimes_10 != null && message.hasOwnProperty("celciusTimes_10"))
                object.celciusTimes_10 = message.celciusTimes_10;
            if (message.relativeHumidityTimes_100 != null && message.hasOwnProperty("relativeHumidityTimes_100"))
                object.relativeHumidityTimes_100 = message.relativeHumidityTimes_100;
            if (message.vocIndex != null && message.hasOwnProperty("vocIndex"))
                object.vocIndex = message.vocIndex;
            if (message.noxIndex != null && message.hasOwnProperty("noxIndex"))
                object.noxIndex = message.noxIndex;
            return object;
        };

        /**
         * Converts this Sen5x to JSON.
         * @function toJSON
         * @memberof quack.Sen5x
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Sen5x.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Sen5x;
    })();

    quack.PressureCable = (function() {

        /**
         * Properties of a PressureCable.
         * @memberof quack
         * @interface IPressureCable
         * @property {Array.<number>|null} [pascals] PressureCable pascals
         */

        /**
         * Constructs a new PressureCable.
         * @memberof quack
         * @classdesc Represents a PressureCable.
         * @implements IPressureCable
         * @constructor
         * @param {quack.IPressureCable=} [properties] Properties to set
         */
        function PressureCable(properties) {
            this.pascals = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PressureCable pascals.
         * @member {Array.<number>} pascals
         * @memberof quack.PressureCable
         * @instance
         */
        PressureCable.prototype.pascals = $util.emptyArray;

        /**
         * Creates a new PressureCable instance using the specified properties.
         * @function create
         * @memberof quack.PressureCable
         * @static
         * @param {quack.IPressureCable=} [properties] Properties to set
         * @returns {quack.PressureCable} PressureCable instance
         */
        PressureCable.create = function create(properties) {
            return new PressureCable(properties);
        };

        /**
         * Creates a PressureCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.PressureCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.PressureCable} PressureCable
         */
        PressureCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.PressureCable)
                return object;
            var message = new $root.quack.PressureCable();
            if (object.pascals) {
                if (!Array.isArray(object.pascals))
                    throw TypeError(".quack.PressureCable.pascals: array expected");
                message.pascals = [];
                for (var i = 0; i < object.pascals.length; ++i)
                    message.pascals[i] = object.pascals[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a PressureCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.PressureCable
         * @static
         * @param {quack.PressureCable} message PressureCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PressureCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pascals = [];
            if (message.pascals && message.pascals.length) {
                object.pascals = [];
                for (var j = 0; j < message.pascals.length; ++j)
                    object.pascals[j] = message.pascals[j];
            }
            return object;
        };

        /**
         * Converts this PressureCable to JSON.
         * @function toJSON
         * @memberof quack.PressureCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PressureCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PressureCable;
    })();

    quack.VibrationCable = (function() {

        /**
         * Properties of a VibrationCable.
         * @memberof quack
         * @interface IVibrationCable
         * @property {Array.<number>|null} [frequency] VibrationCable frequency
         * @property {Array.<number>|null} [singleAccelerationRms] VibrationCable singleAccelerationRms
         * @property {number|null} [totalAccelerationRms] VibrationCable totalAccelerationRms
         */

        /**
         * Constructs a new VibrationCable.
         * @memberof quack
         * @classdesc Represents a VibrationCable.
         * @implements IVibrationCable
         * @constructor
         * @param {quack.IVibrationCable=} [properties] Properties to set
         */
        function VibrationCable(properties) {
            this.frequency = [];
            this.singleAccelerationRms = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VibrationCable frequency.
         * @member {Array.<number>} frequency
         * @memberof quack.VibrationCable
         * @instance
         */
        VibrationCable.prototype.frequency = $util.emptyArray;

        /**
         * VibrationCable singleAccelerationRms.
         * @member {Array.<number>} singleAccelerationRms
         * @memberof quack.VibrationCable
         * @instance
         */
        VibrationCable.prototype.singleAccelerationRms = $util.emptyArray;

        /**
         * VibrationCable totalAccelerationRms.
         * @member {number} totalAccelerationRms
         * @memberof quack.VibrationCable
         * @instance
         */
        VibrationCable.prototype.totalAccelerationRms = 0;

        /**
         * Creates a new VibrationCable instance using the specified properties.
         * @function create
         * @memberof quack.VibrationCable
         * @static
         * @param {quack.IVibrationCable=} [properties] Properties to set
         * @returns {quack.VibrationCable} VibrationCable instance
         */
        VibrationCable.create = function create(properties) {
            return new VibrationCable(properties);
        };

        /**
         * Creates a VibrationCable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VibrationCable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VibrationCable} VibrationCable
         */
        VibrationCable.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VibrationCable)
                return object;
            var message = new $root.quack.VibrationCable();
            if (object.frequency) {
                if (!Array.isArray(object.frequency))
                    throw TypeError(".quack.VibrationCable.frequency: array expected");
                message.frequency = [];
                for (var i = 0; i < object.frequency.length; ++i)
                    message.frequency[i] = object.frequency[i] >>> 0;
            }
            if (object.singleAccelerationRms) {
                if (!Array.isArray(object.singleAccelerationRms))
                    throw TypeError(".quack.VibrationCable.singleAccelerationRms: array expected");
                message.singleAccelerationRms = [];
                for (var i = 0; i < object.singleAccelerationRms.length; ++i)
                    message.singleAccelerationRms[i] = object.singleAccelerationRms[i] >>> 0;
            }
            if (object.totalAccelerationRms != null)
                message.totalAccelerationRms = object.totalAccelerationRms >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a VibrationCable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VibrationCable
         * @static
         * @param {quack.VibrationCable} message VibrationCable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VibrationCable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.frequency = [];
                object.singleAccelerationRms = [];
            }
            if (options.defaults)
                object.totalAccelerationRms = 0;
            if (message.frequency && message.frequency.length) {
                object.frequency = [];
                for (var j = 0; j < message.frequency.length; ++j)
                    object.frequency[j] = message.frequency[j];
            }
            if (message.singleAccelerationRms && message.singleAccelerationRms.length) {
                object.singleAccelerationRms = [];
                for (var j = 0; j < message.singleAccelerationRms.length; ++j)
                    object.singleAccelerationRms[j] = message.singleAccelerationRms[j];
            }
            if (message.totalAccelerationRms != null && message.hasOwnProperty("totalAccelerationRms"))
                object.totalAccelerationRms = message.totalAccelerationRms;
            return object;
        };

        /**
         * Converts this VibrationCable to JSON.
         * @function toJSON
         * @memberof quack.VibrationCable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VibrationCable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VibrationCable;
    })();

    quack.DragerGasDongle = (function() {

        /**
         * Properties of a DragerGasDongle.
         * @memberof quack
         * @interface IDragerGasDongle
         * @property {Array.<number>|null} [ppm] DragerGasDongle ppm
         * @property {Array.<number>|null} [millivolts] DragerGasDongle millivolts
         */

        /**
         * Constructs a new DragerGasDongle.
         * @memberof quack
         * @classdesc Represents a DragerGasDongle.
         * @implements IDragerGasDongle
         * @constructor
         * @param {quack.IDragerGasDongle=} [properties] Properties to set
         */
        function DragerGasDongle(properties) {
            this.ppm = [];
            this.millivolts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DragerGasDongle ppm.
         * @member {Array.<number>} ppm
         * @memberof quack.DragerGasDongle
         * @instance
         */
        DragerGasDongle.prototype.ppm = $util.emptyArray;

        /**
         * DragerGasDongle millivolts.
         * @member {Array.<number>} millivolts
         * @memberof quack.DragerGasDongle
         * @instance
         */
        DragerGasDongle.prototype.millivolts = $util.emptyArray;

        /**
         * Creates a new DragerGasDongle instance using the specified properties.
         * @function create
         * @memberof quack.DragerGasDongle
         * @static
         * @param {quack.IDragerGasDongle=} [properties] Properties to set
         * @returns {quack.DragerGasDongle} DragerGasDongle instance
         */
        DragerGasDongle.create = function create(properties) {
            return new DragerGasDongle(properties);
        };

        /**
         * Creates a DragerGasDongle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.DragerGasDongle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.DragerGasDongle} DragerGasDongle
         */
        DragerGasDongle.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.DragerGasDongle)
                return object;
            var message = new $root.quack.DragerGasDongle();
            if (object.ppm) {
                if (!Array.isArray(object.ppm))
                    throw TypeError(".quack.DragerGasDongle.ppm: array expected");
                message.ppm = [];
                for (var i = 0; i < object.ppm.length; ++i)
                    message.ppm[i] = Number(object.ppm[i]);
            }
            if (object.millivolts) {
                if (!Array.isArray(object.millivolts))
                    throw TypeError(".quack.DragerGasDongle.millivolts: array expected");
                message.millivolts = [];
                for (var i = 0; i < object.millivolts.length; ++i)
                    message.millivolts[i] = object.millivolts[i] >>> 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a DragerGasDongle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.DragerGasDongle
         * @static
         * @param {quack.DragerGasDongle} message DragerGasDongle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DragerGasDongle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.ppm = [];
                object.millivolts = [];
            }
            if (message.ppm && message.ppm.length) {
                object.ppm = [];
                for (var j = 0; j < message.ppm.length; ++j)
                    object.ppm[j] = options.json && !isFinite(message.ppm[j]) ? String(message.ppm[j]) : message.ppm[j];
            }
            if (message.millivolts && message.millivolts.length) {
                object.millivolts = [];
                for (var j = 0; j < message.millivolts.length; ++j)
                    object.millivolts[j] = message.millivolts[j];
            }
            return object;
        };

        /**
         * Converts this DragerGasDongle to JSON.
         * @function toJSON
         * @memberof quack.DragerGasDongle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DragerGasDongle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DragerGasDongle;
    })();

    quack.AirFlow = (function() {

        /**
         * Properties of an AirFlow.
         * @memberof quack
         * @interface IAirFlow
         * @property {number|null} [cfm] AirFlow cfm
         */

        /**
         * Constructs a new AirFlow.
         * @memberof quack
         * @classdesc Represents an AirFlow.
         * @implements IAirFlow
         * @constructor
         * @param {quack.IAirFlow=} [properties] Properties to set
         */
        function AirFlow(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AirFlow cfm.
         * @member {number} cfm
         * @memberof quack.AirFlow
         * @instance
         */
        AirFlow.prototype.cfm = 0;

        /**
         * Creates a new AirFlow instance using the specified properties.
         * @function create
         * @memberof quack.AirFlow
         * @static
         * @param {quack.IAirFlow=} [properties] Properties to set
         * @returns {quack.AirFlow} AirFlow instance
         */
        AirFlow.create = function create(properties) {
            return new AirFlow(properties);
        };

        /**
         * Creates an AirFlow message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AirFlow
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AirFlow} AirFlow
         */
        AirFlow.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AirFlow)
                return object;
            var message = new $root.quack.AirFlow();
            if (object.cfm != null)
                message.cfm = Number(object.cfm);
            return message;
        };

        /**
         * Creates a plain object from an AirFlow message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AirFlow
         * @static
         * @param {quack.AirFlow} message AirFlow
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AirFlow.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.cfm = 0;
            if (message.cfm != null && message.hasOwnProperty("cfm"))
                object.cfm = options.json && !isFinite(message.cfm) ? String(message.cfm) : message.cfm;
            return object;
        };

        /**
         * Converts this AirFlow to JSON.
         * @function toJSON
         * @memberof quack.AirFlow
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AirFlow.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AirFlow;
    })();

    quack.VirtualMeasurement = (function() {

        /**
         * Properties of a VirtualMeasurement.
         * @memberof quack
         * @interface IVirtualMeasurement
         * @property {quack.Measurement|null} [vMeasurement] VirtualMeasurement vMeasurement
         */

        /**
         * Constructs a new VirtualMeasurement.
         * @memberof quack
         * @classdesc Represents a VirtualMeasurement.
         * @implements IVirtualMeasurement
         * @constructor
         * @param {quack.IVirtualMeasurement=} [properties] Properties to set
         */
        function VirtualMeasurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VirtualMeasurement vMeasurement.
         * @member {quack.Measurement|null|undefined} vMeasurement
         * @memberof quack.VirtualMeasurement
         * @instance
         */
        VirtualMeasurement.prototype.vMeasurement = null;

        /**
         * Creates a new VirtualMeasurement instance using the specified properties.
         * @function create
         * @memberof quack.VirtualMeasurement
         * @static
         * @param {quack.IVirtualMeasurement=} [properties] Properties to set
         * @returns {quack.VirtualMeasurement} VirtualMeasurement instance
         */
        VirtualMeasurement.create = function create(properties) {
            return new VirtualMeasurement(properties);
        };

        /**
         * Creates a VirtualMeasurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.VirtualMeasurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.VirtualMeasurement} VirtualMeasurement
         */
        VirtualMeasurement.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.VirtualMeasurement)
                return object;
            var message = new $root.quack.VirtualMeasurement();
            if (object.vMeasurement != null) {
                if (typeof object.vMeasurement !== "object")
                    throw TypeError(".quack.VirtualMeasurement.vMeasurement: object expected");
                message.vMeasurement = $root.quack.Measurement.fromObject(object.vMeasurement);
            }
            return message;
        };

        /**
         * Creates a plain object from a VirtualMeasurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.VirtualMeasurement
         * @static
         * @param {quack.VirtualMeasurement} message VirtualMeasurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VirtualMeasurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.vMeasurement = null;
            if (message.vMeasurement != null && message.hasOwnProperty("vMeasurement"))
                object.vMeasurement = $root.quack.Measurement.toObject(message.vMeasurement, options);
            return object;
        };

        /**
         * Converts this VirtualMeasurement to JSON.
         * @function toJSON
         * @memberof quack.VirtualMeasurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VirtualMeasurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return VirtualMeasurement;
    })();

    quack.Measurement = (function() {

        /**
         * Properties of a Measurement.
         * @memberof quack
         * @interface IMeasurement
         * @property {quack.ComponentID|null} [id] Measurement id
         * @property {number|null} [subtype] Measurement subtype
         * @property {boolean|null} [triggered] Measurement triggered
         * @property {quack.Temperature|null} [temperature] Measurement temperature
         * @property {quack.EdgeTriggered|null} [edgeTriggered] Measurement edgeTriggered
         * @property {quack.Power|null} [power] Measurement power
         * @property {quack.GrainCable|null} [grainCable] Measurement grainCable
         * @property {quack.BooleanOutput|null} [booleanOutput] Measurement booleanOutput
         * @property {quack.Pressure|null} [pressure] Measurement pressure
         * @property {quack.GPS|null} [gps] Measurement gps
         * @property {quack.BooleanInput|null} [booleanInput] Measurement booleanInput
         * @property {quack.HumidityAndTemperature|null} [humidityAndTemperature] Measurement humidityAndTemperature
         * @property {quack.ModemSignal|null} [modemSignal] Measurement modemSignal
         * @property {quack.Light|null} [light] Measurement light
         * @property {quack.Gas|null} [gas] Measurement gas
         * @property {quack.StepperMotor|null} [stepperMotor] Measurement stepperMotor
         * @property {quack.AnalogInput|null} [analogInput] Measurement analogInput
         * @property {quack.ORP|null} [orp] Measurement orp
         * @property {quack.PH|null} [ph] Measurement ph
         * @property {quack.Voltage|null} [voltage] Measurement voltage
         * @property {quack.Concentration|null} [concentration] Measurement concentration
         * @property {quack.Conductivity|null} [conductivity] Measurement conductivity
         * @property {quack.Capacitance|null} [capacitance] Measurement capacitance
         * @property {quack.VapourPressureDeficit|null} [vpd] Measurement vpd
         * @property {quack.Weight|null} [weight] Measurement weight
         * @property {quack.Distance|null} [distance] Measurement distance
         * @property {quack.PressureCable|null} [pressureCable] Measurement pressureCable
         * @property {quack.CapacitorCable|null} [capacitorCable] Measurement capacitorCable
         * @property {quack.Sen5x|null} [sen5x] Measurement sen5x
         * @property {quack.VibrationCable|null} [vibrationCable] Measurement vibrationCable
         * @property {quack.DragerGasDongle|null} [dragerGasDongle] Measurement dragerGasDongle
         * @property {quack.AirFlow|null} [airflow] Measurement airflow
         */

        /**
         * Constructs a new Measurement.
         * @memberof quack
         * @classdesc Represents a Measurement.
         * @implements IMeasurement
         * @constructor
         * @param {quack.IMeasurement=} [properties] Properties to set
         */
        function Measurement(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Measurement id.
         * @member {quack.ComponentID|null|undefined} id
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.id = null;

        /**
         * Measurement subtype.
         * @member {number} subtype
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.subtype = 0;

        /**
         * Measurement triggered.
         * @member {boolean} triggered
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.triggered = false;

        /**
         * Measurement temperature.
         * @member {quack.Temperature|null|undefined} temperature
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.temperature = null;

        /**
         * Measurement edgeTriggered.
         * @member {quack.EdgeTriggered|null|undefined} edgeTriggered
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.edgeTriggered = null;

        /**
         * Measurement power.
         * @member {quack.Power|null|undefined} power
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.power = null;

        /**
         * Measurement grainCable.
         * @member {quack.GrainCable|null|undefined} grainCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.grainCable = null;

        /**
         * Measurement booleanOutput.
         * @member {quack.BooleanOutput|null|undefined} booleanOutput
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.booleanOutput = null;

        /**
         * Measurement pressure.
         * @member {quack.Pressure|null|undefined} pressure
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.pressure = null;

        /**
         * Measurement gps.
         * @member {quack.GPS|null|undefined} gps
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.gps = null;

        /**
         * Measurement booleanInput.
         * @member {quack.BooleanInput|null|undefined} booleanInput
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.booleanInput = null;

        /**
         * Measurement humidityAndTemperature.
         * @member {quack.HumidityAndTemperature|null|undefined} humidityAndTemperature
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.humidityAndTemperature = null;

        /**
         * Measurement modemSignal.
         * @member {quack.ModemSignal|null|undefined} modemSignal
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.modemSignal = null;

        /**
         * Measurement light.
         * @member {quack.Light|null|undefined} light
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.light = null;

        /**
         * Measurement gas.
         * @member {quack.Gas|null|undefined} gas
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.gas = null;

        /**
         * Measurement stepperMotor.
         * @member {quack.StepperMotor|null|undefined} stepperMotor
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.stepperMotor = null;

        /**
         * Measurement analogInput.
         * @member {quack.AnalogInput|null|undefined} analogInput
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.analogInput = null;

        /**
         * Measurement orp.
         * @member {quack.ORP|null|undefined} orp
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.orp = null;

        /**
         * Measurement ph.
         * @member {quack.PH|null|undefined} ph
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.ph = null;

        /**
         * Measurement voltage.
         * @member {quack.Voltage|null|undefined} voltage
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.voltage = null;

        /**
         * Measurement concentration.
         * @member {quack.Concentration|null|undefined} concentration
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.concentration = null;

        /**
         * Measurement conductivity.
         * @member {quack.Conductivity|null|undefined} conductivity
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.conductivity = null;

        /**
         * Measurement capacitance.
         * @member {quack.Capacitance|null|undefined} capacitance
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.capacitance = null;

        /**
         * Measurement vpd.
         * @member {quack.VapourPressureDeficit|null|undefined} vpd
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.vpd = null;

        /**
         * Measurement weight.
         * @member {quack.Weight|null|undefined} weight
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.weight = null;

        /**
         * Measurement distance.
         * @member {quack.Distance|null|undefined} distance
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.distance = null;

        /**
         * Measurement pressureCable.
         * @member {quack.PressureCable|null|undefined} pressureCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.pressureCable = null;

        /**
         * Measurement capacitorCable.
         * @member {quack.CapacitorCable|null|undefined} capacitorCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.capacitorCable = null;

        /**
         * Measurement sen5x.
         * @member {quack.Sen5x|null|undefined} sen5x
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.sen5x = null;

        /**
         * Measurement vibrationCable.
         * @member {quack.VibrationCable|null|undefined} vibrationCable
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.vibrationCable = null;

        /**
         * Measurement dragerGasDongle.
         * @member {quack.DragerGasDongle|null|undefined} dragerGasDongle
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.dragerGasDongle = null;

        /**
         * Measurement airflow.
         * @member {quack.AirFlow|null|undefined} airflow
         * @memberof quack.Measurement
         * @instance
         */
        Measurement.prototype.airflow = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Measurement measurement.
         * @member {"temperature"|"edgeTriggered"|"power"|"grainCable"|"booleanOutput"|"pressure"|"gps"|"booleanInput"|"humidityAndTemperature"|"modemSignal"|"light"|"gas"|"stepperMotor"|"analogInput"|"orp"|"ph"|"voltage"|"concentration"|"conductivity"|"capacitance"|"vpd"|"weight"|"distance"|"pressureCable"|"capacitorCable"|"sen5x"|"vibrationCable"|"dragerGasDongle"|"airflow"|undefined} measurement
         * @memberof quack.Measurement
         * @instance
         */
        Object.defineProperty(Measurement.prototype, "measurement", {
            get: $util.oneOfGetter($oneOfFields = ["temperature", "edgeTriggered", "power", "grainCable", "booleanOutput", "pressure", "gps", "booleanInput", "humidityAndTemperature", "modemSignal", "light", "gas", "stepperMotor", "analogInput", "orp", "ph", "voltage", "concentration", "conductivity", "capacitance", "vpd", "weight", "distance", "pressureCable", "capacitorCable", "sen5x", "vibrationCable", "dragerGasDongle", "airflow"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Measurement instance using the specified properties.
         * @function create
         * @memberof quack.Measurement
         * @static
         * @param {quack.IMeasurement=} [properties] Properties to set
         * @returns {quack.Measurement} Measurement instance
         */
        Measurement.create = function create(properties) {
            return new Measurement(properties);
        };

        /**
         * Creates a Measurement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Measurement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Measurement} Measurement
         */
        Measurement.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Measurement)
                return object;
            var message = new $root.quack.Measurement();
            if (object.id != null) {
                if (typeof object.id !== "object")
                    throw TypeError(".quack.Measurement.id: object expected");
                message.id = $root.quack.ComponentID.fromObject(object.id);
            }
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            if (object.triggered != null)
                message.triggered = Boolean(object.triggered);
            if (object.temperature != null) {
                if (typeof object.temperature !== "object")
                    throw TypeError(".quack.Measurement.temperature: object expected");
                message.temperature = $root.quack.Temperature.fromObject(object.temperature);
            }
            if (object.edgeTriggered != null) {
                if (typeof object.edgeTriggered !== "object")
                    throw TypeError(".quack.Measurement.edgeTriggered: object expected");
                message.edgeTriggered = $root.quack.EdgeTriggered.fromObject(object.edgeTriggered);
            }
            if (object.power != null) {
                if (typeof object.power !== "object")
                    throw TypeError(".quack.Measurement.power: object expected");
                message.power = $root.quack.Power.fromObject(object.power);
            }
            if (object.grainCable != null) {
                if (typeof object.grainCable !== "object")
                    throw TypeError(".quack.Measurement.grainCable: object expected");
                message.grainCable = $root.quack.GrainCable.fromObject(object.grainCable);
            }
            if (object.booleanOutput != null) {
                if (typeof object.booleanOutput !== "object")
                    throw TypeError(".quack.Measurement.booleanOutput: object expected");
                message.booleanOutput = $root.quack.BooleanOutput.fromObject(object.booleanOutput);
            }
            if (object.pressure != null) {
                if (typeof object.pressure !== "object")
                    throw TypeError(".quack.Measurement.pressure: object expected");
                message.pressure = $root.quack.Pressure.fromObject(object.pressure);
            }
            if (object.gps != null) {
                if (typeof object.gps !== "object")
                    throw TypeError(".quack.Measurement.gps: object expected");
                message.gps = $root.quack.GPS.fromObject(object.gps);
            }
            if (object.booleanInput != null) {
                if (typeof object.booleanInput !== "object")
                    throw TypeError(".quack.Measurement.booleanInput: object expected");
                message.booleanInput = $root.quack.BooleanInput.fromObject(object.booleanInput);
            }
            if (object.humidityAndTemperature != null) {
                if (typeof object.humidityAndTemperature !== "object")
                    throw TypeError(".quack.Measurement.humidityAndTemperature: object expected");
                message.humidityAndTemperature = $root.quack.HumidityAndTemperature.fromObject(object.humidityAndTemperature);
            }
            if (object.modemSignal != null) {
                if (typeof object.modemSignal !== "object")
                    throw TypeError(".quack.Measurement.modemSignal: object expected");
                message.modemSignal = $root.quack.ModemSignal.fromObject(object.modemSignal);
            }
            if (object.light != null) {
                if (typeof object.light !== "object")
                    throw TypeError(".quack.Measurement.light: object expected");
                message.light = $root.quack.Light.fromObject(object.light);
            }
            if (object.gas != null) {
                if (typeof object.gas !== "object")
                    throw TypeError(".quack.Measurement.gas: object expected");
                message.gas = $root.quack.Gas.fromObject(object.gas);
            }
            if (object.stepperMotor != null) {
                if (typeof object.stepperMotor !== "object")
                    throw TypeError(".quack.Measurement.stepperMotor: object expected");
                message.stepperMotor = $root.quack.StepperMotor.fromObject(object.stepperMotor);
            }
            if (object.analogInput != null) {
                if (typeof object.analogInput !== "object")
                    throw TypeError(".quack.Measurement.analogInput: object expected");
                message.analogInput = $root.quack.AnalogInput.fromObject(object.analogInput);
            }
            if (object.orp != null) {
                if (typeof object.orp !== "object")
                    throw TypeError(".quack.Measurement.orp: object expected");
                message.orp = $root.quack.ORP.fromObject(object.orp);
            }
            if (object.ph != null) {
                if (typeof object.ph !== "object")
                    throw TypeError(".quack.Measurement.ph: object expected");
                message.ph = $root.quack.PH.fromObject(object.ph);
            }
            if (object.voltage != null) {
                if (typeof object.voltage !== "object")
                    throw TypeError(".quack.Measurement.voltage: object expected");
                message.voltage = $root.quack.Voltage.fromObject(object.voltage);
            }
            if (object.concentration != null) {
                if (typeof object.concentration !== "object")
                    throw TypeError(".quack.Measurement.concentration: object expected");
                message.concentration = $root.quack.Concentration.fromObject(object.concentration);
            }
            if (object.conductivity != null) {
                if (typeof object.conductivity !== "object")
                    throw TypeError(".quack.Measurement.conductivity: object expected");
                message.conductivity = $root.quack.Conductivity.fromObject(object.conductivity);
            }
            if (object.capacitance != null) {
                if (typeof object.capacitance !== "object")
                    throw TypeError(".quack.Measurement.capacitance: object expected");
                message.capacitance = $root.quack.Capacitance.fromObject(object.capacitance);
            }
            if (object.vpd != null) {
                if (typeof object.vpd !== "object")
                    throw TypeError(".quack.Measurement.vpd: object expected");
                message.vpd = $root.quack.VapourPressureDeficit.fromObject(object.vpd);
            }
            if (object.weight != null) {
                if (typeof object.weight !== "object")
                    throw TypeError(".quack.Measurement.weight: object expected");
                message.weight = $root.quack.Weight.fromObject(object.weight);
            }
            if (object.distance != null) {
                if (typeof object.distance !== "object")
                    throw TypeError(".quack.Measurement.distance: object expected");
                message.distance = $root.quack.Distance.fromObject(object.distance);
            }
            if (object.pressureCable != null) {
                if (typeof object.pressureCable !== "object")
                    throw TypeError(".quack.Measurement.pressureCable: object expected");
                message.pressureCable = $root.quack.PressureCable.fromObject(object.pressureCable);
            }
            if (object.capacitorCable != null) {
                if (typeof object.capacitorCable !== "object")
                    throw TypeError(".quack.Measurement.capacitorCable: object expected");
                message.capacitorCable = $root.quack.CapacitorCable.fromObject(object.capacitorCable);
            }
            if (object.sen5x != null) {
                if (typeof object.sen5x !== "object")
                    throw TypeError(".quack.Measurement.sen5x: object expected");
                message.sen5x = $root.quack.Sen5x.fromObject(object.sen5x);
            }
            if (object.vibrationCable != null) {
                if (typeof object.vibrationCable !== "object")
                    throw TypeError(".quack.Measurement.vibrationCable: object expected");
                message.vibrationCable = $root.quack.VibrationCable.fromObject(object.vibrationCable);
            }
            if (object.dragerGasDongle != null) {
                if (typeof object.dragerGasDongle !== "object")
                    throw TypeError(".quack.Measurement.dragerGasDongle: object expected");
                message.dragerGasDongle = $root.quack.DragerGasDongle.fromObject(object.dragerGasDongle);
            }
            if (object.airflow != null) {
                if (typeof object.airflow !== "object")
                    throw TypeError(".quack.Measurement.airflow: object expected");
                message.airflow = $root.quack.AirFlow.fromObject(object.airflow);
            }
            return message;
        };

        /**
         * Creates a plain object from a Measurement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Measurement
         * @static
         * @param {quack.Measurement} message Measurement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Measurement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = null;
                object.subtype = 0;
                object.triggered = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = $root.quack.ComponentID.toObject(message.id, options);
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            if (message.triggered != null && message.hasOwnProperty("triggered"))
                object.triggered = message.triggered;
            if (message.temperature != null && message.hasOwnProperty("temperature")) {
                object.temperature = $root.quack.Temperature.toObject(message.temperature, options);
                if (options.oneofs)
                    object.measurement = "temperature";
            }
            if (message.edgeTriggered != null && message.hasOwnProperty("edgeTriggered")) {
                object.edgeTriggered = $root.quack.EdgeTriggered.toObject(message.edgeTriggered, options);
                if (options.oneofs)
                    object.measurement = "edgeTriggered";
            }
            if (message.power != null && message.hasOwnProperty("power")) {
                object.power = $root.quack.Power.toObject(message.power, options);
                if (options.oneofs)
                    object.measurement = "power";
            }
            if (message.grainCable != null && message.hasOwnProperty("grainCable")) {
                object.grainCable = $root.quack.GrainCable.toObject(message.grainCable, options);
                if (options.oneofs)
                    object.measurement = "grainCable";
            }
            if (message.booleanOutput != null && message.hasOwnProperty("booleanOutput")) {
                object.booleanOutput = $root.quack.BooleanOutput.toObject(message.booleanOutput, options);
                if (options.oneofs)
                    object.measurement = "booleanOutput";
            }
            if (message.pressure != null && message.hasOwnProperty("pressure")) {
                object.pressure = $root.quack.Pressure.toObject(message.pressure, options);
                if (options.oneofs)
                    object.measurement = "pressure";
            }
            if (message.gps != null && message.hasOwnProperty("gps")) {
                object.gps = $root.quack.GPS.toObject(message.gps, options);
                if (options.oneofs)
                    object.measurement = "gps";
            }
            if (message.booleanInput != null && message.hasOwnProperty("booleanInput")) {
                object.booleanInput = $root.quack.BooleanInput.toObject(message.booleanInput, options);
                if (options.oneofs)
                    object.measurement = "booleanInput";
            }
            if (message.humidityAndTemperature != null && message.hasOwnProperty("humidityAndTemperature")) {
                object.humidityAndTemperature = $root.quack.HumidityAndTemperature.toObject(message.humidityAndTemperature, options);
                if (options.oneofs)
                    object.measurement = "humidityAndTemperature";
            }
            if (message.modemSignal != null && message.hasOwnProperty("modemSignal")) {
                object.modemSignal = $root.quack.ModemSignal.toObject(message.modemSignal, options);
                if (options.oneofs)
                    object.measurement = "modemSignal";
            }
            if (message.light != null && message.hasOwnProperty("light")) {
                object.light = $root.quack.Light.toObject(message.light, options);
                if (options.oneofs)
                    object.measurement = "light";
            }
            if (message.gas != null && message.hasOwnProperty("gas")) {
                object.gas = $root.quack.Gas.toObject(message.gas, options);
                if (options.oneofs)
                    object.measurement = "gas";
            }
            if (message.stepperMotor != null && message.hasOwnProperty("stepperMotor")) {
                object.stepperMotor = $root.quack.StepperMotor.toObject(message.stepperMotor, options);
                if (options.oneofs)
                    object.measurement = "stepperMotor";
            }
            if (message.analogInput != null && message.hasOwnProperty("analogInput")) {
                object.analogInput = $root.quack.AnalogInput.toObject(message.analogInput, options);
                if (options.oneofs)
                    object.measurement = "analogInput";
            }
            if (message.orp != null && message.hasOwnProperty("orp")) {
                object.orp = $root.quack.ORP.toObject(message.orp, options);
                if (options.oneofs)
                    object.measurement = "orp";
            }
            if (message.ph != null && message.hasOwnProperty("ph")) {
                object.ph = $root.quack.PH.toObject(message.ph, options);
                if (options.oneofs)
                    object.measurement = "ph";
            }
            if (message.voltage != null && message.hasOwnProperty("voltage")) {
                object.voltage = $root.quack.Voltage.toObject(message.voltage, options);
                if (options.oneofs)
                    object.measurement = "voltage";
            }
            if (message.concentration != null && message.hasOwnProperty("concentration")) {
                object.concentration = $root.quack.Concentration.toObject(message.concentration, options);
                if (options.oneofs)
                    object.measurement = "concentration";
            }
            if (message.conductivity != null && message.hasOwnProperty("conductivity")) {
                object.conductivity = $root.quack.Conductivity.toObject(message.conductivity, options);
                if (options.oneofs)
                    object.measurement = "conductivity";
            }
            if (message.capacitance != null && message.hasOwnProperty("capacitance")) {
                object.capacitance = $root.quack.Capacitance.toObject(message.capacitance, options);
                if (options.oneofs)
                    object.measurement = "capacitance";
            }
            if (message.vpd != null && message.hasOwnProperty("vpd")) {
                object.vpd = $root.quack.VapourPressureDeficit.toObject(message.vpd, options);
                if (options.oneofs)
                    object.measurement = "vpd";
            }
            if (message.weight != null && message.hasOwnProperty("weight")) {
                object.weight = $root.quack.Weight.toObject(message.weight, options);
                if (options.oneofs)
                    object.measurement = "weight";
            }
            if (message.distance != null && message.hasOwnProperty("distance")) {
                object.distance = $root.quack.Distance.toObject(message.distance, options);
                if (options.oneofs)
                    object.measurement = "distance";
            }
            if (message.pressureCable != null && message.hasOwnProperty("pressureCable")) {
                object.pressureCable = $root.quack.PressureCable.toObject(message.pressureCable, options);
                if (options.oneofs)
                    object.measurement = "pressureCable";
            }
            if (message.capacitorCable != null && message.hasOwnProperty("capacitorCable")) {
                object.capacitorCable = $root.quack.CapacitorCable.toObject(message.capacitorCable, options);
                if (options.oneofs)
                    object.measurement = "capacitorCable";
            }
            if (message.sen5x != null && message.hasOwnProperty("sen5x")) {
                object.sen5x = $root.quack.Sen5x.toObject(message.sen5x, options);
                if (options.oneofs)
                    object.measurement = "sen5x";
            }
            if (message.vibrationCable != null && message.hasOwnProperty("vibrationCable")) {
                object.vibrationCable = $root.quack.VibrationCable.toObject(message.vibrationCable, options);
                if (options.oneofs)
                    object.measurement = "vibrationCable";
            }
            if (message.dragerGasDongle != null && message.hasOwnProperty("dragerGasDongle")) {
                object.dragerGasDongle = $root.quack.DragerGasDongle.toObject(message.dragerGasDongle, options);
                if (options.oneofs)
                    object.measurement = "dragerGasDongle";
            }
            if (message.airflow != null && message.hasOwnProperty("airflow")) {
                object.airflow = $root.quack.AirFlow.toObject(message.airflow, options);
                if (options.oneofs)
                    object.measurement = "airflow";
            }
            return object;
        };

        /**
         * Converts this Measurement to JSON.
         * @function toJSON
         * @memberof quack.Measurement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Measurement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Measurement;
    })();

    /**
     * MeasurementType enum.
     * @name quack.MeasurementType
     * @enum {string}
     * @property {number} MEASUREMENT_TYPE_INVALID=0 MEASUREMENT_TYPE_INVALID value
     * @property {number} MEASUREMENT_TYPE_TEMPERATURE=1 MEASUREMENT_TYPE_TEMPERATURE value
     * @property {number} MEASUREMENT_TYPE_BOOLEAN=2 MEASUREMENT_TYPE_BOOLEAN value
     * @property {number} MEASUREMENT_TYPE_VOLTAGE=3 MEASUREMENT_TYPE_VOLTAGE value
     * @property {number} MEASUREMENT_TYPE_PERCENT=4 MEASUREMENT_TYPE_PERCENT value
     * @property {number} MEASUREMENT_TYPE_PRESSURE=5 MEASUREMENT_TYPE_PRESSURE value
     * @property {number} MEASUREMENT_TYPE_RSSI=6 MEASUREMENT_TYPE_RSSI value
     * @property {number} MEASUREMENT_TYPE_LIGHT=7 MEASUREMENT_TYPE_LIGHT value
     * @property {number} MEASUREMENT_TYPE_PPM=8 MEASUREMENT_TYPE_PPM value
     * @property {number} MEASUREMENT_TYPE_ANALOG=9 MEASUREMENT_TYPE_ANALOG value
     * @property {number} MEASUREMENT_TYPE_ORP=10 MEASUREMENT_TYPE_ORP value
     * @property {number} MEASUREMENT_TYPE_PH=11 MEASUREMENT_TYPE_PH value
     * @property {number} MEASUREMENT_TYPE_PPB=12 MEASUREMENT_TYPE_PPB value
     * @property {number} MEASUREMENT_TYPE_CONDUCTIVITY=13 MEASUREMENT_TYPE_CONDUCTIVITY value
     * @property {number} MEASUREMENT_TYPE_CAPACITANCE=14 MEASUREMENT_TYPE_CAPACITANCE value
     * @property {number} MEASUREMENT_TYPE_WEIGHT=15 MEASUREMENT_TYPE_WEIGHT value
     * @property {number} MEASUREMENT_TYPE_DISTANCE_CM=16 MEASUREMENT_TYPE_DISTANCE_CM value
     * @property {number} MEASUREMENT_TYPE_SPEED=17 MEASUREMENT_TYPE_SPEED value
     * @property {number} MEASUREMENT_TYPE_RAIN=18 MEASUREMENT_TYPE_RAIN value
     * @property {number} MEASUREMENT_TYPE_GRAIN_EMC=19 MEASUREMENT_TYPE_GRAIN_EMC value
     * @property {number} MEASUREMENT_TYPE_EDGE_RISES=20 MEASUREMENT_TYPE_EDGE_RISES value
     * @property {number} MEASUREMENT_TYPE_EDGE_FALLS=21 MEASUREMENT_TYPE_EDGE_FALLS value
     * @property {number} MEASUREMENT_TYPE_STATE_CHANGES=22 MEASUREMENT_TYPE_STATE_CHANGES value
     * @property {number} MEASUREMENT_TYPE_FULL_SPECTRUM=23 MEASUREMENT_TYPE_FULL_SPECTRUM value
     * @property {number} MEASUREMENT_TYPE_INFRARED=24 MEASUREMENT_TYPE_INFRARED value
     * @property {number} MEASUREMENT_TYPE_LUX=25 MEASUREMENT_TYPE_LUX value
     * @property {number} MEASUREMENT_TYPE_VISIBLE_LIGHT=26 MEASUREMENT_TYPE_VISIBLE_LIGHT value
     * @property {number} MEASUREMENT_TYPE_CFM=29 MEASUREMENT_TYPE_CFM value
     * @property {number} MEASUREMENT_TYPE_CAPACITANCE_GND_FF=27 MEASUREMENT_TYPE_CAPACITANCE_GND_FF value
     * @property {number} MEASUREMENT_TYPE_CAPACITANCE_SELF_FF=28 MEASUREMENT_TYPE_CAPACITANCE_SELF_FF value
     * @property {number} MEASUREMENT_TYPE_DUST_1UG=30 MEASUREMENT_TYPE_DUST_1UG value
     * @property {number} MEASUREMENT_TYPE_DUST_2UG=31 MEASUREMENT_TYPE_DUST_2UG value
     * @property {number} MEASUREMENT_TYPE_DUST_4UG=32 MEASUREMENT_TYPE_DUST_4UG value
     * @property {number} MEASUREMENT_TYPE_DUST_10UG=33 MEASUREMENT_TYPE_DUST_10UG value
     * @property {number} MEASUREMENT_TYPE_VOC_INDEX=34 MEASUREMENT_TYPE_VOC_INDEX value
     * @property {number} MEASUREMENT_TYPE_NOX_INDEX=35 MEASUREMENT_TYPE_NOX_INDEX value
     * @property {number} MEASUREMENT_TYPE_FREQUENCY=36 MEASUREMENT_TYPE_FREQUENCY value
     * @property {number} MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS=37 MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS value
     * @property {number} MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS=38 MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS value
     * @property {number} MEASUREMENT_TYPE_BUSHEL_CABLE=39 MEASUREMENT_TYPE_BUSHEL_CABLE value
     * @property {number} MEASUREMENT_TYPE_BUSHEL_LIDAR=40 MEASUREMENT_TYPE_BUSHEL_LIDAR value
     */
    quack.MeasurementType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "MEASUREMENT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "MEASUREMENT_TYPE_TEMPERATURE"] = 1;
        values[valuesById[2] = "MEASUREMENT_TYPE_BOOLEAN"] = 2;
        values[valuesById[3] = "MEASUREMENT_TYPE_VOLTAGE"] = 3;
        values[valuesById[4] = "MEASUREMENT_TYPE_PERCENT"] = 4;
        values[valuesById[5] = "MEASUREMENT_TYPE_PRESSURE"] = 5;
        values[valuesById[6] = "MEASUREMENT_TYPE_RSSI"] = 6;
        values[valuesById[7] = "MEASUREMENT_TYPE_LIGHT"] = 7;
        values[valuesById[8] = "MEASUREMENT_TYPE_PPM"] = 8;
        values[valuesById[9] = "MEASUREMENT_TYPE_ANALOG"] = 9;
        values[valuesById[10] = "MEASUREMENT_TYPE_ORP"] = 10;
        values[valuesById[11] = "MEASUREMENT_TYPE_PH"] = 11;
        values[valuesById[12] = "MEASUREMENT_TYPE_PPB"] = 12;
        values[valuesById[13] = "MEASUREMENT_TYPE_CONDUCTIVITY"] = 13;
        values[valuesById[14] = "MEASUREMENT_TYPE_CAPACITANCE"] = 14;
        values[valuesById[15] = "MEASUREMENT_TYPE_WEIGHT"] = 15;
        values[valuesById[16] = "MEASUREMENT_TYPE_DISTANCE_CM"] = 16;
        values[valuesById[17] = "MEASUREMENT_TYPE_SPEED"] = 17;
        values[valuesById[18] = "MEASUREMENT_TYPE_RAIN"] = 18;
        values[valuesById[19] = "MEASUREMENT_TYPE_GRAIN_EMC"] = 19;
        values[valuesById[20] = "MEASUREMENT_TYPE_EDGE_RISES"] = 20;
        values[valuesById[21] = "MEASUREMENT_TYPE_EDGE_FALLS"] = 21;
        values[valuesById[22] = "MEASUREMENT_TYPE_STATE_CHANGES"] = 22;
        values[valuesById[23] = "MEASUREMENT_TYPE_FULL_SPECTRUM"] = 23;
        values[valuesById[24] = "MEASUREMENT_TYPE_INFRARED"] = 24;
        values[valuesById[25] = "MEASUREMENT_TYPE_LUX"] = 25;
        values[valuesById[26] = "MEASUREMENT_TYPE_VISIBLE_LIGHT"] = 26;
        values[valuesById[29] = "MEASUREMENT_TYPE_CFM"] = 29;
        values[valuesById[27] = "MEASUREMENT_TYPE_CAPACITANCE_GND_FF"] = 27;
        values[valuesById[28] = "MEASUREMENT_TYPE_CAPACITANCE_SELF_FF"] = 28;
        values[valuesById[30] = "MEASUREMENT_TYPE_DUST_1UG"] = 30;
        values[valuesById[31] = "MEASUREMENT_TYPE_DUST_2UG"] = 31;
        values[valuesById[32] = "MEASUREMENT_TYPE_DUST_4UG"] = 32;
        values[valuesById[33] = "MEASUREMENT_TYPE_DUST_10UG"] = 33;
        values[valuesById[34] = "MEASUREMENT_TYPE_VOC_INDEX"] = 34;
        values[valuesById[35] = "MEASUREMENT_TYPE_NOX_INDEX"] = 35;
        values[valuesById[36] = "MEASUREMENT_TYPE_FREQUENCY"] = 36;
        values[valuesById[37] = "MEASUREMENT_TYPE_SINGLE_ACCELERATION_RMS"] = 37;
        values[valuesById[38] = "MEASUREMENT_TYPE_TOTAL_ACCELERATION_RMS"] = 38;
        values[valuesById[39] = "MEASUREMENT_TYPE_BUSHEL_CABLE"] = 39;
        values[valuesById[40] = "MEASUREMENT_TYPE_BUSHEL_LIDAR"] = 40;
        return values;
    })();

    /**
     * RelationalOperator enum.
     * @name quack.RelationalOperator
     * @enum {string}
     * @property {number} RELATIONAL_OPERATOR_INVALID=0 RELATIONAL_OPERATOR_INVALID value
     * @property {number} RELATIONAL_OPERATOR_EQUAL_TO=1 RELATIONAL_OPERATOR_EQUAL_TO value
     * @property {number} RELATIONAL_OPERATOR_LESS_THAN=2 RELATIONAL_OPERATOR_LESS_THAN value
     * @property {number} RELATIONAL_OPERATOR_GREATER_THAN=3 RELATIONAL_OPERATOR_GREATER_THAN value
     */
    quack.RelationalOperator = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "RELATIONAL_OPERATOR_INVALID"] = 0;
        values[valuesById[1] = "RELATIONAL_OPERATOR_EQUAL_TO"] = 1;
        values[valuesById[2] = "RELATIONAL_OPERATOR_LESS_THAN"] = 2;
        values[valuesById[3] = "RELATIONAL_OPERATOR_GREATER_THAN"] = 3;
        return values;
    })();

    /**
     * InteractionResultType enum.
     * @name quack.InteractionResultType
     * @enum {string}
     * @property {number} INTERACTION_RESULT_TYPE_INVALID=0 INTERACTION_RESULT_TYPE_INVALID value
     * @property {number} INTERACTION_RESULT_TYPE_REPORT=1 INTERACTION_RESULT_TYPE_REPORT value
     * @property {number} INTERACTION_RESULT_TYPE_TOGGLE=2 INTERACTION_RESULT_TYPE_TOGGLE value
     * @property {number} INTERACTION_RESULT_TYPE_RUN=3 INTERACTION_RESULT_TYPE_RUN value
     * @property {number} INTERACTION_RESULT_TYPE_SET=4 INTERACTION_RESULT_TYPE_SET value
     */
    quack.InteractionResultType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "INTERACTION_RESULT_TYPE_INVALID"] = 0;
        values[valuesById[1] = "INTERACTION_RESULT_TYPE_REPORT"] = 1;
        values[valuesById[2] = "INTERACTION_RESULT_TYPE_TOGGLE"] = 2;
        values[valuesById[3] = "INTERACTION_RESULT_TYPE_RUN"] = 3;
        values[valuesById[4] = "INTERACTION_RESULT_TYPE_SET"] = 4;
        return values;
    })();

    quack.InteractionCondition = (function() {

        /**
         * Properties of an InteractionCondition.
         * @memberof quack
         * @interface IInteractionCondition
         * @property {number|null} [measurementType] InteractionCondition measurementType
         * @property {number|null} [comparison] InteractionCondition comparison
         * @property {number|null} [value] InteractionCondition value
         */

        /**
         * Constructs a new InteractionCondition.
         * @memberof quack
         * @classdesc Represents an InteractionCondition.
         * @implements IInteractionCondition
         * @constructor
         * @param {quack.IInteractionCondition=} [properties] Properties to set
         */
        function InteractionCondition(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionCondition measurementType.
         * @member {number} measurementType
         * @memberof quack.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.measurementType = 0;

        /**
         * InteractionCondition comparison.
         * @member {number} comparison
         * @memberof quack.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.comparison = 0;

        /**
         * InteractionCondition value.
         * @member {number} value
         * @memberof quack.InteractionCondition
         * @instance
         */
        InteractionCondition.prototype.value = 0;

        /**
         * Creates a new InteractionCondition instance using the specified properties.
         * @function create
         * @memberof quack.InteractionCondition
         * @static
         * @param {quack.IInteractionCondition=} [properties] Properties to set
         * @returns {quack.InteractionCondition} InteractionCondition instance
         */
        InteractionCondition.create = function create(properties) {
            return new InteractionCondition(properties);
        };

        /**
         * Creates an InteractionCondition message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.InteractionCondition
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.InteractionCondition} InteractionCondition
         */
        InteractionCondition.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.InteractionCondition)
                return object;
            var message = new $root.quack.InteractionCondition();
            if (object.measurementType != null)
                message.measurementType = object.measurementType >>> 0;
            if (object.comparison != null)
                message.comparison = object.comparison >>> 0;
            if (object.value != null)
                message.value = object.value | 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionCondition message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.InteractionCondition
         * @static
         * @param {quack.InteractionCondition} message InteractionCondition
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionCondition.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.measurementType = 0;
                object.comparison = 0;
                object.value = 0;
            }
            if (message.measurementType != null && message.hasOwnProperty("measurementType"))
                object.measurementType = message.measurementType;
            if (message.comparison != null && message.hasOwnProperty("comparison"))
                object.comparison = message.comparison;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            return object;
        };

        /**
         * Converts this InteractionCondition to JSON.
         * @function toJSON
         * @memberof quack.InteractionCondition
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionCondition.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionCondition;
    })();

    quack.InteractionResult = (function() {

        /**
         * Properties of an InteractionResult.
         * @memberof quack
         * @interface IInteractionResult
         * @property {number|null} [type] InteractionResult type
         * @property {number|null} [value] InteractionResult value
         * @property {number|null} [mode] InteractionResult mode
         * @property {number|null} [dutyCycle] InteractionResult dutyCycle
         */

        /**
         * Constructs a new InteractionResult.
         * @memberof quack
         * @classdesc Represents an InteractionResult.
         * @implements IInteractionResult
         * @constructor
         * @param {quack.IInteractionResult=} [properties] Properties to set
         */
        function InteractionResult(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionResult type.
         * @member {number} type
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.type = 0;

        /**
         * InteractionResult value.
         * @member {number} value
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.value = 0;

        /**
         * InteractionResult mode.
         * @member {number} mode
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.mode = 0;

        /**
         * InteractionResult dutyCycle.
         * @member {number} dutyCycle
         * @memberof quack.InteractionResult
         * @instance
         */
        InteractionResult.prototype.dutyCycle = 0;

        /**
         * Creates a new InteractionResult instance using the specified properties.
         * @function create
         * @memberof quack.InteractionResult
         * @static
         * @param {quack.IInteractionResult=} [properties] Properties to set
         * @returns {quack.InteractionResult} InteractionResult instance
         */
        InteractionResult.create = function create(properties) {
            return new InteractionResult(properties);
        };

        /**
         * Creates an InteractionResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.InteractionResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.InteractionResult} InteractionResult
         */
        InteractionResult.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.InteractionResult)
                return object;
            var message = new $root.quack.InteractionResult();
            if (object.type != null)
                message.type = object.type >>> 0;
            if (object.value != null)
                message.value = object.value | 0;
            if (object.mode != null)
                message.mode = object.mode >>> 0;
            if (object.dutyCycle != null)
                message.dutyCycle = object.dutyCycle >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.InteractionResult
         * @static
         * @param {quack.InteractionResult} message InteractionResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = 0;
                object.value = 0;
                object.mode = 0;
                object.dutyCycle = 0;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = message.value;
            if (message.mode != null && message.hasOwnProperty("mode"))
                object.mode = message.mode;
            if (message.dutyCycle != null && message.hasOwnProperty("dutyCycle"))
                object.dutyCycle = message.dutyCycle;
            return object;
        };

        /**
         * Converts this InteractionResult to JSON.
         * @function toJSON
         * @memberof quack.InteractionResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionResult;
    })();

    quack.InteractionSchedule = (function() {

        /**
         * Properties of an InteractionSchedule.
         * @memberof quack
         * @interface IInteractionSchedule
         * @property {number|null} [weekdays] InteractionSchedule weekdays
         * @property {number|null} [timeOfDayStart] InteractionSchedule timeOfDayStart
         * @property {number|null} [timeOfDayEnd] InteractionSchedule timeOfDayEnd
         * @property {number|null} [utcOffset] InteractionSchedule utcOffset
         */

        /**
         * Constructs a new InteractionSchedule.
         * @memberof quack
         * @classdesc Represents an InteractionSchedule.
         * @implements IInteractionSchedule
         * @constructor
         * @param {quack.IInteractionSchedule=} [properties] Properties to set
         */
        function InteractionSchedule(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InteractionSchedule weekdays.
         * @member {number} weekdays
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.weekdays = 0;

        /**
         * InteractionSchedule timeOfDayStart.
         * @member {number} timeOfDayStart
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timeOfDayStart = 0;

        /**
         * InteractionSchedule timeOfDayEnd.
         * @member {number} timeOfDayEnd
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.timeOfDayEnd = 0;

        /**
         * InteractionSchedule utcOffset.
         * @member {number} utcOffset
         * @memberof quack.InteractionSchedule
         * @instance
         */
        InteractionSchedule.prototype.utcOffset = 0;

        /**
         * Creates a new InteractionSchedule instance using the specified properties.
         * @function create
         * @memberof quack.InteractionSchedule
         * @static
         * @param {quack.IInteractionSchedule=} [properties] Properties to set
         * @returns {quack.InteractionSchedule} InteractionSchedule instance
         */
        InteractionSchedule.create = function create(properties) {
            return new InteractionSchedule(properties);
        };

        /**
         * Creates an InteractionSchedule message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.InteractionSchedule
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.InteractionSchedule} InteractionSchedule
         */
        InteractionSchedule.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.InteractionSchedule)
                return object;
            var message = new $root.quack.InteractionSchedule();
            if (object.weekdays != null)
                message.weekdays = object.weekdays >>> 0;
            if (object.timeOfDayStart != null)
                message.timeOfDayStart = object.timeOfDayStart >>> 0;
            if (object.timeOfDayEnd != null)
                message.timeOfDayEnd = object.timeOfDayEnd >>> 0;
            if (object.utcOffset != null)
                message.utcOffset = object.utcOffset | 0;
            return message;
        };

        /**
         * Creates a plain object from an InteractionSchedule message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.InteractionSchedule
         * @static
         * @param {quack.InteractionSchedule} message InteractionSchedule
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InteractionSchedule.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.weekdays = 0;
                object.timeOfDayStart = 0;
                object.timeOfDayEnd = 0;
                object.utcOffset = 0;
            }
            if (message.weekdays != null && message.hasOwnProperty("weekdays"))
                object.weekdays = message.weekdays;
            if (message.timeOfDayStart != null && message.hasOwnProperty("timeOfDayStart"))
                object.timeOfDayStart = message.timeOfDayStart;
            if (message.timeOfDayEnd != null && message.hasOwnProperty("timeOfDayEnd"))
                object.timeOfDayEnd = message.timeOfDayEnd;
            if (message.utcOffset != null && message.hasOwnProperty("utcOffset"))
                object.utcOffset = message.utcOffset;
            return object;
        };

        /**
         * Converts this InteractionSchedule to JSON.
         * @function toJSON
         * @memberof quack.InteractionSchedule
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InteractionSchedule.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InteractionSchedule;
    })();

    quack.Interaction = (function() {

        /**
         * Properties of an Interaction.
         * @memberof quack
         * @interface IInteraction
         * @property {quack.ComponentID|null} [source] Interaction source
         * @property {quack.ComponentID|null} [sink] Interaction sink
         * @property {number|null} [id] Interaction id
         * @property {Array.<quack.InteractionCondition>|null} [conditions] Interaction conditions
         * @property {quack.InteractionResult|null} [result] Interaction result
         * @property {boolean|null} [reports] Interaction reports
         * @property {quack.InteractionSchedule|null} [schedule] Interaction schedule
         * @property {number|null} [priority] Interaction priority
         * @property {number|null} [subtype] Interaction subtype
         */

        /**
         * Constructs a new Interaction.
         * @memberof quack
         * @classdesc Represents an Interaction.
         * @implements IInteraction
         * @constructor
         * @param {quack.IInteraction=} [properties] Properties to set
         */
        function Interaction(properties) {
            this.conditions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Interaction source.
         * @member {quack.ComponentID|null|undefined} source
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.source = null;

        /**
         * Interaction sink.
         * @member {quack.ComponentID|null|undefined} sink
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.sink = null;

        /**
         * Interaction id.
         * @member {number} id
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.id = 0;

        /**
         * Interaction conditions.
         * @member {Array.<quack.InteractionCondition>} conditions
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.conditions = $util.emptyArray;

        /**
         * Interaction result.
         * @member {quack.InteractionResult|null|undefined} result
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.result = null;

        /**
         * Interaction reports.
         * @member {boolean} reports
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.reports = false;

        /**
         * Interaction schedule.
         * @member {quack.InteractionSchedule|null|undefined} schedule
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.schedule = null;

        /**
         * Interaction priority.
         * @member {number} priority
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.priority = 0;

        /**
         * Interaction subtype.
         * @member {number} subtype
         * @memberof quack.Interaction
         * @instance
         */
        Interaction.prototype.subtype = 0;

        /**
         * Creates a new Interaction instance using the specified properties.
         * @function create
         * @memberof quack.Interaction
         * @static
         * @param {quack.IInteraction=} [properties] Properties to set
         * @returns {quack.Interaction} Interaction instance
         */
        Interaction.create = function create(properties) {
            return new Interaction(properties);
        };

        /**
         * Creates an Interaction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Interaction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Interaction} Interaction
         */
        Interaction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Interaction)
                return object;
            var message = new $root.quack.Interaction();
            if (object.source != null) {
                if (typeof object.source !== "object")
                    throw TypeError(".quack.Interaction.source: object expected");
                message.source = $root.quack.ComponentID.fromObject(object.source);
            }
            if (object.sink != null) {
                if (typeof object.sink !== "object")
                    throw TypeError(".quack.Interaction.sink: object expected");
                message.sink = $root.quack.ComponentID.fromObject(object.sink);
            }
            if (object.id != null)
                message.id = object.id >>> 0;
            if (object.conditions) {
                if (!Array.isArray(object.conditions))
                    throw TypeError(".quack.Interaction.conditions: array expected");
                message.conditions = [];
                for (var i = 0; i < object.conditions.length; ++i) {
                    if (typeof object.conditions[i] !== "object")
                        throw TypeError(".quack.Interaction.conditions: object expected");
                    message.conditions[i] = $root.quack.InteractionCondition.fromObject(object.conditions[i]);
                }
            }
            if (object.result != null) {
                if (typeof object.result !== "object")
                    throw TypeError(".quack.Interaction.result: object expected");
                message.result = $root.quack.InteractionResult.fromObject(object.result);
            }
            if (object.reports != null)
                message.reports = Boolean(object.reports);
            if (object.schedule != null) {
                if (typeof object.schedule !== "object")
                    throw TypeError(".quack.Interaction.schedule: object expected");
                message.schedule = $root.quack.InteractionSchedule.fromObject(object.schedule);
            }
            if (object.priority != null)
                message.priority = object.priority >>> 0;
            if (object.subtype != null)
                message.subtype = object.subtype >>> 0;
            return message;
        };

        /**
         * Creates a plain object from an Interaction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Interaction
         * @static
         * @param {quack.Interaction} message Interaction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Interaction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.conditions = [];
            if (options.defaults) {
                object.source = null;
                object.sink = null;
                object.id = 0;
                object.result = null;
                object.reports = false;
                object.schedule = null;
                object.priority = 0;
                object.subtype = 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = $root.quack.ComponentID.toObject(message.source, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = $root.quack.ComponentID.toObject(message.sink, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.conditions && message.conditions.length) {
                object.conditions = [];
                for (var j = 0; j < message.conditions.length; ++j)
                    object.conditions[j] = $root.quack.InteractionCondition.toObject(message.conditions[j], options);
            }
            if (message.result != null && message.hasOwnProperty("result"))
                object.result = $root.quack.InteractionResult.toObject(message.result, options);
            if (message.reports != null && message.hasOwnProperty("reports"))
                object.reports = message.reports;
            if (message.schedule != null && message.hasOwnProperty("schedule"))
                object.schedule = $root.quack.InteractionSchedule.toObject(message.schedule, options);
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = message.priority;
            if (message.subtype != null && message.hasOwnProperty("subtype"))
                object.subtype = message.subtype;
            return object;
        };

        /**
         * Converts this Interaction to JSON.
         * @function toJSON
         * @memberof quack.Interaction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Interaction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Interaction;
    })();

    quack.AddInteraction = (function() {

        /**
         * Properties of an AddInteraction.
         * @memberof quack
         * @interface IAddInteraction
         * @property {quack.Interaction|null} [interaction] AddInteraction interaction
         */

        /**
         * Constructs a new AddInteraction.
         * @memberof quack
         * @classdesc Represents an AddInteraction.
         * @implements IAddInteraction
         * @constructor
         * @param {quack.IAddInteraction=} [properties] Properties to set
         */
        function AddInteraction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddInteraction interaction.
         * @member {quack.Interaction|null|undefined} interaction
         * @memberof quack.AddInteraction
         * @instance
         */
        AddInteraction.prototype.interaction = null;

        /**
         * Creates a new AddInteraction instance using the specified properties.
         * @function create
         * @memberof quack.AddInteraction
         * @static
         * @param {quack.IAddInteraction=} [properties] Properties to set
         * @returns {quack.AddInteraction} AddInteraction instance
         */
        AddInteraction.create = function create(properties) {
            return new AddInteraction(properties);
        };

        /**
         * Creates an AddInteraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddInteraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddInteraction} AddInteraction
         */
        AddInteraction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddInteraction)
                return object;
            var message = new $root.quack.AddInteraction();
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".quack.AddInteraction.interaction: object expected");
                message.interaction = $root.quack.Interaction.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddInteraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddInteraction
         * @static
         * @param {quack.AddInteraction} message AddInteraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddInteraction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.interaction = null;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.quack.Interaction.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this AddInteraction to JSON.
         * @function toJSON
         * @memberof quack.AddInteraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddInteraction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddInteraction;
    })();

    quack.RemoveInteraction = (function() {

        /**
         * Properties of a RemoveInteraction.
         * @memberof quack
         * @interface IRemoveInteraction
         * @property {quack.ComponentID|null} [source] RemoveInteraction source
         * @property {quack.ComponentID|null} [sink] RemoveInteraction sink
         * @property {number|null} [id] RemoveInteraction id
         */

        /**
         * Constructs a new RemoveInteraction.
         * @memberof quack
         * @classdesc Represents a RemoveInteraction.
         * @implements IRemoveInteraction
         * @constructor
         * @param {quack.IRemoveInteraction=} [properties] Properties to set
         */
        function RemoveInteraction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveInteraction source.
         * @member {quack.ComponentID|null|undefined} source
         * @memberof quack.RemoveInteraction
         * @instance
         */
        RemoveInteraction.prototype.source = null;

        /**
         * RemoveInteraction sink.
         * @member {quack.ComponentID|null|undefined} sink
         * @memberof quack.RemoveInteraction
         * @instance
         */
        RemoveInteraction.prototype.sink = null;

        /**
         * RemoveInteraction id.
         * @member {number} id
         * @memberof quack.RemoveInteraction
         * @instance
         */
        RemoveInteraction.prototype.id = 0;

        /**
         * Creates a new RemoveInteraction instance using the specified properties.
         * @function create
         * @memberof quack.RemoveInteraction
         * @static
         * @param {quack.IRemoveInteraction=} [properties] Properties to set
         * @returns {quack.RemoveInteraction} RemoveInteraction instance
         */
        RemoveInteraction.create = function create(properties) {
            return new RemoveInteraction(properties);
        };

        /**
         * Creates a RemoveInteraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.RemoveInteraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.RemoveInteraction} RemoveInteraction
         */
        RemoveInteraction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.RemoveInteraction)
                return object;
            var message = new $root.quack.RemoveInteraction();
            if (object.source != null) {
                if (typeof object.source !== "object")
                    throw TypeError(".quack.RemoveInteraction.source: object expected");
                message.source = $root.quack.ComponentID.fromObject(object.source);
            }
            if (object.sink != null) {
                if (typeof object.sink !== "object")
                    throw TypeError(".quack.RemoveInteraction.sink: object expected");
                message.sink = $root.quack.ComponentID.fromObject(object.sink);
            }
            if (object.id != null)
                message.id = object.id >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a RemoveInteraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.RemoveInteraction
         * @static
         * @param {quack.RemoveInteraction} message RemoveInteraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveInteraction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.source = null;
                object.sink = null;
                object.id = 0;
            }
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = $root.quack.ComponentID.toObject(message.source, options);
            if (message.sink != null && message.hasOwnProperty("sink"))
                object.sink = $root.quack.ComponentID.toObject(message.sink, options);
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this RemoveInteraction to JSON.
         * @function toJSON
         * @memberof quack.RemoveInteraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveInteraction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveInteraction;
    })();

    quack.UpdateInteraction = (function() {

        /**
         * Properties of an UpdateInteraction.
         * @memberof quack
         * @interface IUpdateInteraction
         * @property {quack.Interaction|null} [interaction] UpdateInteraction interaction
         */

        /**
         * Constructs a new UpdateInteraction.
         * @memberof quack
         * @classdesc Represents an UpdateInteraction.
         * @implements IUpdateInteraction
         * @constructor
         * @param {quack.IUpdateInteraction=} [properties] Properties to set
         */
        function UpdateInteraction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateInteraction interaction.
         * @member {quack.Interaction|null|undefined} interaction
         * @memberof quack.UpdateInteraction
         * @instance
         */
        UpdateInteraction.prototype.interaction = null;

        /**
         * Creates a new UpdateInteraction instance using the specified properties.
         * @function create
         * @memberof quack.UpdateInteraction
         * @static
         * @param {quack.IUpdateInteraction=} [properties] Properties to set
         * @returns {quack.UpdateInteraction} UpdateInteraction instance
         */
        UpdateInteraction.create = function create(properties) {
            return new UpdateInteraction(properties);
        };

        /**
         * Creates an UpdateInteraction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateInteraction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateInteraction} UpdateInteraction
         */
        UpdateInteraction.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateInteraction)
                return object;
            var message = new $root.quack.UpdateInteraction();
            if (object.interaction != null) {
                if (typeof object.interaction !== "object")
                    throw TypeError(".quack.UpdateInteraction.interaction: object expected");
                message.interaction = $root.quack.Interaction.fromObject(object.interaction);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateInteraction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateInteraction
         * @static
         * @param {quack.UpdateInteraction} message UpdateInteraction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateInteraction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.interaction = null;
            if (message.interaction != null && message.hasOwnProperty("interaction"))
                object.interaction = $root.quack.Interaction.toObject(message.interaction, options);
            return object;
        };

        /**
         * Converts this UpdateInteraction to JSON.
         * @function toJSON
         * @memberof quack.UpdateInteraction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateInteraction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateInteraction;
    })();

    /**
     * UserPermissions enum.
     * @name quack.UserPermissions
     * @enum {string}
     * @property {number} USER_PERMISSIONS_INVALID=0 USER_PERMISSIONS_INVALID value
     * @property {number} USER_PERMISSIONS_USER=1 USER_PERMISSIONS_USER value
     * @property {number} USER_PERMISSIONS_MASTER=2 USER_PERMISSIONS_MASTER value
     * @property {number} USER_PERMISSIONS_INSTALLER=3 USER_PERMISSIONS_INSTALLER value
     * @property {number} USER_PERMISSIONS_SERIAL=4 USER_PERMISSIONS_SERIAL value
     */
    quack.UserPermissions = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "USER_PERMISSIONS_INVALID"] = 0;
        values[valuesById[1] = "USER_PERMISSIONS_USER"] = 1;
        values[valuesById[2] = "USER_PERMISSIONS_MASTER"] = 2;
        values[valuesById[3] = "USER_PERMISSIONS_INSTALLER"] = 3;
        values[valuesById[4] = "USER_PERMISSIONS_SERIAL"] = 4;
        return values;
    })();

    quack.User = (function() {

        /**
         * Properties of a User.
         * @memberof quack
         * @interface IUser
         * @property {string|null} [id] User id
         * @property {boolean|null} [receivesEvents] User receivesEvents
         * @property {number|null} [permissions] User permissions
         */

        /**
         * Constructs a new User.
         * @memberof quack
         * @classdesc Represents a User.
         * @implements IUser
         * @constructor
         * @param {quack.IUser=} [properties] Properties to set
         */
        function User(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * User id.
         * @member {string} id
         * @memberof quack.User
         * @instance
         */
        User.prototype.id = "";

        /**
         * User receivesEvents.
         * @member {boolean} receivesEvents
         * @memberof quack.User
         * @instance
         */
        User.prototype.receivesEvents = false;

        /**
         * User permissions.
         * @member {number} permissions
         * @memberof quack.User
         * @instance
         */
        User.prototype.permissions = 0;

        /**
         * Creates a new User instance using the specified properties.
         * @function create
         * @memberof quack.User
         * @static
         * @param {quack.IUser=} [properties] Properties to set
         * @returns {quack.User} User instance
         */
        User.create = function create(properties) {
            return new User(properties);
        };

        /**
         * Creates a User message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.User
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.User} User
         */
        User.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.User)
                return object;
            var message = new $root.quack.User();
            if (object.id != null)
                message.id = String(object.id);
            if (object.receivesEvents != null)
                message.receivesEvents = Boolean(object.receivesEvents);
            if (object.permissions != null)
                message.permissions = object.permissions >>> 0;
            return message;
        };

        /**
         * Creates a plain object from a User message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.User
         * @static
         * @param {quack.User} message User
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        User.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.receivesEvents = false;
                object.permissions = 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.receivesEvents != null && message.hasOwnProperty("receivesEvents"))
                object.receivesEvents = message.receivesEvents;
            if (message.permissions != null && message.hasOwnProperty("permissions"))
                object.permissions = message.permissions;
            return object;
        };

        /**
         * Converts this User to JSON.
         * @function toJSON
         * @memberof quack.User
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        User.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return User;
    })();

    quack.AddUser = (function() {

        /**
         * Properties of an AddUser.
         * @memberof quack
         * @interface IAddUser
         * @property {quack.User|null} [user] AddUser user
         */

        /**
         * Constructs a new AddUser.
         * @memberof quack
         * @classdesc Represents an AddUser.
         * @implements IAddUser
         * @constructor
         * @param {quack.IAddUser=} [properties] Properties to set
         */
        function AddUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AddUser user.
         * @member {quack.User|null|undefined} user
         * @memberof quack.AddUser
         * @instance
         */
        AddUser.prototype.user = null;

        /**
         * Creates a new AddUser instance using the specified properties.
         * @function create
         * @memberof quack.AddUser
         * @static
         * @param {quack.IAddUser=} [properties] Properties to set
         * @returns {quack.AddUser} AddUser instance
         */
        AddUser.create = function create(properties) {
            return new AddUser(properties);
        };

        /**
         * Creates an AddUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.AddUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.AddUser} AddUser
         */
        AddUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.AddUser)
                return object;
            var message = new $root.quack.AddUser();
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".quack.AddUser.user: object expected");
                message.user = $root.quack.User.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from an AddUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.AddUser
         * @static
         * @param {quack.AddUser} message AddUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.user = null;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.quack.User.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this AddUser to JSON.
         * @function toJSON
         * @memberof quack.AddUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AddUser;
    })();

    quack.RemoveUser = (function() {

        /**
         * Properties of a RemoveUser.
         * @memberof quack
         * @interface IRemoveUser
         * @property {string|null} [id] RemoveUser id
         */

        /**
         * Constructs a new RemoveUser.
         * @memberof quack
         * @classdesc Represents a RemoveUser.
         * @implements IRemoveUser
         * @constructor
         * @param {quack.IRemoveUser=} [properties] Properties to set
         */
        function RemoveUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RemoveUser id.
         * @member {string} id
         * @memberof quack.RemoveUser
         * @instance
         */
        RemoveUser.prototype.id = "";

        /**
         * Creates a new RemoveUser instance using the specified properties.
         * @function create
         * @memberof quack.RemoveUser
         * @static
         * @param {quack.IRemoveUser=} [properties] Properties to set
         * @returns {quack.RemoveUser} RemoveUser instance
         */
        RemoveUser.create = function create(properties) {
            return new RemoveUser(properties);
        };

        /**
         * Creates a RemoveUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.RemoveUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.RemoveUser} RemoveUser
         */
        RemoveUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.RemoveUser)
                return object;
            var message = new $root.quack.RemoveUser();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a RemoveUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.RemoveUser
         * @static
         * @param {quack.RemoveUser} message RemoveUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RemoveUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this RemoveUser to JSON.
         * @function toJSON
         * @memberof quack.RemoveUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RemoveUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RemoveUser;
    })();

    quack.UpdateUser = (function() {

        /**
         * Properties of an UpdateUser.
         * @memberof quack
         * @interface IUpdateUser
         * @property {string|null} [id] UpdateUser id
         * @property {quack.User|null} [user] UpdateUser user
         */

        /**
         * Constructs a new UpdateUser.
         * @memberof quack
         * @classdesc Represents an UpdateUser.
         * @implements IUpdateUser
         * @constructor
         * @param {quack.IUpdateUser=} [properties] Properties to set
         */
        function UpdateUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UpdateUser id.
         * @member {string} id
         * @memberof quack.UpdateUser
         * @instance
         */
        UpdateUser.prototype.id = "";

        /**
         * UpdateUser user.
         * @member {quack.User|null|undefined} user
         * @memberof quack.UpdateUser
         * @instance
         */
        UpdateUser.prototype.user = null;

        /**
         * Creates a new UpdateUser instance using the specified properties.
         * @function create
         * @memberof quack.UpdateUser
         * @static
         * @param {quack.IUpdateUser=} [properties] Properties to set
         * @returns {quack.UpdateUser} UpdateUser instance
         */
        UpdateUser.create = function create(properties) {
            return new UpdateUser(properties);
        };

        /**
         * Creates an UpdateUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.UpdateUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.UpdateUser} UpdateUser
         */
        UpdateUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.UpdateUser)
                return object;
            var message = new $root.quack.UpdateUser();
            if (object.id != null)
                message.id = String(object.id);
            if (object.user != null) {
                if (typeof object.user !== "object")
                    throw TypeError(".quack.UpdateUser.user: object expected");
                message.user = $root.quack.User.fromObject(object.user);
            }
            return message;
        };

        /**
         * Creates a plain object from an UpdateUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.UpdateUser
         * @static
         * @param {quack.UpdateUser} message UpdateUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.user = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.user != null && message.hasOwnProperty("user"))
                object.user = $root.quack.User.toObject(message.user, options);
            return object;
        };

        /**
         * Converts this UpdateUser to JSON.
         * @function toJSON
         * @memberof quack.UpdateUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UpdateUser;
    })();

    quack.GetUser = (function() {

        /**
         * Properties of a GetUser.
         * @memberof quack
         * @interface IGetUser
         * @property {string|null} [id] GetUser id
         */

        /**
         * Constructs a new GetUser.
         * @memberof quack
         * @classdesc Represents a GetUser.
         * @implements IGetUser
         * @constructor
         * @param {quack.IGetUser=} [properties] Properties to set
         */
        function GetUser(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GetUser id.
         * @member {string} id
         * @memberof quack.GetUser
         * @instance
         */
        GetUser.prototype.id = "";

        /**
         * Creates a new GetUser instance using the specified properties.
         * @function create
         * @memberof quack.GetUser
         * @static
         * @param {quack.IGetUser=} [properties] Properties to set
         * @returns {quack.GetUser} GetUser instance
         */
        GetUser.create = function create(properties) {
            return new GetUser(properties);
        };

        /**
         * Creates a GetUser message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.GetUser
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.GetUser} GetUser
         */
        GetUser.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.GetUser)
                return object;
            var message = new $root.quack.GetUser();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a GetUser message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.GetUser
         * @static
         * @param {quack.GetUser} message GetUser
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUser.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this GetUser to JSON.
         * @function toJSON
         * @memberof quack.GetUser
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUser.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GetUser;
    })();

    quack.Quack = (function() {

        /**
         * Properties of a Quack.
         * @memberof quack
         * @interface IQuack
         * @property {Uint8Array|null} [deviceId] Quack deviceId
         * @property {number|null} [count] Quack count
         * @property {boolean|null} [queued] Quack queued
         * @property {quack.Unknown|null} [unknown] Quack unknown
         * @property {quack.Ack|null} [ack] Quack ack
         * @property {quack.Nack|null} [nack] Quack nack
         * @property {quack.Check|null} [check] Quack check
         * @property {quack.UpdateDevice|null} [updateDevice] Quack updateDevice
         * @property {quack.Firmware|null} [firmware] Quack firmware
         * @property {quack.SyncTime|null} [syncTime] Quack syncTime
         * @property {quack.Error|null} [error] Quack error
         * @property {quack.Clear|null} [clear] Quack clear
         * @property {quack.Status|null} [status] Quack status
         * @property {quack.Connect|null} [connect] Quack connect
         * @property {quack.AddComponent|null} [addComponent] Quack addComponent
         * @property {quack.RemoveComponent|null} [removeComponent] Quack removeComponent
         * @property {quack.UpdateComponent|null} [updateComponent] Quack updateComponent
         * @property {quack.UpdateVirtualComponent|null} [updateVComponent] Quack updateVComponent
         * @property {quack.AddInteraction|null} [addInteraction] Quack addInteraction
         * @property {quack.RemoveInteraction|null} [removeInteraction] Quack removeInteraction
         * @property {quack.UpdateInteraction|null} [updateInteraction] Quack updateInteraction
         * @property {quack.GetMeasurement|null} [getMeasurement] Quack getMeasurement
         * @property {quack.Measurement|null} [measurement] Quack measurement
         * @property {quack.VirtualMeasurement|null} [vMeasurement] Quack vMeasurement
         * @property {quack.AddUser|null} [addUser] Quack addUser
         * @property {quack.RemoveUser|null} [removeUser] Quack removeUser
         * @property {quack.UpdateUser|null} [updateUser] Quack updateUser
         */

        /**
         * Constructs a new Quack.
         * @memberof quack
         * @classdesc Represents a Quack.
         * @implements IQuack
         * @constructor
         * @param {quack.IQuack=} [properties] Properties to set
         */
        function Quack(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Quack deviceId.
         * @member {Uint8Array} deviceId
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.deviceId = $util.newBuffer([]);

        /**
         * Quack count.
         * @member {number} count
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.count = 0;

        /**
         * Quack queued.
         * @member {boolean} queued
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.queued = false;

        /**
         * Quack unknown.
         * @member {quack.Unknown|null|undefined} unknown
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.unknown = null;

        /**
         * Quack ack.
         * @member {quack.Ack|null|undefined} ack
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.ack = null;

        /**
         * Quack nack.
         * @member {quack.Nack|null|undefined} nack
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.nack = null;

        /**
         * Quack check.
         * @member {quack.Check|null|undefined} check
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.check = null;

        /**
         * Quack updateDevice.
         * @member {quack.UpdateDevice|null|undefined} updateDevice
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateDevice = null;

        /**
         * Quack firmware.
         * @member {quack.Firmware|null|undefined} firmware
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.firmware = null;

        /**
         * Quack syncTime.
         * @member {quack.SyncTime|null|undefined} syncTime
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.syncTime = null;

        /**
         * Quack error.
         * @member {quack.Error|null|undefined} error
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.error = null;

        /**
         * Quack clear.
         * @member {quack.Clear|null|undefined} clear
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.clear = null;

        /**
         * Quack status.
         * @member {quack.Status|null|undefined} status
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.status = null;

        /**
         * Quack connect.
         * @member {quack.Connect|null|undefined} connect
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.connect = null;

        /**
         * Quack addComponent.
         * @member {quack.AddComponent|null|undefined} addComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.addComponent = null;

        /**
         * Quack removeComponent.
         * @member {quack.RemoveComponent|null|undefined} removeComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.removeComponent = null;

        /**
         * Quack updateComponent.
         * @member {quack.UpdateComponent|null|undefined} updateComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateComponent = null;

        /**
         * Quack updateVComponent.
         * @member {quack.UpdateVirtualComponent|null|undefined} updateVComponent
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateVComponent = null;

        /**
         * Quack addInteraction.
         * @member {quack.AddInteraction|null|undefined} addInteraction
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.addInteraction = null;

        /**
         * Quack removeInteraction.
         * @member {quack.RemoveInteraction|null|undefined} removeInteraction
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.removeInteraction = null;

        /**
         * Quack updateInteraction.
         * @member {quack.UpdateInteraction|null|undefined} updateInteraction
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateInteraction = null;

        /**
         * Quack getMeasurement.
         * @member {quack.GetMeasurement|null|undefined} getMeasurement
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.getMeasurement = null;

        /**
         * Quack measurement.
         * @member {quack.Measurement|null|undefined} measurement
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.measurement = null;

        /**
         * Quack vMeasurement.
         * @member {quack.VirtualMeasurement|null|undefined} vMeasurement
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.vMeasurement = null;

        /**
         * Quack addUser.
         * @member {quack.AddUser|null|undefined} addUser
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.addUser = null;

        /**
         * Quack removeUser.
         * @member {quack.RemoveUser|null|undefined} removeUser
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.removeUser = null;

        /**
         * Quack updateUser.
         * @member {quack.UpdateUser|null|undefined} updateUser
         * @memberof quack.Quack
         * @instance
         */
        Quack.prototype.updateUser = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Quack payload.
         * @member {"unknown"|"ack"|"nack"|"check"|"updateDevice"|"firmware"|"syncTime"|"error"|"clear"|"status"|"connect"|"addComponent"|"removeComponent"|"updateComponent"|"updateVComponent"|"addInteraction"|"removeInteraction"|"updateInteraction"|"getMeasurement"|"measurement"|"vMeasurement"|"addUser"|"removeUser"|"updateUser"|undefined} payload
         * @memberof quack.Quack
         * @instance
         */
        Object.defineProperty(Quack.prototype, "payload", {
            get: $util.oneOfGetter($oneOfFields = ["unknown", "ack", "nack", "check", "updateDevice", "firmware", "syncTime", "error", "clear", "status", "connect", "addComponent", "removeComponent", "updateComponent", "updateVComponent", "addInteraction", "removeInteraction", "updateInteraction", "getMeasurement", "measurement", "vMeasurement", "addUser", "removeUser", "updateUser"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Quack instance using the specified properties.
         * @function create
         * @memberof quack.Quack
         * @static
         * @param {quack.IQuack=} [properties] Properties to set
         * @returns {quack.Quack} Quack instance
         */
        Quack.create = function create(properties) {
            return new Quack(properties);
        };

        /**
         * Creates a Quack message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Quack
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Quack} Quack
         */
        Quack.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Quack)
                return object;
            var message = new $root.quack.Quack();
            if (object.deviceId != null)
                if (typeof object.deviceId === "string")
                    $util.base64.decode(object.deviceId, message.deviceId = $util.newBuffer($util.base64.length(object.deviceId)), 0);
                else if (object.deviceId.length)
                    message.deviceId = object.deviceId;
            if (object.count != null)
                message.count = object.count >>> 0;
            if (object.queued != null)
                message.queued = Boolean(object.queued);
            if (object.unknown != null) {
                if (typeof object.unknown !== "object")
                    throw TypeError(".quack.Quack.unknown: object expected");
                message.unknown = $root.quack.Unknown.fromObject(object.unknown);
            }
            if (object.ack != null) {
                if (typeof object.ack !== "object")
                    throw TypeError(".quack.Quack.ack: object expected");
                message.ack = $root.quack.Ack.fromObject(object.ack);
            }
            if (object.nack != null) {
                if (typeof object.nack !== "object")
                    throw TypeError(".quack.Quack.nack: object expected");
                message.nack = $root.quack.Nack.fromObject(object.nack);
            }
            if (object.check != null) {
                if (typeof object.check !== "object")
                    throw TypeError(".quack.Quack.check: object expected");
                message.check = $root.quack.Check.fromObject(object.check);
            }
            if (object.updateDevice != null) {
                if (typeof object.updateDevice !== "object")
                    throw TypeError(".quack.Quack.updateDevice: object expected");
                message.updateDevice = $root.quack.UpdateDevice.fromObject(object.updateDevice);
            }
            if (object.firmware != null) {
                if (typeof object.firmware !== "object")
                    throw TypeError(".quack.Quack.firmware: object expected");
                message.firmware = $root.quack.Firmware.fromObject(object.firmware);
            }
            if (object.syncTime != null) {
                if (typeof object.syncTime !== "object")
                    throw TypeError(".quack.Quack.syncTime: object expected");
                message.syncTime = $root.quack.SyncTime.fromObject(object.syncTime);
            }
            if (object.error != null) {
                if (typeof object.error !== "object")
                    throw TypeError(".quack.Quack.error: object expected");
                message.error = $root.quack.Error.fromObject(object.error);
            }
            if (object.clear != null) {
                if (typeof object.clear !== "object")
                    throw TypeError(".quack.Quack.clear: object expected");
                message.clear = $root.quack.Clear.fromObject(object.clear);
            }
            if (object.status != null) {
                if (typeof object.status !== "object")
                    throw TypeError(".quack.Quack.status: object expected");
                message.status = $root.quack.Status.fromObject(object.status);
            }
            if (object.connect != null) {
                if (typeof object.connect !== "object")
                    throw TypeError(".quack.Quack.connect: object expected");
                message.connect = $root.quack.Connect.fromObject(object.connect);
            }
            if (object.addComponent != null) {
                if (typeof object.addComponent !== "object")
                    throw TypeError(".quack.Quack.addComponent: object expected");
                message.addComponent = $root.quack.AddComponent.fromObject(object.addComponent);
            }
            if (object.removeComponent != null) {
                if (typeof object.removeComponent !== "object")
                    throw TypeError(".quack.Quack.removeComponent: object expected");
                message.removeComponent = $root.quack.RemoveComponent.fromObject(object.removeComponent);
            }
            if (object.updateComponent != null) {
                if (typeof object.updateComponent !== "object")
                    throw TypeError(".quack.Quack.updateComponent: object expected");
                message.updateComponent = $root.quack.UpdateComponent.fromObject(object.updateComponent);
            }
            if (object.updateVComponent != null) {
                if (typeof object.updateVComponent !== "object")
                    throw TypeError(".quack.Quack.updateVComponent: object expected");
                message.updateVComponent = $root.quack.UpdateVirtualComponent.fromObject(object.updateVComponent);
            }
            if (object.addInteraction != null) {
                if (typeof object.addInteraction !== "object")
                    throw TypeError(".quack.Quack.addInteraction: object expected");
                message.addInteraction = $root.quack.AddInteraction.fromObject(object.addInteraction);
            }
            if (object.removeInteraction != null) {
                if (typeof object.removeInteraction !== "object")
                    throw TypeError(".quack.Quack.removeInteraction: object expected");
                message.removeInteraction = $root.quack.RemoveInteraction.fromObject(object.removeInteraction);
            }
            if (object.updateInteraction != null) {
                if (typeof object.updateInteraction !== "object")
                    throw TypeError(".quack.Quack.updateInteraction: object expected");
                message.updateInteraction = $root.quack.UpdateInteraction.fromObject(object.updateInteraction);
            }
            if (object.getMeasurement != null) {
                if (typeof object.getMeasurement !== "object")
                    throw TypeError(".quack.Quack.getMeasurement: object expected");
                message.getMeasurement = $root.quack.GetMeasurement.fromObject(object.getMeasurement);
            }
            if (object.measurement != null) {
                if (typeof object.measurement !== "object")
                    throw TypeError(".quack.Quack.measurement: object expected");
                message.measurement = $root.quack.Measurement.fromObject(object.measurement);
            }
            if (object.vMeasurement != null) {
                if (typeof object.vMeasurement !== "object")
                    throw TypeError(".quack.Quack.vMeasurement: object expected");
                message.vMeasurement = $root.quack.VirtualMeasurement.fromObject(object.vMeasurement);
            }
            if (object.addUser != null) {
                if (typeof object.addUser !== "object")
                    throw TypeError(".quack.Quack.addUser: object expected");
                message.addUser = $root.quack.AddUser.fromObject(object.addUser);
            }
            if (object.removeUser != null) {
                if (typeof object.removeUser !== "object")
                    throw TypeError(".quack.Quack.removeUser: object expected");
                message.removeUser = $root.quack.RemoveUser.fromObject(object.removeUser);
            }
            if (object.updateUser != null) {
                if (typeof object.updateUser !== "object")
                    throw TypeError(".quack.Quack.updateUser: object expected");
                message.updateUser = $root.quack.UpdateUser.fromObject(object.updateUser);
            }
            return message;
        };

        /**
         * Creates a plain object from a Quack message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Quack
         * @static
         * @param {quack.Quack} message Quack
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quack.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.deviceId = "";
                else {
                    object.deviceId = [];
                    if (options.bytes !== Array)
                        object.deviceId = $util.newBuffer(object.deviceId);
                }
                object.count = 0;
                object.queued = false;
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = options.bytes === String ? $util.base64.encode(message.deviceId, 0, message.deviceId.length) : options.bytes === Array ? Array.prototype.slice.call(message.deviceId) : message.deviceId;
            if (message.count != null && message.hasOwnProperty("count"))
                object.count = message.count;
            if (message.queued != null && message.hasOwnProperty("queued"))
                object.queued = message.queued;
            if (message.unknown != null && message.hasOwnProperty("unknown")) {
                object.unknown = $root.quack.Unknown.toObject(message.unknown, options);
                if (options.oneofs)
                    object.payload = "unknown";
            }
            if (message.ack != null && message.hasOwnProperty("ack")) {
                object.ack = $root.quack.Ack.toObject(message.ack, options);
                if (options.oneofs)
                    object.payload = "ack";
            }
            if (message.nack != null && message.hasOwnProperty("nack")) {
                object.nack = $root.quack.Nack.toObject(message.nack, options);
                if (options.oneofs)
                    object.payload = "nack";
            }
            if (message.check != null && message.hasOwnProperty("check")) {
                object.check = $root.quack.Check.toObject(message.check, options);
                if (options.oneofs)
                    object.payload = "check";
            }
            if (message.updateDevice != null && message.hasOwnProperty("updateDevice")) {
                object.updateDevice = $root.quack.UpdateDevice.toObject(message.updateDevice, options);
                if (options.oneofs)
                    object.payload = "updateDevice";
            }
            if (message.firmware != null && message.hasOwnProperty("firmware")) {
                object.firmware = $root.quack.Firmware.toObject(message.firmware, options);
                if (options.oneofs)
                    object.payload = "firmware";
            }
            if (message.syncTime != null && message.hasOwnProperty("syncTime")) {
                object.syncTime = $root.quack.SyncTime.toObject(message.syncTime, options);
                if (options.oneofs)
                    object.payload = "syncTime";
            }
            if (message.error != null && message.hasOwnProperty("error")) {
                object.error = $root.quack.Error.toObject(message.error, options);
                if (options.oneofs)
                    object.payload = "error";
            }
            if (message.clear != null && message.hasOwnProperty("clear")) {
                object.clear = $root.quack.Clear.toObject(message.clear, options);
                if (options.oneofs)
                    object.payload = "clear";
            }
            if (message.status != null && message.hasOwnProperty("status")) {
                object.status = $root.quack.Status.toObject(message.status, options);
                if (options.oneofs)
                    object.payload = "status";
            }
            if (message.connect != null && message.hasOwnProperty("connect")) {
                object.connect = $root.quack.Connect.toObject(message.connect, options);
                if (options.oneofs)
                    object.payload = "connect";
            }
            if (message.addComponent != null && message.hasOwnProperty("addComponent")) {
                object.addComponent = $root.quack.AddComponent.toObject(message.addComponent, options);
                if (options.oneofs)
                    object.payload = "addComponent";
            }
            if (message.removeComponent != null && message.hasOwnProperty("removeComponent")) {
                object.removeComponent = $root.quack.RemoveComponent.toObject(message.removeComponent, options);
                if (options.oneofs)
                    object.payload = "removeComponent";
            }
            if (message.updateComponent != null && message.hasOwnProperty("updateComponent")) {
                object.updateComponent = $root.quack.UpdateComponent.toObject(message.updateComponent, options);
                if (options.oneofs)
                    object.payload = "updateComponent";
            }
            if (message.updateVComponent != null && message.hasOwnProperty("updateVComponent")) {
                object.updateVComponent = $root.quack.UpdateVirtualComponent.toObject(message.updateVComponent, options);
                if (options.oneofs)
                    object.payload = "updateVComponent";
            }
            if (message.addInteraction != null && message.hasOwnProperty("addInteraction")) {
                object.addInteraction = $root.quack.AddInteraction.toObject(message.addInteraction, options);
                if (options.oneofs)
                    object.payload = "addInteraction";
            }
            if (message.removeInteraction != null && message.hasOwnProperty("removeInteraction")) {
                object.removeInteraction = $root.quack.RemoveInteraction.toObject(message.removeInteraction, options);
                if (options.oneofs)
                    object.payload = "removeInteraction";
            }
            if (message.updateInteraction != null && message.hasOwnProperty("updateInteraction")) {
                object.updateInteraction = $root.quack.UpdateInteraction.toObject(message.updateInteraction, options);
                if (options.oneofs)
                    object.payload = "updateInteraction";
            }
            if (message.getMeasurement != null && message.hasOwnProperty("getMeasurement")) {
                object.getMeasurement = $root.quack.GetMeasurement.toObject(message.getMeasurement, options);
                if (options.oneofs)
                    object.payload = "getMeasurement";
            }
            if (message.measurement != null && message.hasOwnProperty("measurement")) {
                object.measurement = $root.quack.Measurement.toObject(message.measurement, options);
                if (options.oneofs)
                    object.payload = "measurement";
            }
            if (message.vMeasurement != null && message.hasOwnProperty("vMeasurement")) {
                object.vMeasurement = $root.quack.VirtualMeasurement.toObject(message.vMeasurement, options);
                if (options.oneofs)
                    object.payload = "vMeasurement";
            }
            if (message.addUser != null && message.hasOwnProperty("addUser")) {
                object.addUser = $root.quack.AddUser.toObject(message.addUser, options);
                if (options.oneofs)
                    object.payload = "addUser";
            }
            if (message.removeUser != null && message.hasOwnProperty("removeUser")) {
                object.removeUser = $root.quack.RemoveUser.toObject(message.removeUser, options);
                if (options.oneofs)
                    object.payload = "removeUser";
            }
            if (message.updateUser != null && message.hasOwnProperty("updateUser")) {
                object.updateUser = $root.quack.UpdateUser.toObject(message.updateUser, options);
                if (options.oneofs)
                    object.payload = "updateUser";
            }
            return object;
        };

        /**
         * Converts this Quack to JSON.
         * @function toJSON
         * @memberof quack.Quack
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quack.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Quack;
    })();

    quack.Quacks = (function() {

        /**
         * Properties of a Quacks.
         * @memberof quack
         * @interface IQuacks
         * @property {Array.<quack.Quack>|null} [quacks] Quacks quacks
         */

        /**
         * Constructs a new Quacks.
         * @memberof quack
         * @classdesc Represents a Quacks.
         * @implements IQuacks
         * @constructor
         * @param {quack.IQuacks=} [properties] Properties to set
         */
        function Quacks(properties) {
            this.quacks = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Quacks quacks.
         * @member {Array.<quack.Quack>} quacks
         * @memberof quack.Quacks
         * @instance
         */
        Quacks.prototype.quacks = $util.emptyArray;

        /**
         * Creates a new Quacks instance using the specified properties.
         * @function create
         * @memberof quack.Quacks
         * @static
         * @param {quack.IQuacks=} [properties] Properties to set
         * @returns {quack.Quacks} Quacks instance
         */
        Quacks.create = function create(properties) {
            return new Quacks(properties);
        };

        /**
         * Creates a Quacks message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof quack.Quacks
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {quack.Quacks} Quacks
         */
        Quacks.fromObject = function fromObject(object) {
            if (object instanceof $root.quack.Quacks)
                return object;
            var message = new $root.quack.Quacks();
            if (object.quacks) {
                if (!Array.isArray(object.quacks))
                    throw TypeError(".quack.Quacks.quacks: array expected");
                message.quacks = [];
                for (var i = 0; i < object.quacks.length; ++i) {
                    if (typeof object.quacks[i] !== "object")
                        throw TypeError(".quack.Quacks.quacks: object expected");
                    message.quacks[i] = $root.quack.Quack.fromObject(object.quacks[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Quacks message. Also converts values to other types if specified.
         * @function toObject
         * @memberof quack.Quacks
         * @static
         * @param {quack.Quacks} message Quacks
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Quacks.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.quacks = [];
            if (message.quacks && message.quacks.length) {
                object.quacks = [];
                for (var j = 0; j < message.quacks.length; ++j)
                    object.quacks[j] = $root.quack.Quack.toObject(message.quacks[j], options);
            }
            return object;
        };

        /**
         * Converts this Quacks to JSON.
         * @function toJSON
         * @memberof quack.Quacks
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Quacks.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Quacks;
    })();

    return quack;
})();

module.exports = $root;
